var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvanceCrTlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 557,
    height: 194,
    viewBox: "0 0 557 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.155 73.5497H246.141L259.077 104.217H255.82L252.473 96.0753H236.19L232.752 104.217H229.767L243.155 73.5497ZM244.512 76.6255L237.366 93.4518H251.478L244.512 76.6255Z",
    fill: "#262262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.058 73.5497H272.556C275.18 73.5497 277.441 73.9116 279.341 74.5448C281.15 75.1781 282.688 75.9922 283.955 77.0778C285.221 78.0729 286.126 79.249 286.85 80.425C287.573 81.6915 288.116 82.8675 288.388 83.9531C288.659 85.0387 288.93 86.1242 289.021 87.0289C289.111 87.9335 289.111 88.5668 289.111 88.9286C289.111 89.2905 289.111 89.9237 289.021 90.8284C288.93 91.733 288.749 92.7281 288.388 93.9041C288.026 94.9897 287.573 96.1658 286.85 97.4323C286.126 98.6987 285.131 99.7843 283.955 100.779C282.688 101.775 281.15 102.589 279.341 103.312C277.532 103.946 275.27 104.308 272.556 104.308H263.058V73.5497ZM265.862 101.594H271.742C273.732 101.594 275.632 101.322 277.441 100.87C279.16 100.327 280.698 99.6034 282.055 98.5178C283.322 97.5227 284.407 96.1658 285.131 94.5374C285.855 92.909 286.216 91.0093 286.216 88.8382C286.216 86.667 285.855 84.7673 285.131 83.1389C284.407 81.5106 283.322 80.2441 282.055 79.1585C280.789 78.0729 279.251 77.3492 277.441 76.8064C275.723 76.2636 273.823 76.0827 271.742 76.0827H265.862V101.594Z",
    fill: "#262262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.192 73.5497H294.268L304.128 100.508L314.079 73.5497H317.155L305.485 104.217H302.59L291.192 73.5497Z",
    fill: "#262262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.282 73.5497H331.267L344.204 104.217H341.038L337.69 96.0753H321.407L317.969 104.217H314.984L328.282 73.5497ZM329.549 76.6255L322.402 93.4518H336.514L329.549 76.6255Z",
    fill: "#262262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.546 73.5497H352.255L370.981 100.418H371.071V73.5497H373.966V104.217H370.257L351.531 77.3492H351.441V104.217H348.546V73.5497Z",
    fill: "#262262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.529 99.4225C406.081 101.413 404.362 102.86 402.372 103.674C400.472 104.579 398.301 104.941 396.13 104.941C393.778 104.941 391.607 104.579 389.707 103.765C387.717 102.951 386.089 101.865 384.732 100.418C383.375 98.9701 382.289 97.2513 381.475 95.2611C380.661 93.2709 380.299 91.0998 380.299 88.7477C380.299 86.3956 380.661 84.2245 381.475 82.3247C382.289 80.3345 383.375 78.7062 384.732 77.2587C386.089 75.8113 387.807 74.7257 389.707 73.9116C391.697 73.0974 393.778 72.7355 396.13 72.7355C398.211 72.7355 400.11 73.0974 401.92 73.8211C403.729 74.5448 405.267 75.8113 406.624 77.5301L404.272 79.5203C403.277 78.0729 402.101 76.9873 400.653 76.3541C399.206 75.7209 397.668 75.359 396.04 75.359C394.049 75.359 392.24 75.7209 390.612 76.3541C388.983 77.0778 387.626 77.9825 386.541 79.249C385.455 80.425 384.551 81.8724 383.917 83.5008C383.284 85.1291 383.013 86.9384 383.013 88.8382C383.013 90.7379 383.284 92.5472 383.917 94.1755C384.551 95.8039 385.365 97.2513 386.541 98.4273C387.626 99.6034 389.074 100.598 390.612 101.322C392.24 102.046 394.049 102.317 396.04 102.317C396.854 102.317 397.668 102.227 398.482 102.046C399.296 101.865 400.11 101.594 400.925 101.141C401.739 100.779 402.463 100.237 403.186 99.6939C403.91 99.0606 404.543 98.4273 405.086 97.5227L407.529 99.4225Z",
    fill: "#262262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.775 73.5497H431.501V76.1732H415.58V87.1193H430.506V89.7428H415.58V101.684H432.225V104.308H412.775V73.5497Z",
    fill: "#262262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.731 80.6963C457.646 79.5203 456.47 78.7061 455.475 78.2538C454.389 77.892 453.394 77.6206 452.308 77.6206C450.68 77.6206 449.323 77.892 447.966 78.4347C446.7 78.9775 445.614 79.7917 444.619 80.7868C443.714 81.7819 442.991 82.9579 442.448 84.3149C441.905 85.6719 441.724 87.1193 441.724 88.5667C441.724 90.1951 441.995 91.733 442.448 93.0899C442.991 94.4469 443.624 95.7134 444.619 96.7085C445.524 97.7036 446.609 98.5178 447.966 99.0606C449.233 99.6033 450.68 99.9652 452.308 99.9652C453.575 99.9652 454.751 99.6938 455.927 99.0606C457.103 98.4273 458.188 97.5227 459.184 96.2562L463.707 99.4224C462.35 101.322 460.631 102.679 458.641 103.584C456.651 104.488 454.479 104.85 452.308 104.85C449.956 104.85 447.785 104.488 445.795 103.674C443.805 102.951 442.086 101.865 440.638 100.418C439.191 98.9701 438.105 97.3417 437.291 95.3515C436.477 93.3613 436.115 91.1902 436.115 88.8381C436.115 86.3956 436.477 84.134 437.291 82.1438C438.105 80.1536 439.191 78.4347 440.638 76.9873C442.086 75.5399 443.805 74.4543 445.795 73.7306C447.785 73.0069 449.956 72.5546 452.308 72.5546C454.389 72.5546 456.289 72.9164 458.098 73.6401C459.907 74.3639 461.536 75.6303 463.074 77.3492L458.731 80.6963Z",
    fill: "#27AAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.416 73.5497H478.091C479.538 73.5497 480.986 73.7306 482.343 74.002C483.7 74.2734 484.966 74.7258 485.961 75.4495C487.047 76.0827 487.861 76.9874 488.494 78.1634C489.127 79.249 489.489 80.6964 489.489 82.4152C489.489 84.6768 488.856 86.4861 487.68 88.024C486.413 89.5619 484.695 90.4665 482.433 90.7379L490.575 104.308H483.971L476.824 91.2807H472.844V104.308H467.416V73.5497ZM477.096 86.4861C477.91 86.4861 478.634 86.4861 479.448 86.3956C480.262 86.3052 480.986 86.1242 481.619 85.8528C482.252 85.5815 482.795 85.1291 483.157 84.5863C483.519 84.0436 483.79 83.2294 483.79 82.2343C483.79 81.3296 483.609 80.6059 483.247 80.0631C482.885 79.5204 482.343 79.068 481.8 78.7966C481.167 78.5252 480.533 78.3443 479.81 78.2539C479.086 78.1634 478.362 78.1634 477.638 78.1634H472.934V86.4861H477.096Z",
    fill: "#27AAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.164 78.4348H490.756V73.4592H515V78.4348H505.592V104.217H500.164V78.4348Z",
    fill: "#27AAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.082 21.2614C184.082 21.4424 183.901 21.6233 183.72 21.6233C183.539 21.6233 183.358 21.4424 183.358 21.2614C183.358 21.0805 183.539 20.8996 183.72 20.8996C183.992 20.8996 184.082 20.99 184.082 21.2614Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.253 20.6282C186.253 20.8091 186.072 20.99 185.891 20.99C185.71 20.99 185.53 20.8091 185.53 20.6282C185.53 20.4473 185.71 20.2663 185.891 20.2663C186.072 20.1759 186.253 20.3568 186.253 20.6282Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.058 21.0805C189.058 21.171 188.967 21.2614 188.877 21.2614C188.786 21.2614 188.696 21.171 188.696 21.0805C188.696 20.99 188.786 20.8996 188.877 20.8996C188.967 20.8091 189.058 20.8996 189.058 21.0805Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.053 21.4423C190.103 21.4423 190.143 21.4018 190.143 21.3519C190.143 21.3019 190.103 21.2614 190.053 21.2614C190.003 21.2614 189.962 21.3019 189.962 21.3519C189.962 21.4018 190.003 21.4423 190.053 21.4423Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.048 23.5231C191.048 23.6135 190.957 23.6135 190.957 23.6135C190.867 23.6135 190.867 23.5231 190.867 23.5231C190.867 23.4326 190.957 23.4326 190.957 23.4326C190.957 23.4326 191.048 23.4326 191.048 23.5231Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.31 29.2223C193.31 29.3128 193.219 29.3128 193.219 29.3128C193.129 29.3128 193.129 29.2223 193.129 29.2223C193.129 29.1318 193.219 29.1318 193.219 29.1318C193.31 29.1318 193.31 29.2223 193.31 29.2223Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.129 25.6037C193.129 25.7846 193.038 25.8751 192.857 25.8751C192.676 25.8751 192.586 25.7846 192.586 25.6037C192.586 25.4228 192.676 25.3323 192.857 25.3323C193.038 25.3323 193.129 25.4228 193.129 25.6037Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.586 29.6746C192.636 29.6746 192.676 29.6341 192.676 29.5841C192.676 29.5342 192.636 29.4937 192.586 29.4937C192.536 29.4937 192.495 29.5342 192.495 29.5841C192.495 29.6341 192.536 29.6746 192.586 29.6746Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.406 21.5328C192.406 21.5328 192.314 21.6239 192.406 21.5328C192.314 21.6239 192.314 21.5328 192.314 21.5328C192.314 21.5328 192.314 21.5328 192.406 21.5328C192.314 21.5328 192.406 21.5328 192.406 21.5328Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.139 21.0805C191.139 21.2614 190.958 21.4424 190.777 21.4424C190.596 21.4424 190.415 21.2614 190.415 21.0805C190.415 20.8996 190.596 20.7187 190.777 20.7187C191.048 20.7187 191.139 20.8996 191.139 21.0805Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.706 18.9094C186.706 18.9998 186.615 19.0903 186.525 19.0903C186.434 19.0903 186.344 18.9998 186.344 18.9094C186.344 18.8189 186.434 18.7285 186.525 18.7285C186.615 18.638 186.706 18.7285 186.706 18.9094Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.762 23.704C193.762 23.8849 193.671 23.9754 193.49 23.9754C193.309 23.9754 193.219 23.8849 193.219 23.704C193.219 23.5231 193.309 23.4326 193.49 23.4326C193.581 23.4326 193.762 23.5231 193.762 23.704Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.29 30.4888C197.29 30.6697 197.109 30.8506 196.928 30.8506C196.747 30.8506 196.566 30.6697 196.566 30.4888C196.566 30.3078 196.747 30.1269 196.928 30.1269C197.109 30.1269 197.29 30.2174 197.29 30.4888Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.757 27.2321C194.757 27.413 194.666 27.5035 194.486 27.5035C194.305 27.5035 194.214 27.413 194.214 27.2321C194.214 27.0512 194.305 26.9607 194.486 26.9607C194.576 26.9607 194.757 27.0512 194.757 27.2321Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.114 30.8506C196.114 30.9411 196.024 31.0316 195.933 31.0316C195.843 31.0316 195.752 30.9411 195.752 30.8506C195.752 30.7602 195.843 30.6697 195.933 30.6697C196.024 30.5792 196.114 30.6697 196.114 30.8506Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.29 36.4594C197.29 36.5499 197.2 36.6403 197.109 36.6403C197.019 36.6403 196.928 36.5499 196.928 36.4594C196.928 36.3689 197.019 36.2785 197.109 36.2785C197.2 36.2785 197.29 36.3689 197.29 36.4594Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.033 34.5597C194.183 34.5597 194.305 34.4382 194.305 34.2883C194.305 34.1384 194.183 34.0169 194.033 34.0169C193.883 34.0169 193.762 34.1384 193.762 34.2883C193.762 34.4382 193.883 34.5597 194.033 34.5597Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.209 33.4741C195.209 33.655 195.028 33.836 194.847 33.836C194.667 33.836 194.486 33.655 194.486 33.4741C194.486 33.2932 194.667 33.1122 194.847 33.1122C195.119 33.1122 195.209 33.2932 195.209 33.4741Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.948 38.9019C192.948 39.0829 192.857 39.1733 192.676 39.1733C192.495 39.1733 192.405 39.0829 192.405 38.9019C192.405 38.721 192.495 38.6306 192.676 38.6306C192.767 38.6306 192.948 38.721 192.948 38.9019Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.019 39.0829C197.019 39.0829 196.928 39.0829 197.019 39.0829C196.928 39.1733 196.928 39.0829 196.928 39.0829C196.838 38.9924 196.838 38.9924 197.019 39.0829C196.928 38.9924 197.019 38.9924 197.019 39.0829Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.752 36.0071C195.802 36.0071 195.843 35.9666 195.843 35.9166C195.843 35.8667 195.802 35.8262 195.752 35.8262C195.702 35.8262 195.662 35.8667 195.662 35.9166C195.662 35.9666 195.702 36.0071 195.752 36.0071Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.224 38.5401C192.224 38.721 192.043 38.902 191.862 38.902C191.681 38.902 191.5 38.721 191.5 38.5401C191.5 38.3592 191.681 38.1783 191.862 38.1783C192.134 38.1783 192.224 38.3592 192.224 38.5401Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.129 40.5303C193.378 40.5303 193.581 40.3278 193.581 40.078C193.581 39.8282 193.378 39.6257 193.129 39.6257C192.879 39.6257 192.676 39.8282 192.676 40.078C192.676 40.3278 192.879 40.5303 193.129 40.5303Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.486 40.078C194.486 40.1685 194.395 40.2589 194.305 40.2589C194.214 40.2589 194.124 40.1685 194.124 40.078C194.124 39.9875 194.214 39.8971 194.305 39.8971C194.395 39.8971 194.486 39.9875 194.486 40.078Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.833 37.9973C197.833 38.1783 197.652 38.3592 197.471 38.3592C197.29 38.3592 197.109 38.1783 197.109 37.9973C197.109 37.8164 197.29 37.6355 197.471 37.6355C197.652 37.6355 197.833 37.7259 197.833 37.9973Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.835 35.8262C178.835 36.0071 178.654 36.2785 178.383 36.2785C178.202 36.2785 177.931 36.0976 177.931 35.8262C177.931 35.6452 178.112 35.3738 178.383 35.3738C178.654 35.4643 178.835 35.6452 178.835 35.8262Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.483 35.1025C176.583 35.1025 176.664 35.0215 176.664 34.9215C176.664 34.8216 176.583 34.7406 176.483 34.7406C176.383 34.7406 176.302 34.8216 176.302 34.9215C176.302 35.0215 176.383 35.1025 176.483 35.1025Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.407 31.6648C173.507 31.6648 173.588 31.5838 173.588 31.4839C173.588 31.384 173.507 31.3029 173.407 31.3029C173.308 31.3029 173.227 31.384 173.227 31.4839C173.227 31.5838 173.308 31.6648 173.407 31.6648Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.865 30.0364C173.065 30.0364 173.227 29.8744 173.227 29.6746C173.227 29.4747 173.065 29.3127 172.865 29.3127C172.665 29.3127 172.503 29.4747 172.503 29.6746C172.503 29.8744 172.665 30.0364 172.865 30.0364Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.765 29.5842C174.765 29.8555 174.584 30.0365 174.312 30.0365C174.041 30.0365 173.86 29.8555 173.86 29.5842C173.86 29.3128 174.041 29.1318 174.312 29.1318C174.584 29.1318 174.765 29.3128 174.765 29.5842Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.402 23.6135C174.552 23.6135 174.674 23.492 174.674 23.3421C174.674 23.1922 174.552 23.0707 174.402 23.0707C174.253 23.0707 174.131 23.1922 174.131 23.3421C174.131 23.492 174.253 23.6135 174.402 23.6135Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.036 25.7846C175.036 25.9656 174.855 26.1465 174.674 26.1465C174.493 26.1465 174.312 25.9656 174.312 25.7846C174.312 25.6037 174.493 25.4228 174.674 25.4228C174.945 25.4228 175.036 25.6037 175.036 25.7846Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.031 30.0365C176.031 30.2174 175.85 30.3983 175.669 30.3983C175.488 30.3983 175.307 30.2174 175.307 30.0365C175.307 29.8555 175.488 29.6746 175.669 29.6746C175.85 29.6746 176.031 29.8555 176.031 30.0365Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.483 28.4081C176.483 28.589 176.302 28.7699 176.121 28.7699C175.94 28.7699 175.76 28.589 175.76 28.4081C175.76 28.2272 175.94 28.0462 176.121 28.0462C176.393 28.0462 176.483 28.2272 176.483 28.4081Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.845 25.9656C176.945 25.9656 177.026 25.8846 177.026 25.7847C177.026 25.6847 176.945 25.6037 176.845 25.6037C176.745 25.6037 176.664 25.6847 176.664 25.7847C176.664 25.8846 176.745 25.9656 176.845 25.9656Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.659 23.8849C177.659 23.9754 177.569 23.9754 177.569 23.9754C177.478 23.9754 177.478 23.8849 177.478 23.8849C177.478 23.7944 177.569 23.7944 177.569 23.7944C177.569 23.7944 177.659 23.7944 177.659 23.8849Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.473 22.347C178.473 22.5279 178.383 22.6184 178.202 22.6184C178.021 22.6184 177.931 22.5279 177.931 22.347C177.931 22.1661 178.021 22.0756 178.202 22.0756C178.383 22.0756 178.473 22.2566 178.473 22.347Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.283 20.4473C180.333 20.4473 180.373 20.4068 180.373 20.3568C180.373 20.3068 180.333 20.2663 180.283 20.2663C180.233 20.2663 180.192 20.3068 180.192 20.3568C180.192 20.4068 180.233 20.4473 180.283 20.4473Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.63 18.9999C183.63 19.1808 183.449 19.3617 183.268 19.3617C183.087 19.3617 182.906 19.1808 182.906 18.9999C182.906 18.8189 183.087 18.638 183.268 18.638C183.449 18.638 183.63 18.8189 183.63 18.9999Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.368 19.7235C181.368 19.9045 181.187 19.9949 181.097 19.9949C180.916 19.9949 180.825 19.814 180.825 19.7235C180.825 19.5426 181.006 19.4521 181.097 19.4521C181.187 19.4521 181.368 19.5426 181.368 19.7235Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.373 20.3568C180.373 20.4473 180.283 20.4473 180.283 20.4473C180.192 20.4473 180.192 20.3568 180.192 20.3568C180.192 20.2663 180.283 20.2663 180.283 20.2663C180.283 20.1759 180.373 20.2663 180.373 20.3568Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.83 21.0805C179.83 21.2614 179.74 21.3519 179.559 21.3519C179.378 21.3519 179.288 21.2614 179.288 21.0805C179.288 20.8996 179.378 20.8091 179.559 20.8091C179.74 20.8091 179.83 20.8996 179.83 21.0805Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.383 22.9803C178.383 23.0707 178.292 23.1612 178.202 23.1612C178.111 23.1612 178.021 23.0707 178.021 22.9803C178.021 22.8898 178.111 22.7993 178.202 22.7993C178.383 22.8898 178.383 22.8898 178.383 22.9803Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.312 27.232C174.362 27.232 174.403 27.1915 174.403 27.1416C174.403 27.0916 174.362 27.0511 174.312 27.0511C174.262 27.0511 174.222 27.0916 174.222 27.1416C174.222 27.1915 174.262 27.232 174.312 27.232Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.312 25.0609C174.312 25.2419 174.131 25.4228 173.95 25.4228C173.769 25.4228 173.588 25.2419 173.588 25.0609C173.588 24.88 173.769 24.6991 173.95 24.6991C174.131 24.6086 174.312 24.7895 174.312 25.0609Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.398 23.0707C175.498 23.0707 175.579 22.9897 175.579 22.8898C175.579 22.7899 175.498 22.7089 175.398 22.7089C175.298 22.7089 175.217 22.7899 175.217 22.8898C175.217 22.9897 175.298 23.0707 175.398 23.0707Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.192 20.2663C180.192 20.2663 180.192 20.3568 180.192 20.2663C180.102 20.3568 180.011 20.3568 180.011 20.2663C180.011 20.1759 180.102 20.1759 180.192 20.2663C180.192 20.1759 180.192 20.1759 180.192 20.2663Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.796 21.7138C186.796 21.8043 186.706 21.8043 186.796 21.7138C186.706 21.8043 186.615 21.7138 186.615 21.7138C186.615 21.7138 186.706 21.6233 186.796 21.7138C186.706 21.6233 186.796 21.7138 186.796 21.7138Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.544 23.1612C182.694 23.1612 182.816 23.0397 182.816 22.8898C182.816 22.7399 182.694 22.6184 182.544 22.6184C182.394 22.6184 182.273 22.7399 182.273 22.8898C182.273 23.0397 182.394 23.1612 182.544 23.1612Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.021 20.2663C178.021 20.3568 177.931 20.4473 177.84 20.4473C177.75 20.4473 177.659 20.3568 177.659 20.2663C177.659 20.1759 177.75 20.0854 177.84 20.0854C177.931 20.0854 178.021 20.1759 178.021 20.2663Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.173 34.7406C184.173 34.8311 184.082 34.9216 183.992 34.9216C183.901 34.9216 183.811 34.8311 183.811 34.7406C183.811 34.6502 183.901 34.5597 183.992 34.5597C184.082 34.5597 184.173 34.6502 184.173 34.7406Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.826 35.3738C180.975 35.3738 181.097 35.2523 181.097 35.1024C181.097 34.9526 180.975 34.8311 180.826 34.8311C180.676 34.8311 180.554 34.9526 180.554 35.1024C180.554 35.2523 180.676 35.3738 180.826 35.3738Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.745 32.2981C178.745 32.3885 178.654 32.479 178.564 32.479C178.474 32.479 178.383 32.3885 178.383 32.2981C178.383 32.2076 178.474 32.1172 178.564 32.1172C178.654 32.1172 178.745 32.2076 178.745 32.2981Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.354 34.6502C184.354 34.7406 184.263 34.7406 184.263 34.7406C184.173 34.7406 184.173 34.6502 184.173 34.6502C184.173 34.5597 184.263 34.5597 184.263 34.5597L184.354 34.6502Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.178 38.0878C183.178 38.2687 183.087 38.3592 182.906 38.3592C182.725 38.3592 182.635 38.2687 182.635 38.0878C182.635 37.9069 182.725 37.8164 182.906 37.8164C183.087 37.8164 183.178 37.9069 183.178 38.0878Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.921 35.1025C179.921 35.1025 179.921 35.1936 179.921 35.1025C179.83 35.1936 179.83 35.1025 179.83 35.1025C179.83 35.1025 179.83 35.1025 179.921 35.1025Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.102 32.9313C180.102 33.1122 179.921 33.2932 179.74 33.2932C179.559 33.2932 179.378 33.1122 179.378 32.9313C179.378 32.7504 179.559 32.5695 179.74 32.5695C179.921 32.479 180.102 32.6599 180.102 32.9313Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.796 29.2223C186.796 29.4032 186.615 29.5841 186.434 29.5841C186.253 29.5841 186.073 29.4032 186.073 29.2223C186.073 29.0413 186.253 28.8604 186.434 28.8604C186.615 28.8604 186.796 29.0413 186.796 29.2223Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.525 31.303C186.525 31.3934 186.525 31.3934 186.434 31.3934C186.344 31.3934 186.344 31.3934 186.344 31.303C186.344 31.2125 186.344 31.2125 186.434 31.2125C186.525 31.2125 186.525 31.2125 186.525 31.303Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.173 30.6697C184.173 30.8506 183.992 30.9411 183.901 30.9411C183.811 30.9411 183.63 30.7602 183.63 30.6697C183.63 30.4888 183.811 30.3983 183.901 30.3983C183.992 30.3983 184.173 30.4888 184.173 30.6697Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.119 41.8875C195.028 41.9786 195.028 41.8875 195.028 41.8875C195.028 41.8875 195.028 41.7964 195.119 41.8875C195.119 41.7964 195.119 41.8875 195.119 41.8875Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.933 39.897C196.183 39.897 196.385 39.6945 196.385 39.4447C196.385 39.1949 196.183 38.9924 195.933 38.9924C195.683 38.9924 195.481 39.1949 195.481 39.4447C195.481 39.6945 195.683 39.897 195.933 39.897Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.757 36.8213C194.957 36.8213 195.119 36.6593 195.119 36.4594C195.119 36.2596 194.957 36.0976 194.757 36.0976C194.557 36.0976 194.395 36.2596 194.395 36.4594C194.395 36.6593 194.557 36.8213 194.757 36.8213Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.2 31.5743C197.2 31.8457 197.019 32.0267 196.747 32.0267C196.476 32.0267 196.295 31.8457 196.295 31.5743C196.295 31.3029 196.476 31.122 196.747 31.122C197.019 31.2125 197.2 31.3934 197.2 31.5743Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.043 40.1685C192.043 40.3494 191.953 40.4398 191.772 40.4398C191.591 40.4398 191.5 40.3494 191.5 40.1685C191.5 39.9875 191.591 39.8971 191.772 39.8971C191.953 39.9875 192.043 40.078 192.043 40.1685Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.96 48.2198C171.96 48.3102 171.87 48.4007 171.779 48.4007C171.689 48.4007 171.598 48.3102 171.598 48.2198C171.598 48.1293 171.689 48.0388 171.779 48.0388C171.87 48.0388 171.96 48.1293 171.96 48.2198Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.684 48.1293C172.684 48.2197 172.593 48.2197 172.684 48.1293C172.593 48.2197 172.503 48.1293 172.503 48.1293C172.503 48.1293 172.503 48.0388 172.684 48.1293C172.593 48.0388 172.684 48.1293 172.684 48.1293Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.097 43.5161C181.006 43.6072 181.006 43.5161 181.006 43.5161C181.006 43.425 181.006 43.425 181.097 43.5161C181.097 43.425 181.097 43.425 181.097 43.5161Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.273 42.7919C182.273 42.9728 182.183 43.0633 182.002 43.0633C181.821 43.0633 181.73 42.9728 181.73 42.7919C181.73 42.611 181.821 42.5205 182.002 42.5205C182.183 42.5205 182.273 42.611 182.273 42.7919Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.635 45.144C182.635 45.2344 182.544 45.3249 182.454 45.3249C182.363 45.3249 182.273 45.2344 182.273 45.144C182.273 45.0535 182.363 44.963 182.454 44.963C182.544 44.963 182.635 45.0535 182.635 45.144Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.554 40.8921C180.554 40.9826 180.464 41.1635 180.283 41.1635C180.192 41.1635 180.011 41.0731 180.011 40.8921C180.011 40.8017 180.102 40.6208 180.283 40.6208C180.464 40.7112 180.554 40.8017 180.554 40.8921Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.498 42.43C173.498 42.5205 173.407 42.611 173.317 42.611C173.226 42.611 173.136 42.5205 173.136 42.43C173.136 42.3396 173.226 42.2491 173.317 42.2491C173.407 42.2491 173.498 42.3396 173.498 42.43Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.464 45.144C180.514 45.144 180.554 45.1035 180.554 45.0535C180.554 45.0035 180.514 44.963 180.464 44.963C180.414 44.963 180.373 45.0035 180.373 45.0535C180.373 45.1035 180.414 45.144 180.464 45.144Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.635 43.6965C182.785 43.6965 182.906 43.575 182.906 43.4251C182.906 43.2753 182.785 43.1537 182.635 43.1537C182.485 43.1537 182.363 43.2753 182.363 43.4251C182.363 43.575 182.485 43.6965 182.635 43.6965Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.901 44.5107C183.901 44.6012 183.811 44.6917 183.72 44.6917C183.63 44.6917 183.54 44.6012 183.54 44.5107C183.54 44.4203 183.63 44.3298 183.72 44.3298C183.901 44.3298 183.901 44.4203 183.901 44.5107Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.544 40.3494C182.544 40.4398 182.454 40.4398 182.454 40.4398C182.363 40.4398 182.363 40.3494 182.363 40.3494C182.363 40.2589 182.454 40.2589 182.454 40.2589C182.454 40.1684 182.544 40.2589 182.544 40.3494Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.916 38.9924C180.916 39.2638 180.735 39.4447 180.464 39.4447C180.192 39.4447 180.011 39.2638 180.011 38.9924C180.011 38.721 180.192 38.5401 180.464 38.5401C180.735 38.6306 180.916 38.8115 180.916 38.9924Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.026 38.5401C177.026 38.8115 176.845 38.9924 176.574 38.9924C176.302 38.9924 176.121 38.8115 176.121 38.5401C176.121 38.2687 176.302 38.0878 176.574 38.0878C176.845 38.0878 177.026 38.3592 177.026 38.5401Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.227 35.1929C173.227 35.2834 173.136 35.2834 173.136 35.2834C173.046 35.2834 173.046 35.1929 173.046 35.1929C173.046 35.1025 173.136 35.1025 173.136 35.1025C173.227 35.1025 173.227 35.1025 173.227 35.1929Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.608 37.9068C169.608 37.9973 169.517 37.9973 169.517 37.9973C169.427 37.9973 169.427 37.9068 169.427 37.9068C169.427 37.8163 169.517 37.8163 169.517 37.8163C169.517 37.7259 169.608 37.8163 169.608 37.9068Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.618 40.5303C167.618 40.6208 167.527 40.7112 167.437 40.7112C167.346 40.7112 167.256 40.6208 167.256 40.5303C167.256 40.4398 167.346 40.3494 167.437 40.3494C167.527 40.3494 167.618 40.4398 167.618 40.5303Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.984 43.968C166.984 44.1489 166.804 44.3298 166.623 44.3298C166.442 44.3298 166.261 44.1489 166.261 43.968C166.261 43.787 166.442 43.6061 166.623 43.6061C166.804 43.6061 166.984 43.787 166.984 43.968Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.351 47.7674C166.351 47.9483 166.261 48.0388 166.08 48.0388C165.899 48.0388 165.809 47.9483 165.809 47.7674C165.809 47.5865 165.899 47.496 166.08 47.496C166.17 47.496 166.351 47.5865 166.351 47.7674Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.17 48.5816C166.17 48.6721 166.08 48.7625 165.99 48.7625C165.899 48.7625 165.809 48.6721 165.809 48.5816C165.809 48.4911 165.899 48.4007 165.99 48.4007C166.08 48.4007 166.17 48.4911 166.17 48.5816Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.532 49.1244C166.532 49.2149 166.442 49.3053 166.351 49.3053C166.261 49.3053 166.17 49.2149 166.17 49.1244C166.17 49.0339 166.261 48.9435 166.351 48.9435C166.442 48.9435 166.532 49.0339 166.532 49.1244Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.713 48.1293C166.863 48.1293 166.984 48.0078 166.984 47.8579C166.984 47.708 166.863 47.5865 166.713 47.5865C166.563 47.5865 166.442 47.708 166.442 47.8579C166.442 48.0078 166.563 48.1293 166.713 48.1293Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.628 38.9924C165.628 39.2638 165.447 39.4447 165.175 39.4447C164.904 39.4447 164.723 39.2638 164.723 38.9924C164.723 38.721 164.904 38.5401 165.175 38.5401C165.447 38.6306 165.628 38.8115 165.628 38.9924Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.779 37.8164C171.929 37.8164 172.051 37.6949 172.051 37.545C172.051 37.3951 171.929 37.2736 171.779 37.2736C171.629 37.2736 171.508 37.3951 171.508 37.545C171.508 37.6949 171.629 37.8164 171.779 37.8164Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.307 39.8066C175.307 39.8971 175.217 39.9875 175.126 39.9875C175.036 39.9875 174.945 39.8971 174.945 39.8066C174.945 39.7161 175.036 39.6257 175.126 39.6257C175.217 39.6257 175.307 39.7161 175.307 39.8066Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.121 39.8066C176.121 39.8971 176.031 39.9875 175.94 39.9875C175.85 39.9875 175.76 39.8971 175.76 39.8066C175.76 39.7161 175.85 39.6257 175.94 39.6257C176.031 39.6257 176.121 39.7161 176.121 39.8066Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.921 41.1636C179.921 41.1636 179.921 41.2547 179.921 41.1636C179.921 41.2547 179.83 41.1636 179.921 41.1636C179.83 41.1636 179.921 41.1636 179.921 41.1636Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.165 46.5914C167.165 46.6819 167.075 46.8628 166.894 46.8628C166.803 46.8628 166.623 46.7723 166.623 46.5914C166.623 46.5009 166.713 46.32 166.894 46.32C167.075 46.32 167.165 46.4105 167.165 46.5914Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.965 44.6012C170.965 44.7821 170.784 44.963 170.603 44.963C170.422 44.963 170.241 44.7821 170.241 44.6012C170.241 44.4202 170.422 44.2393 170.603 44.2393C170.784 44.2393 170.965 44.3298 170.965 44.6012Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.764 41.9777C174.764 42.1587 174.584 42.3396 174.403 42.3396C174.222 42.3396 174.041 42.1587 174.041 41.9777C174.041 41.7968 174.222 41.6159 174.403 41.6159C174.584 41.6159 174.764 41.7968 174.764 41.9777Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.022 42.3396C178.022 42.4307 177.931 42.4307 178.022 42.3396C177.931 42.4307 177.931 42.3396 177.931 42.3396C177.931 42.3396 177.931 42.3396 178.022 42.3396C177.931 42.3396 178.022 42.3396 178.022 42.3396Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.454 47.677C145.654 47.677 145.816 47.5149 145.816 47.3151C145.816 47.1153 145.654 46.9532 145.454 46.9532C145.254 46.9532 145.092 47.1153 145.092 47.3151C145.092 47.5149 145.254 47.677 145.454 47.677Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.082 46.5914C147.082 46.7723 146.901 46.9533 146.72 46.9533C146.54 46.9533 146.359 46.7723 146.359 46.5914C146.359 46.4105 146.54 46.2296 146.72 46.2296C146.901 46.2296 147.082 46.4105 147.082 46.5914Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.977 45.5058C150.127 45.5058 150.249 45.3843 150.249 45.2344C150.249 45.0846 150.127 44.963 149.977 44.963C149.827 44.963 149.706 45.0846 149.706 45.2344C149.706 45.3843 149.827 45.5058 149.977 45.5058Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.691 43.8775C152.691 43.9674 152.691 43.9674 152.691 43.8775C152.601 43.9674 152.601 43.9674 152.691 43.8775C152.601 43.8775 152.601 43.8775 152.691 43.8775Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.938 44.963C157.938 45.0535 157.848 45.144 157.757 45.144C157.667 45.144 157.576 45.0535 157.576 44.963C157.576 44.8726 157.667 44.7821 157.757 44.7821C157.848 44.7821 157.938 44.8726 157.938 44.963Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.031 61.8798C139.031 61.9703 138.941 62.0608 138.85 62.0608C138.76 62.0608 138.669 61.9703 138.669 61.8798C138.669 61.7894 138.76 61.6989 138.85 61.6989C138.941 61.6989 139.031 61.7894 139.031 61.8798Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.393 62.5131C139.493 62.5131 139.574 62.4321 139.574 62.3321C139.574 62.2322 139.493 62.1512 139.393 62.1512C139.293 62.1512 139.212 62.2322 139.212 62.3321C139.212 62.4321 139.293 62.5131 139.393 62.5131Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.197 54.6427C142.197 54.7332 142.107 54.8236 142.016 54.8236C141.926 54.8236 141.835 54.7332 141.835 54.6427C141.835 54.5523 141.926 54.4618 142.016 54.4618C142.197 54.4618 142.197 54.5523 142.197 54.6427Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.464 78.7062C143.464 78.7966 143.373 78.8871 143.283 78.8871C143.193 78.8871 143.102 78.7966 143.102 78.7062C143.102 78.6157 143.193 78.5252 143.283 78.5252C143.373 78.5252 143.464 78.6157 143.464 78.7062Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.469 74.2735C142.469 74.3639 142.378 74.5449 142.197 74.5449C142.016 74.5449 141.926 74.4544 141.926 74.2735C141.926 74.183 142.016 74.0021 142.197 74.0021C142.378 74.0021 142.469 74.183 142.469 74.2735Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.107 73.1879C142.107 73.2784 142.017 73.3688 141.926 73.3688C141.836 73.3688 141.745 73.2784 141.745 73.1879C141.745 73.0974 141.836 73.007 141.926 73.007C142.017 73.007 142.107 73.0974 142.107 73.1879Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.75 65.6793C140.75 65.7698 140.75 65.7698 140.659 65.7698C140.569 65.7698 140.569 65.7698 140.569 65.6793C140.569 65.5889 140.569 65.5889 140.659 65.5889C140.75 65.4984 140.75 65.5889 140.75 65.6793Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.75 64.6842C140.75 64.7747 140.659 64.8652 140.569 64.8652C140.478 64.8652 140.388 64.7747 140.388 64.6842C140.388 64.5938 140.478 64.5033 140.569 64.5033C140.75 64.5938 140.75 64.5938 140.75 64.6842Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.84 60.161C140.84 60.2515 140.75 60.342 140.659 60.342C140.569 60.342 140.479 60.2515 140.479 60.161C140.479 60.0706 140.569 59.9801 140.659 59.9801C140.75 59.9801 140.84 60.0706 140.84 60.161Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.293 56.3615C141.293 56.5424 141.112 56.7234 140.931 56.7234C140.75 56.7234 140.569 56.5424 140.569 56.3615C140.569 56.1806 140.75 55.9997 140.931 55.9997C141.112 56.0901 141.293 56.1806 141.293 56.3615Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.112 53.6476C141.112 53.8285 141.021 53.919 140.84 53.919C140.659 53.919 140.569 53.8285 140.569 53.6476C140.569 53.4667 140.659 53.3762 140.84 53.3762C141.021 53.3762 141.112 53.5571 141.112 53.6476Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.926 54.4618C141.926 54.5522 141.835 54.6427 141.745 54.6427C141.654 54.6427 141.564 54.5522 141.564 54.4618C141.564 54.3713 141.654 54.2809 141.745 54.2809C141.835 54.2809 141.926 54.3713 141.926 54.4618Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.469 50.1195C142.569 50.1195 142.65 50.0385 142.65 49.9386C142.65 49.8386 142.569 49.7576 142.469 49.7576C142.369 49.7576 142.288 49.8386 142.288 49.9386C142.288 50.0385 142.369 50.1195 142.469 50.1195Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.65 49.1244C142.799 49.1244 142.921 49.0029 142.921 48.853C142.921 48.7031 142.799 48.5816 142.65 48.5816C142.5 48.5816 142.378 48.7031 142.378 48.853C142.378 49.0029 142.5 49.1244 142.65 49.1244Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.444 44.6917C147.444 44.8726 147.354 44.963 147.173 44.963C146.992 44.963 146.901 44.8726 146.901 44.6917C146.901 44.5107 146.992 44.4203 147.173 44.4203C147.263 44.4203 147.444 44.5107 147.444 44.6917Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.836 45.3249C141.836 45.416 141.836 45.416 141.836 45.3249C141.745 45.416 141.745 45.3249 141.745 45.3249C141.745 45.3249 141.745 45.3249 141.836 45.3249Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.835 48.0388C141.835 48.1293 141.745 48.2198 141.655 48.2198C141.564 48.2198 141.474 48.1293 141.474 48.0388C141.474 47.9484 141.564 47.8579 141.655 47.8579C141.745 47.8579 141.835 47.9484 141.835 48.0388Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.836 50.9337C141.836 51.1146 141.655 51.2051 141.564 51.2051C141.383 51.2051 141.293 51.0241 141.293 50.9337C141.293 50.8432 141.474 50.6623 141.564 50.6623C141.655 50.6623 141.836 50.7528 141.836 50.9337Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.112 53.5571C141.112 53.6476 141.021 53.7381 140.931 53.7381C140.84 53.7381 140.75 53.6476 140.75 53.5571C140.75 53.4667 140.84 53.3762 140.931 53.3762C141.112 53.3762 141.112 53.4667 141.112 53.5571Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.373 82.0533C143.473 82.0533 143.554 81.9723 143.554 81.8724C143.554 81.7725 143.473 81.6915 143.373 81.6915C143.273 81.6915 143.192 81.7725 143.192 81.8724C143.192 81.9723 143.273 82.0533 143.373 82.0533Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.011 84.5863C143.011 84.6763 143.011 84.6763 143.011 84.5863C143.011 84.6763 142.921 84.6763 143.011 84.5863C142.921 84.5863 143.011 84.5863 143.011 84.5863Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.821 88.2954C144.921 88.2954 145.002 88.2144 145.002 88.1144C145.002 88.0145 144.921 87.9335 144.821 87.9335C144.721 87.9335 144.64 88.0145 144.64 88.1144C144.64 88.2144 144.721 88.2954 144.821 88.2954Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.635 88.9286C145.635 89.1095 145.544 89.2 145.363 89.2C145.182 89.2 145.092 89.1095 145.092 88.9286C145.092 88.7477 145.182 88.6572 145.363 88.6572C145.544 88.6572 145.635 88.7477 145.635 88.9286Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.716 90.3761C147.866 90.3761 147.987 90.2546 147.987 90.1047C147.987 89.9548 147.866 89.8333 147.716 89.8333C147.566 89.8333 147.444 89.9548 147.444 90.1047C147.444 90.2546 147.566 90.3761 147.716 90.3761Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.686 86.3052C153.686 86.4861 153.505 86.667 153.324 86.667C153.143 86.667 152.962 86.4861 152.962 86.3052C152.962 86.1243 153.143 85.9433 153.324 85.9433C153.505 85.8529 153.686 86.0338 153.686 86.3052Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.686 83.4103C153.686 83.5008 153.596 83.5913 153.505 83.5913C153.415 83.5913 153.324 83.5008 153.324 83.4103C153.324 83.3199 153.415 83.2294 153.505 83.2294C153.596 83.1389 153.686 83.2294 153.686 83.4103Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.234 80.7869C153.234 80.8773 153.143 80.9678 153.053 80.9678C152.963 80.9678 152.872 80.8773 152.872 80.7869C152.872 80.6964 152.963 80.6059 153.053 80.6059C153.143 80.6059 153.234 80.6964 153.234 80.7869Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.515 79.068C151.515 79.249 151.334 79.4299 151.153 79.4299C150.972 79.4299 150.792 79.249 150.792 79.068C150.792 78.8871 150.972 78.7062 151.153 78.7062C151.334 78.7062 151.515 78.8871 151.515 79.068Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.148 82.4152C152.148 82.5962 152.058 82.6866 151.877 82.6866C151.696 82.6866 151.606 82.5962 151.606 82.4152C151.606 82.2343 151.696 82.1438 151.877 82.1438C152.058 82.1438 152.148 82.2343 152.148 82.4152Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.882 81.2392C150.882 81.3296 150.791 81.3296 150.882 81.2392C150.791 81.3296 150.701 81.2392 150.701 81.2392C150.701 81.2392 150.701 81.1487 150.882 81.2392C150.791 81.1487 150.882 81.2392 150.882 81.2392Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.249 79.5203C150.249 79.7013 150.068 79.8822 149.887 79.8822C149.706 79.8822 149.525 79.7013 149.525 79.5203C149.525 79.3394 149.706 79.1585 149.887 79.1585C150.068 79.1585 150.249 79.2489 150.249 79.5203Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.906 75.9923C146.106 75.9923 146.268 75.8303 146.268 75.6304C146.268 75.4306 146.106 75.2686 145.906 75.2686C145.706 75.2686 145.544 75.4306 145.544 75.6304C145.544 75.8303 145.706 75.9923 145.906 75.9923Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.092 74.6353C145.142 74.6353 145.183 74.5948 145.183 74.5448C145.183 74.4949 145.142 74.4544 145.092 74.4544C145.042 74.4544 145.002 74.4949 145.002 74.5448C145.002 74.5948 145.042 74.6353 145.092 74.6353Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.906 71.9213C145.906 72.1023 145.725 72.2832 145.544 72.2832C145.364 72.2832 145.183 72.1023 145.183 71.9213C145.183 71.7404 145.364 71.5595 145.544 71.5595C145.725 71.5595 145.906 71.6499 145.906 71.9213Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.54 68.5742C146.54 68.6647 146.449 68.6647 146.449 68.6647C146.359 68.6647 146.359 68.5742 146.359 68.5742L146.449 68.4838C146.449 68.3933 146.54 68.4838 146.54 68.5742Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.082 66.584C147.182 66.584 147.263 66.503 147.263 66.403C147.263 66.3031 147.182 66.2221 147.082 66.2221C146.982 66.2221 146.901 66.3031 146.901 66.403C146.901 66.503 146.982 66.584 147.082 66.584Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.901 68.936C147.001 68.936 147.082 68.855 147.082 68.7551C147.082 68.6552 147.001 68.5742 146.901 68.5742C146.801 68.5742 146.72 68.6552 146.72 68.7551C146.72 68.855 146.801 68.936 146.901 68.936Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.992 66.584C146.992 66.584 146.901 66.6744 146.992 66.584C146.811 66.6744 146.811 66.6744 146.811 66.584C146.811 66.4935 146.811 66.4935 146.992 66.584C146.901 66.4935 146.992 66.4935 146.992 66.584Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.354 64.5033C147.354 64.6842 147.173 64.8651 146.992 64.8651C146.811 64.8651 146.63 64.6842 146.63 64.5033C146.63 64.3223 146.811 64.1414 146.992 64.1414C147.173 64.1414 147.354 64.2319 147.354 64.5033Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.53 61.2466C148.53 61.4275 148.439 61.518 148.258 61.518C148.078 61.518 147.987 61.4275 147.987 61.2466C147.987 61.0656 148.078 60.9752 148.258 60.9752C148.349 60.9752 148.53 61.0656 148.53 61.2466Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.801 60.4324C148.801 60.5229 148.711 60.6134 148.62 60.6134C148.53 60.6134 148.439 60.5229 148.439 60.4324C148.439 60.342 148.53 60.2515 148.62 60.2515C148.711 60.2515 148.801 60.342 148.801 60.4324Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.425 57.1757C151.334 57.2662 151.244 57.1757 151.244 57.1757C151.334 57.0852 151.334 57.0852 151.425 57.1757C151.425 57.0852 151.425 57.0852 151.425 57.1757Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.872 55.5473C152.872 55.6378 152.782 55.6378 152.782 55.6378C152.691 55.6378 152.691 55.5473 152.691 55.5473C152.691 55.4569 152.782 55.4569 152.782 55.4569C152.872 55.3664 152.872 55.4569 152.872 55.5473Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.686 54.1904C153.686 54.2809 153.596 54.3713 153.505 54.3713C153.415 54.3713 153.324 54.2809 153.324 54.1904C153.324 54.0999 153.415 54.0095 153.505 54.0095C153.596 54.0095 153.686 54.0095 153.686 54.1904Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.701 61.8798C150.701 62.0608 150.52 62.2417 150.339 62.2417C150.158 62.2417 149.977 62.0608 149.977 61.8798C149.977 61.6989 150.158 61.518 150.339 61.518C150.52 61.518 150.701 61.6989 150.701 61.8798Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.339 63.87C150.339 63.9605 150.249 64.051 150.158 64.051C150.068 64.051 149.977 63.9605 149.977 63.87C149.977 63.7796 150.068 63.6891 150.158 63.6891C150.249 63.6891 150.339 63.7796 150.339 63.87Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.61 60.342C150.61 60.5229 150.43 60.7038 150.249 60.7038C150.068 60.7038 149.887 60.5229 149.887 60.342C149.887 60.161 150.068 59.9801 150.249 59.9801C150.52 59.9801 150.61 60.161 150.61 60.342Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.972 55.9092C150.882 55.9997 150.792 55.9092 150.792 55.9092C150.792 55.8187 150.882 55.8187 150.972 55.9092C150.972 55.8187 150.972 55.8187 150.972 55.9092Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.063 55.1855C151.063 55.276 150.972 55.3664 150.882 55.3664C150.791 55.3664 150.701 55.276 150.701 55.1855C150.701 55.095 150.791 55.0046 150.882 55.0046C150.972 55.0046 151.063 55.095 151.063 55.1855Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.631 49.1247C146.631 49.1247 146.631 49.2158 146.631 49.1247C146.54 49.2158 146.54 49.1247 146.54 49.1247C146.54 49.1247 146.54 49.0336 146.631 49.1247C146.631 49.0336 146.631 49.1247 146.631 49.1247Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.117 44.4203C177.266 44.4203 177.388 44.2987 177.388 44.1489C177.388 43.999 177.266 43.8775 177.117 43.8775C176.967 43.8775 176.845 43.999 176.845 44.1489C176.845 44.2987 176.967 44.4203 177.117 44.4203Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.297 42.7014C177.297 42.7919 177.207 42.7919 177.207 42.7919C177.116 42.7919 177.116 42.7014 177.116 42.7014C177.116 42.611 177.207 42.611 177.207 42.611C177.297 42.611 177.297 42.611 177.297 42.7014Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.755 44.4203C176.904 44.4203 177.026 44.2987 177.026 44.1489C177.026 43.999 176.904 43.8775 176.755 43.8775C176.605 43.8775 176.483 43.999 176.483 44.1489C176.483 44.2987 176.605 44.4203 176.755 44.4203Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.031 45.0535C176.131 45.0535 176.212 44.9725 176.212 44.8726C176.212 44.7727 176.131 44.6917 176.031 44.6917C175.931 44.6917 175.85 44.7727 175.85 44.8726C175.85 44.9725 175.931 45.0535 176.031 45.0535Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.855 46.8628C175.055 46.8628 175.217 46.7008 175.217 46.5009C175.217 46.3011 175.055 46.1391 174.855 46.1391C174.655 46.1391 174.493 46.3011 174.493 46.5009C174.493 46.7008 174.655 46.8628 174.855 46.8628Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.875 50.3909C170.875 50.4814 170.875 50.4814 170.875 50.3909C170.784 50.4814 170.694 50.3909 170.694 50.3909C170.694 50.3909 170.784 50.3909 170.875 50.3909Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.16 51.6574C168.16 51.8383 168.07 51.9288 167.889 51.9288C167.708 51.9288 167.618 51.8383 167.618 51.6574C167.618 51.4765 167.708 51.386 167.889 51.386C167.98 51.386 168.16 51.5669 168.16 51.6574Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.085 52.1097C165.335 52.1097 165.537 51.9072 165.537 51.6574C165.537 51.4076 165.335 51.2051 165.085 51.2051C164.835 51.2051 164.633 51.4076 164.633 51.6574C164.633 51.9072 164.835 52.1097 165.085 52.1097Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.07 50.4814C168.07 50.6623 167.889 50.8432 167.708 50.8432C167.527 50.8432 167.346 50.6623 167.346 50.4814C167.346 50.3004 167.527 50.1195 167.708 50.1195C167.889 50.1195 168.07 50.3004 168.07 50.4814Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.231 46.8628C172.231 46.9532 172.141 47.0437 172.051 47.0437C171.96 47.0437 171.87 46.9532 171.87 46.8628C171.87 46.7723 171.96 46.6819 172.051 46.6819C172.141 46.6819 172.231 46.7723 172.231 46.8628Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.769 42.611C173.769 42.611 173.769 42.7009 173.769 42.611C173.679 42.7009 173.679 42.611 173.769 42.611C173.679 42.611 173.679 42.611 173.769 42.611Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.774 46.2295C172.774 46.4105 172.593 46.5914 172.412 46.5914C172.231 46.5914 172.051 46.4105 172.051 46.2295C172.051 46.0486 172.231 45.8677 172.412 45.8677C172.593 45.8677 172.774 46.0486 172.774 46.2295Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.175 50.3004C165.175 50.3909 165.175 50.3909 165.175 50.3004C165.085 50.3909 164.994 50.3909 164.994 50.3004C164.994 50.21 165.085 50.21 165.175 50.3004C165.175 50.21 165.175 50.3004 165.175 50.3004Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.29 52.1097C160.44 52.1097 160.562 51.9882 160.562 51.8383C160.562 51.6884 160.44 51.5669 160.29 51.5669C160.14 51.5669 160.019 51.6884 160.019 51.8383C160.019 51.9882 160.14 52.1097 160.29 52.1097Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.747 53.3762C159.747 53.3762 159.747 53.4667 159.747 53.3762C159.657 53.4667 159.657 53.3762 159.657 53.3762C159.566 53.3762 159.657 53.2857 159.747 53.3762C159.747 53.2857 159.747 53.3762 159.747 53.3762Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.674 38.1783C174.674 38.3592 174.493 38.5401 174.312 38.5401C174.131 38.5401 173.95 38.3592 173.95 38.1783C173.95 37.9973 174.131 37.8164 174.312 37.8164C174.493 37.8164 174.674 37.9973 174.674 38.1783Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.322 36.8213C172.322 37.0022 172.231 37.0927 172.05 37.0927C171.87 37.0927 171.779 37.0022 171.779 36.8213C171.779 36.6403 171.87 36.5499 172.05 36.5499C172.231 36.5499 172.322 36.6403 172.322 36.8213Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.055 39.6257C171.055 39.7161 170.965 39.8066 170.875 39.8066C170.784 39.8066 170.694 39.7161 170.694 39.6257C170.694 39.5352 170.784 39.4447 170.875 39.4447C170.965 39.5352 171.055 39.5352 171.055 39.6257Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.415 55.9997C190.415 56.1806 190.324 56.2711 190.143 56.2711C189.962 56.2711 189.872 56.1806 189.872 55.9997C189.872 55.8187 189.962 55.7283 190.143 55.7283C190.324 55.7283 190.415 55.9092 190.415 55.9997Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.087 52.743C183.087 52.9239 182.906 53.1048 182.725 53.1048C182.544 53.1048 182.363 52.9239 182.363 52.743C182.363 52.562 182.544 52.3811 182.725 52.3811C182.906 52.3811 183.087 52.562 183.087 52.743Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.947 48.853C192.947 48.9429 192.947 48.9429 192.947 48.853C192.857 48.9429 192.857 48.9429 192.947 48.853C192.857 48.853 192.857 48.853 192.947 48.853Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.496 46.9532C192.496 47.0444 192.496 47.0444 192.496 46.9532C192.405 47.0444 192.405 46.9532 192.405 46.9532C192.405 46.9532 192.405 46.9532 192.496 46.9532Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.863 45.4154C191.863 45.5065 191.863 45.5065 191.863 45.4154C191.772 45.5065 191.772 45.4154 191.772 45.4154C191.772 45.4154 191.772 45.4154 191.863 45.4154Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.263 45.9581C184.263 46.1391 184.082 46.32 183.901 46.32C183.72 46.32 183.54 46.1391 183.54 45.9581C183.54 45.7772 183.72 45.5963 183.901 45.5963C184.173 45.5963 184.263 45.7772 184.263 45.9581Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.054 42.2491C190.054 42.2491 190.054 42.3402 190.054 42.2491C189.962 42.3402 189.962 42.2491 189.962 42.2491C189.962 42.2491 190.054 42.2491 190.054 42.2491Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.253 44.3298C186.453 44.3298 186.615 44.1678 186.615 43.968C186.615 43.7681 186.453 43.6061 186.253 43.6061C186.054 43.6061 185.892 43.7681 185.892 43.968C185.892 44.1678 186.054 44.3298 186.253 44.3298Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.807 50.9337C184.807 51.0248 184.807 51.0248 184.807 50.9337C184.716 51.0248 184.716 50.9337 184.716 50.9337C184.716 50.9337 184.716 50.9337 184.807 50.9337Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.253 46.5009C186.253 46.5914 186.163 46.6819 186.073 46.6819C185.982 46.6819 185.892 46.5914 185.892 46.5009C185.892 46.4105 185.982 46.32 186.073 46.32C186.163 46.32 186.253 46.4105 186.253 46.5009Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.253 44.8726C186.253 44.963 186.163 45.0535 186.073 45.0535C185.982 45.0535 185.892 44.963 185.892 44.8726C185.892 44.7821 185.982 44.6917 186.073 44.6917C186.163 44.6917 186.253 44.7821 186.253 44.8726Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.987 48.3102C184.987 48.5816 184.806 48.7626 184.535 48.7626C184.263 48.7626 184.082 48.5816 184.082 48.3102C184.082 48.0388 184.263 47.8579 184.535 47.8579C184.716 47.8579 184.987 48.0388 184.987 48.3102Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.368 49.5767C181.618 49.5767 181.821 49.3742 181.821 49.1244C181.821 48.8746 181.618 48.6721 181.368 48.6721C181.119 48.6721 180.916 48.8746 180.916 49.1244C180.916 49.3742 181.119 49.5767 181.368 49.5767Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.192 43.6966C180.242 43.6966 180.283 43.656 180.283 43.6061C180.283 43.5561 180.242 43.5156 180.192 43.5156C180.142 43.5156 180.102 43.5561 180.102 43.6061C180.102 43.656 180.142 43.6966 180.192 43.6966Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.659 47.677C177.659 47.7674 177.569 47.8579 177.478 47.8579C177.388 47.8579 177.297 47.7674 177.297 47.677C177.297 47.5865 177.388 47.496 177.478 47.496C177.569 47.5865 177.659 47.5865 177.659 47.677Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.207 48.4912C177.207 48.6721 177.116 48.7626 176.935 48.7626C176.755 48.7626 176.664 48.6721 176.664 48.4912C176.664 48.3103 176.755 48.2198 176.935 48.2198C177.116 48.2198 177.207 48.3103 177.207 48.4912Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.618 52.1097C167.618 52.2002 167.527 52.2002 167.618 52.1097C167.527 52.2002 167.437 52.2002 167.437 52.1097C167.437 52.1097 167.437 52.0193 167.618 52.1097C167.527 52.0193 167.618 52.1097 167.618 52.1097Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.351 52.6525C166.401 52.6525 166.442 52.612 166.442 52.562C166.442 52.5121 166.401 52.4716 166.351 52.4716C166.301 52.4716 166.261 52.5121 166.261 52.562C166.261 52.612 166.301 52.6525 166.351 52.6525Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.376 53.4667C161.376 53.5578 161.285 53.5578 161.376 53.4667C161.285 53.5578 161.285 53.4667 161.285 53.4667C161.285 53.4667 161.285 53.4667 161.376 53.4667C161.285 53.4667 161.376 53.4667 161.376 53.4667Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.833 53.6476C160.833 53.8285 160.652 54.0094 160.471 54.0094C160.29 54.0094 160.109 53.8285 160.109 53.6476C160.109 53.4667 160.29 53.2857 160.471 53.2857C160.652 53.2857 160.833 53.4667 160.833 53.6476Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.742 44.8726C160.742 44.9631 160.652 45.144 160.471 45.144C160.29 45.144 160.2 45.0535 160.2 44.8726C160.2 44.7821 160.29 44.6012 160.471 44.6012C160.652 44.6012 160.742 44.6917 160.742 44.8726Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.552 42.5205C162.552 42.611 162.461 42.7015 162.371 42.7015C162.28 42.7015 162.19 42.611 162.19 42.5205C162.19 42.4301 162.28 42.3396 162.371 42.3396C162.552 42.3396 162.552 42.4301 162.552 42.5205Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.285 39.3543C161.485 39.3543 161.647 39.1923 161.647 38.9924C161.647 38.7926 161.485 38.6306 161.285 38.6306C161.085 38.6306 160.923 38.7926 160.923 38.9924C160.923 39.1923 161.085 39.3543 161.285 39.3543Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.527 37.1831C167.527 37.3641 167.346 37.545 167.165 37.545C166.984 37.545 166.803 37.3641 166.803 37.1831C166.803 37.0022 166.984 36.8213 167.165 36.8213C167.346 36.8213 167.527 37.0022 167.527 37.1831Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.774 38.6306C172.774 38.721 172.684 38.721 172.684 38.721L172.593 38.6306C172.593 38.5401 172.684 38.5401 172.684 38.5401C172.684 38.5401 172.774 38.5401 172.774 38.6306Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.099 44.5107C162.099 44.6917 161.919 44.8726 161.738 44.8726C161.557 44.8726 161.376 44.6917 161.376 44.5107C161.376 44.3298 161.557 44.1489 161.738 44.1489C161.919 44.1489 162.099 44.3298 162.099 44.5107Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.608 37.0022C169.608 37.1831 169.427 37.364 169.246 37.364C169.065 37.364 168.884 37.1831 168.884 37.0022C168.884 36.8212 169.065 36.6403 169.246 36.6403C169.427 36.6403 169.608 36.8212 169.608 37.0022Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.261 39.897C166.261 39.9875 166.17 39.9875 166.17 39.9875C166.08 39.9875 166.08 39.897 166.08 39.897C166.08 39.8066 166.17 39.8066 166.17 39.8066C166.261 39.8066 166.261 39.8066 166.261 39.897Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.518 35.8261C169.518 35.8261 169.518 35.9166 169.518 35.8261C169.427 35.9166 169.337 35.8261 169.337 35.8261C169.427 35.7357 169.427 35.7357 169.518 35.8261C169.518 35.7357 169.518 35.7357 169.518 35.8261Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.141 34.1978C172.191 34.1978 172.231 34.1573 172.231 34.1074C172.231 34.0574 172.191 34.0169 172.141 34.0169C172.091 34.0169 172.051 34.0574 172.051 34.1074C172.051 34.1573 172.091 34.1978 172.141 34.1978Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.398 39.3543C175.398 39.5352 175.307 39.6257 175.126 39.6257C174.945 39.6257 174.855 39.5352 174.855 39.3543C174.855 39.1734 174.945 39.0829 175.126 39.0829C175.307 39.0829 175.398 39.1734 175.398 39.3543Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.838 39.0829C196.838 39.2638 196.657 39.4447 196.476 39.4447C196.295 39.4447 196.114 39.2638 196.114 39.0829C196.114 38.9019 196.295 38.721 196.476 38.721C196.657 38.721 196.838 38.9019 196.838 39.0829Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.476 38.2687C196.476 38.4496 196.295 38.6305 196.114 38.6305C195.933 38.6305 195.752 38.4496 195.752 38.2687C195.752 38.0878 195.933 37.9068 196.114 37.9068C196.295 37.9068 196.476 38.0878 196.476 38.2687Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.566 34.1073C196.566 34.1978 196.476 34.2883 196.385 34.2883C196.295 34.2883 196.204 34.1978 196.204 34.1073C196.204 34.0169 196.295 33.9264 196.385 33.9264C196.476 33.9264 196.566 34.0169 196.566 34.1073Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.114 34.5597C196.364 34.5597 196.566 34.3572 196.566 34.1074C196.566 33.8575 196.364 33.655 196.114 33.655C195.864 33.655 195.662 33.8575 195.662 34.1074C195.662 34.3572 195.864 34.5597 196.114 34.5597Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.023 36.5499C196.023 36.7308 195.933 36.8213 195.752 36.8213C195.571 36.8213 195.481 36.7308 195.481 36.5499C195.481 36.3689 195.571 36.2785 195.752 36.2785C195.933 36.2785 196.023 36.4594 196.023 36.5499Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.933 35.7357C195.933 35.7357 195.843 35.7357 195.933 35.7357C195.843 35.8262 195.843 35.7357 195.843 35.7357C195.752 35.7357 195.843 35.6453 195.933 35.7357C195.843 35.6453 195.933 35.7357 195.933 35.7357Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.928 33.836C196.928 34.0169 196.838 34.1074 196.657 34.1074C196.476 34.1074 196.385 34.0169 196.385 33.836C196.385 33.655 196.476 33.5646 196.657 33.5646C196.747 33.5646 196.928 33.7455 196.928 33.836Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.329 37.3641C189.329 37.545 189.148 37.7259 188.967 37.7259C188.786 37.7259 188.605 37.545 188.605 37.3641C188.605 37.1831 188.786 37.0022 188.967 37.0022C189.148 37.0022 189.329 37.1831 189.329 37.3641Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.148 38.8115C189.148 38.9924 188.967 39.1734 188.786 39.1734C188.605 39.1734 188.425 38.9924 188.425 38.8115C188.425 38.6306 188.605 38.4496 188.786 38.4496C188.967 38.4496 189.148 38.6306 189.148 38.8115Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.662 38.0878C195.662 38.3592 195.481 38.5401 195.209 38.5401C194.938 38.5401 194.757 38.3592 194.757 38.0878C194.757 37.8164 194.938 37.6355 195.209 37.6355C195.481 37.6355 195.662 37.9069 195.662 38.0878Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.151 57.5375C170.151 57.5375 170.151 57.628 170.151 57.5375C170.06 57.628 169.97 57.5375 169.97 57.5375C169.97 57.5375 170.06 57.4471 170.151 57.5375C170.151 57.4471 170.151 57.4471 170.151 57.5375Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.158 63.6891C150.158 63.7796 150.068 63.7796 150.068 63.7796C149.977 63.7796 149.977 63.6891 149.977 63.6891C149.977 63.5987 150.068 63.5987 150.068 63.5987L150.158 63.6891Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.425 60.7943C151.425 60.8847 151.425 60.8847 151.425 60.7943C151.244 60.8847 151.244 60.8847 151.244 60.7943C151.334 60.7943 151.334 60.7038 151.425 60.7943C151.425 60.7038 151.425 60.7943 151.425 60.7943Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.787 59.7992C151.887 59.7992 151.968 59.7182 151.968 59.6182C151.968 59.5183 151.887 59.4373 151.787 59.4373C151.687 59.4373 151.606 59.5183 151.606 59.6182C151.606 59.7182 151.687 59.7992 151.787 59.7992Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.782 56.9043C152.782 57.0853 152.691 57.1757 152.51 57.1757C152.329 57.1757 152.239 57.0853 152.239 56.9043C152.239 56.7234 152.329 56.6329 152.51 56.6329C152.691 56.6329 152.782 56.7234 152.782 56.9043Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.158 55.7283C150.308 55.7283 150.43 55.6068 150.43 55.4569C150.43 55.307 150.308 55.1855 150.158 55.1855C150.008 55.1855 149.887 55.307 149.887 55.4569C149.887 55.6068 150.008 55.7283 150.158 55.7283Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.068 56.1806C150.068 56.2711 149.977 56.2711 149.977 56.2711C149.887 56.2711 149.887 56.1806 149.887 56.1806C149.887 56.0901 149.977 56.0901 149.977 56.0901C149.977 56.0901 150.068 56.0901 150.068 56.1806Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.349 59.2564C148.399 59.2564 148.439 59.2159 148.439 59.1659C148.439 59.116 148.399 59.0755 148.349 59.0755C148.299 59.0755 148.258 59.116 148.258 59.1659C148.258 59.2159 148.299 59.2564 148.349 59.2564Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.73 59.1659C144.73 59.3469 144.549 59.4373 144.459 59.4373C144.278 59.4373 144.188 59.2564 144.188 59.1659C144.188 58.985 144.368 58.8945 144.459 58.8945C144.549 58.8945 144.73 58.985 144.73 59.1659Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.359 62.9654C146.359 63.0558 146.268 63.1463 146.178 63.1463C146.087 63.1463 145.997 63.0558 145.997 62.9654C145.997 62.8749 146.087 62.7845 146.178 62.7845C146.359 62.7845 146.359 62.8749 146.359 62.9654Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.087 62.1512C146.087 62.2417 145.997 62.2417 145.997 62.2417C145.906 62.2417 145.906 62.1512 145.906 62.1512C145.906 62.0608 145.997 62.0608 145.997 62.0608C145.997 61.9703 146.087 62.0608 146.087 62.1512Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.268 56.7234C146.418 56.7234 146.54 56.6019 146.54 56.452C146.54 56.3021 146.418 56.1806 146.268 56.1806C146.118 56.1806 145.997 56.3021 145.997 56.452C145.997 56.6019 146.118 56.7234 146.268 56.7234Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.54 54.2809C146.54 54.4618 146.359 54.7332 146.087 54.7332C145.816 54.7332 145.635 54.5523 145.635 54.2809C145.635 54.0999 145.816 53.8286 146.087 53.8286C146.359 53.8286 146.54 54.0095 146.54 54.2809Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.811 50.7527C146.811 50.8432 146.721 50.9337 146.63 50.9337C146.54 50.9337 146.449 50.8432 146.449 50.7527C146.449 50.6623 146.54 50.5718 146.63 50.5718C146.721 50.5718 146.811 50.6623 146.811 50.7527Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.082 47.0438C147.082 47.1342 146.992 47.2247 146.901 47.2247C146.811 47.2247 146.72 47.1342 146.72 47.0438C146.72 46.9533 146.811 46.8628 146.901 46.8628C146.992 46.8628 147.082 46.9533 147.082 47.0438Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.449 48.1293C146.449 48.2192 146.449 48.2192 146.449 48.1293C146.359 48.2192 146.359 48.2192 146.449 48.1293C146.359 48.1293 146.359 48.1293 146.449 48.1293Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.545 50.5718C145.595 50.5718 145.635 50.5313 145.635 50.4814C145.635 50.4314 145.595 50.3909 145.545 50.3909C145.495 50.3909 145.454 50.4314 145.454 50.4814C145.454 50.5313 145.495 50.5718 145.545 50.5718Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.64 53.7381C144.64 53.919 144.459 54.0999 144.278 54.0999C144.097 54.0999 143.916 53.919 143.916 53.7381C143.916 53.5572 144.097 53.3762 144.278 53.3762C144.459 53.3762 144.64 53.5572 144.64 53.7381Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.188 57.0855C144.188 57.0855 144.188 57.1766 144.188 57.0855C144.097 57.1766 144.097 57.0855 144.097 57.0855C144.097 57.0855 144.097 56.9944 144.188 57.0855C144.188 56.9944 144.188 57.0855 144.188 57.0855Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.459 60.8847C144.459 60.9752 144.459 60.9752 144.459 60.8847C144.369 60.9752 144.278 60.8847 144.278 60.8847C144.369 60.8847 144.369 60.7943 144.459 60.8847C144.459 60.7943 144.459 60.8847 144.459 60.8847Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.002 60.7943C145.002 60.8847 144.911 60.9752 144.821 60.9752C144.73 60.9752 144.64 60.8847 144.64 60.7943C144.64 60.7038 144.73 60.6133 144.821 60.6133C145.002 60.6133 145.002 60.7038 145.002 60.7943Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.449 56.3615C146.449 56.452 146.359 56.5424 146.268 56.5424C146.178 56.5424 146.087 56.452 146.087 56.3615C146.087 56.271 146.178 56.1806 146.268 56.1806C146.359 56.0901 146.449 56.1806 146.449 56.3615Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.449 55.6378C146.599 55.6378 146.721 55.5163 146.721 55.3664C146.721 55.2165 146.599 55.095 146.449 55.095C146.299 55.095 146.178 55.2165 146.178 55.3664C146.178 55.5163 146.299 55.6378 146.449 55.6378Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.897 54.8237C147.897 54.9148 147.897 54.9148 147.897 54.8237C147.806 54.9148 147.806 54.8237 147.806 54.8237C147.806 54.8237 147.806 54.8237 147.897 54.8237Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.268 59.9801C146.268 59.9801 146.268 60.0705 146.268 59.9801C146.178 60.0705 146.087 59.9801 146.087 59.9801C146.178 59.8896 146.178 59.8896 146.268 59.9801C146.268 59.8896 146.268 59.8896 146.268 59.9801Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.906 61.6989C145.906 61.7894 145.816 61.8799 145.725 61.8799C145.635 61.8799 145.544 61.7894 145.544 61.6989C145.544 61.6085 145.635 61.518 145.725 61.518C145.816 61.4275 145.906 61.518 145.906 61.6989Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.183 66.9459C145.183 67.0363 145.092 67.1268 145.002 67.1268C144.911 67.1268 144.821 67.0363 144.821 66.9459C144.821 66.8554 144.911 66.7649 145.002 66.7649C145.092 66.7649 145.183 66.8554 145.183 66.9459Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.916 75.1781C143.916 75.359 143.735 75.5399 143.554 75.5399C143.373 75.5399 143.192 75.359 143.192 75.1781C143.192 74.9972 143.373 74.8162 143.554 74.8162C143.735 74.8162 143.916 74.9972 143.916 75.1781Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.645 76.0827C143.645 76.2637 143.554 76.3541 143.373 76.3541C143.193 76.3541 143.102 76.2637 143.102 76.0827C143.102 75.9018 143.193 75.8113 143.373 75.8113C143.554 75.8113 143.645 75.9923 143.645 76.0827Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.65 80.8773C142.65 80.9678 142.65 80.9678 142.559 80.9678C142.469 80.9678 142.469 80.9678 142.469 80.8773C142.469 80.7869 142.469 80.7869 142.559 80.7869L142.65 80.8773Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.378 77.6206C142.378 77.8015 142.197 77.9824 142.016 77.9824C141.835 77.9824 141.655 77.8015 141.655 77.6206C141.655 77.4397 141.835 77.2587 142.016 77.2587C142.197 77.2587 142.378 77.4397 142.378 77.6206Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.745 75.6304C141.895 75.6304 142.016 75.5089 142.016 75.359C142.016 75.2091 141.895 75.0876 141.745 75.0876C141.595 75.0876 141.474 75.2091 141.474 75.359C141.474 75.5089 141.595 75.6304 141.745 75.6304Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.474 72.5546C141.474 72.6451 141.383 72.7355 141.293 72.7355C141.202 72.7355 141.112 72.6451 141.112 72.5546C141.112 72.4641 141.202 72.3737 141.293 72.3737C141.383 72.3737 141.474 72.4641 141.474 72.5546Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.569 65.6793C140.569 65.7698 140.478 65.7698 140.569 65.6793C140.478 65.7698 140.388 65.6793 140.388 65.6793C140.388 65.6793 140.388 65.6793 140.569 65.6793C140.478 65.6793 140.569 65.6793 140.569 65.6793Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.479 64.9556C140.479 65.1366 140.298 65.227 140.207 65.227C140.026 65.227 139.936 65.0461 139.936 64.9556C139.936 64.7747 140.117 64.6842 140.207 64.6842C140.298 64.6842 140.479 64.7747 140.479 64.9556Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.207 63.7796C140.207 63.8701 140.117 63.8701 140.207 63.7796C140.026 63.8701 140.026 63.8701 140.026 63.7796C140.026 63.7796 140.026 63.6891 140.207 63.7796C140.117 63.6891 140.207 63.7796 140.207 63.7796Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.66 61.0657C140.66 61.2466 140.479 61.4275 140.298 61.4275C140.117 61.4275 139.936 61.2466 139.936 61.0657C139.936 60.8848 140.117 60.7038 140.298 60.7038C140.479 60.6134 140.66 60.7943 140.66 61.0657Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.745 63.5986C141.945 63.5986 142.107 63.4366 142.107 63.2368C142.107 63.0369 141.945 62.8749 141.745 62.8749C141.545 62.8749 141.383 63.0369 141.383 63.2368C141.383 63.4366 141.545 63.5986 141.745 63.5986Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.459 73.8211C144.509 73.8211 144.549 73.7806 144.549 73.7306C144.549 73.6807 144.509 73.6402 144.459 73.6402C144.409 73.6402 144.368 73.6807 144.368 73.7306C144.368 73.7806 144.409 73.8211 144.459 73.8211Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.65 67.76C142.799 67.76 142.921 67.6385 142.921 67.4886C142.921 67.3387 142.799 67.2172 142.65 67.2172C142.5 67.2172 142.378 67.3387 142.378 67.4886C142.378 67.6385 142.5 67.76 142.65 67.76Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.835 62.3319C141.835 62.3319 141.745 62.3319 141.835 62.3319C141.745 62.3319 141.745 62.3319 141.835 62.3319C141.745 62.3319 141.745 62.242 141.835 62.3319C141.745 62.242 141.835 62.3319 141.835 62.3319Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.202 58.8945C141.352 58.8945 141.474 58.773 141.474 58.6231C141.474 58.4732 141.352 58.3517 141.202 58.3517C141.052 58.3517 140.931 58.4732 140.931 58.6231C140.931 58.773 141.052 58.8945 141.202 58.8945Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.021 56.9948C141.121 56.9948 141.202 56.9138 141.202 56.8139C141.202 56.7139 141.121 56.6329 141.021 56.6329C140.921 56.6329 140.84 56.7139 140.84 56.8139C140.84 56.9138 140.921 56.9948 141.021 56.9948Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.112 51.386C141.112 51.4765 141.021 51.4765 141.021 51.4765L140.931 51.386C140.931 51.2955 141.021 51.2955 141.021 51.2955C141.021 51.2955 141.112 51.2955 141.112 51.386Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.831 48.3102C143.03 48.3102 143.192 48.1482 143.192 47.9484C143.192 47.7485 143.03 47.5865 142.831 47.5865C142.631 47.5865 142.469 47.7485 142.469 47.9484C142.469 48.1482 142.631 48.3102 142.831 48.3102Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.549 45.7772C144.549 45.9582 144.459 46.0486 144.278 46.0486C144.097 46.0486 144.007 45.9582 144.007 45.7772C144.007 45.5963 144.097 45.5058 144.278 45.5058C144.368 45.5058 144.549 45.6868 144.549 45.7772Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.767 43.1538C155.767 43.3347 155.586 43.5156 155.405 43.5156C155.224 43.5156 155.043 43.3347 155.043 43.1538C155.043 42.9728 155.224 42.7919 155.405 42.7919C155.586 42.7919 155.767 42.9728 155.767 43.1538Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.818 50.4814C163.818 50.5718 163.728 50.6623 163.637 50.6623C163.547 50.6623 163.457 50.5718 163.457 50.4814C163.457 50.3909 163.547 50.3004 163.637 50.3004C163.728 50.3004 163.818 50.3909 163.818 50.4814Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.28 51.2051C162.28 51.2051 162.28 51.2955 162.28 51.2051C162.099 51.2955 162.099 51.2955 162.099 51.2051C162.099 51.1146 162.19 51.1146 162.28 51.2051C162.28 51.1146 162.28 51.1146 162.28 51.2051Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.381 51.8383C160.381 52.1097 160.2 52.2907 159.928 52.2907C159.657 52.2907 159.476 52.1097 159.476 51.8383C159.476 51.5669 159.657 51.386 159.928 51.386C160.2 51.4765 160.381 51.6574 160.381 51.8383Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.757 49.8481C157.757 50.029 157.576 50.1195 157.486 50.1195C157.305 50.1195 157.214 49.9386 157.214 49.8481C157.214 49.6672 157.395 49.5767 157.486 49.5767C157.667 49.4862 157.757 49.6672 157.757 49.8481Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.315 50.8432C155.315 50.9337 155.224 51.0242 155.134 51.0242C155.043 51.0242 154.953 50.9337 154.953 50.8432C154.953 50.7528 155.043 50.6623 155.134 50.6623C155.224 50.6623 155.315 50.7528 155.315 50.8432Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.063 53.6476C151.113 53.6476 151.153 53.6071 151.153 53.5571C151.153 53.5072 151.113 53.4667 151.063 53.4667C151.013 53.4667 150.972 53.5072 150.972 53.5571C150.972 53.6071 151.013 53.6476 151.063 53.6476Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.887 57.0852C149.887 57.2662 149.706 57.4471 149.525 57.4471C149.344 57.4471 149.163 57.2662 149.163 57.0852C149.163 56.9043 149.344 56.7234 149.525 56.7234C149.706 56.7234 149.887 56.9043 149.887 57.0852Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.755 46.9533C176.755 47.0438 176.664 47.0438 176.664 47.0438C176.574 47.0438 176.574 46.9533 176.574 46.9533C176.574 46.8628 176.664 46.8628 176.664 46.8628C176.755 46.8628 176.755 46.9533 176.755 46.9533Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.412 49.5767C172.412 49.6672 172.322 49.7577 172.231 49.7577C172.141 49.7577 172.051 49.6672 172.051 49.5767C172.051 49.4863 172.141 49.3958 172.231 49.3958C172.322 49.3958 172.412 49.4863 172.412 49.5767Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.092 58.4422C182.092 58.5327 182.002 58.6231 181.911 58.6231C181.821 58.6231 181.73 58.5327 181.73 58.4422C181.73 58.3518 181.821 58.2613 181.911 58.2613C182.002 58.2613 182.092 58.3518 182.092 58.4422Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.686 59.9801C190.836 59.9801 190.958 59.8586 190.958 59.7087C190.958 59.5588 190.836 59.4373 190.686 59.4373C190.536 59.4373 190.415 59.5588 190.415 59.7087C190.415 59.8586 190.536 59.9801 190.686 59.9801Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.053 53.5571C190.053 53.6476 190.053 53.6476 189.962 53.6476C189.872 53.6476 189.872 53.6476 189.872 53.5571C189.872 53.4667 189.872 53.4667 189.962 53.4667L190.053 53.5571Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.762 48.853C193.762 48.9435 193.671 49.0339 193.581 49.0339C193.49 49.0339 193.4 48.9435 193.4 48.853C193.4 48.7626 193.49 48.6721 193.581 48.6721C193.671 48.7626 193.762 48.7626 193.762 48.853Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.877 40.8022C188.786 40.8933 188.786 40.8022 188.786 40.8022C188.786 40.7111 188.786 40.7111 188.877 40.8022C188.877 40.7111 188.877 40.7111 188.877 40.8022Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.324 38.9924C190.424 38.9924 190.505 38.9114 190.505 38.8115C190.505 38.7116 190.424 38.6306 190.324 38.6306C190.224 38.6306 190.143 38.7116 190.143 38.8115C190.143 38.9114 190.224 38.9924 190.324 38.9924Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.334 41.435C188.334 41.5254 188.244 41.6159 188.153 41.6159C188.063 41.6159 187.972 41.5254 187.972 41.435C187.972 41.3445 188.063 41.254 188.153 41.254C188.244 41.254 188.334 41.3445 188.334 41.435Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.153 42.1586C188.153 42.2491 188.063 42.2491 188.063 42.2491C187.972 42.2491 187.972 42.1586 187.972 42.1586C187.972 42.0682 188.063 42.0682 188.063 42.0682L188.153 42.1586Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.143 40.8921C190.293 40.8921 190.415 40.7706 190.415 40.6208C190.415 40.4709 190.293 40.3494 190.143 40.3494C189.993 40.3494 189.872 40.4709 189.872 40.6208C189.872 40.7706 189.993 40.8921 190.143 40.8921Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.173 83.1389C147.273 83.1389 147.354 83.0579 147.354 82.958C147.354 82.858 147.273 82.777 147.173 82.777C147.073 82.777 146.992 82.858 146.992 82.958C146.992 83.0579 147.073 83.1389 147.173 83.1389Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.444 84.4054C147.444 84.4959 147.354 84.4959 147.354 84.4959C147.263 84.4959 147.263 84.4054 147.263 84.4054C147.263 84.3149 147.354 84.3149 147.354 84.3149C147.444 84.3149 147.444 84.3149 147.444 84.4054Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.782 78.2539C152.782 78.3443 152.691 78.4348 152.601 78.4348C152.51 78.4348 152.42 78.3443 152.42 78.2539C152.42 78.1634 152.51 78.0729 152.601 78.0729C152.691 78.1634 152.782 78.1634 152.782 78.2539Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.987 86.2147C148.087 86.2147 148.168 86.1337 148.168 86.0337C148.168 85.9338 148.087 85.8528 147.987 85.8528C147.887 85.8528 147.806 85.9338 147.806 86.0337C147.806 86.1337 147.887 86.2147 147.987 86.2147Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.61 86.486C150.61 86.5765 150.52 86.667 150.429 86.667C150.339 86.667 150.249 86.5765 150.249 86.486C150.249 86.3956 150.339 86.3051 150.429 86.3051C150.52 86.3051 150.61 86.3956 150.61 86.486Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.41 89.6523C154.41 89.8333 154.32 89.9237 154.139 89.9237C153.958 89.9237 153.867 89.8333 153.867 89.6523C153.867 89.4714 153.958 89.381 154.139 89.381C154.32 89.381 154.41 89.5619 154.41 89.6523Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.857 86.3052C155.857 86.3956 155.767 86.4861 155.677 86.4861C155.586 86.4861 155.496 86.3956 155.496 86.3052C155.496 86.2147 155.586 86.1242 155.677 86.1242C155.767 86.1242 155.857 86.2147 155.857 86.3052Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.767 84.134C155.867 84.134 155.948 84.053 155.948 83.9531C155.948 83.8532 155.867 83.7722 155.767 83.7722C155.667 83.7722 155.586 83.8532 155.586 83.9531C155.586 84.053 155.667 84.134 155.767 84.134Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.772 88.1145C154.772 88.2954 154.681 88.3859 154.5 88.3859C154.319 88.3859 154.229 88.2954 154.229 88.1145C154.229 87.9335 154.319 87.8431 154.5 87.8431C154.681 87.8431 154.772 87.9335 154.772 88.1145Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.601 90.1047C152.8 90.1047 152.962 89.9427 152.962 89.7428C152.962 89.543 152.8 89.381 152.601 89.381C152.401 89.381 152.239 89.543 152.239 89.7428C152.239 89.9427 152.401 90.1047 152.601 90.1047Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.591 86.3957C154.641 86.3957 154.681 86.3552 154.681 86.3052C154.681 86.2552 154.641 86.2147 154.591 86.2147C154.541 86.2147 154.5 86.2552 154.5 86.3052C154.5 86.3552 154.541 86.3957 154.591 86.3957Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.677 84.7673C155.677 84.9482 155.586 85.0387 155.405 85.0387C155.224 85.0387 155.134 84.9482 155.134 84.7673C155.134 84.5863 155.224 84.4959 155.405 84.4959C155.586 84.4959 155.677 84.6768 155.677 84.7673Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.676 84.3149C155.826 84.3149 155.948 84.1934 155.948 84.0436C155.948 83.8937 155.826 83.7722 155.676 83.7722C155.527 83.7722 155.405 83.8937 155.405 84.0436C155.405 84.1934 155.527 84.3149 155.676 84.3149Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.591 81.3296C154.591 81.4201 154.5 81.5106 154.41 81.5106C154.319 81.5106 154.229 81.4201 154.229 81.3296C154.229 81.2392 154.319 81.1487 154.41 81.1487C154.5 81.1487 154.591 81.2392 154.591 81.3296Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.691 79.6108C152.691 79.7013 152.691 79.7013 152.691 79.6108C152.601 79.7013 152.51 79.6108 152.51 79.6108C152.51 79.6108 152.601 79.6108 152.691 79.6108Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.525 77.6206C149.675 77.6206 149.796 77.4991 149.796 77.3492C149.796 77.1994 149.675 77.0779 149.525 77.0779C149.375 77.0779 149.254 77.1994 149.254 77.3492C149.254 77.4991 149.375 77.6206 149.525 77.6206Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.526 75.7211C149.435 75.8122 149.435 75.7211 149.435 75.7211C149.435 75.7211 149.526 75.63 149.526 75.7211C149.526 75.63 149.526 75.7211 149.526 75.7211Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.344 75.8113C149.344 75.9018 149.254 75.9923 149.163 75.9923C149.073 75.9923 148.982 75.9018 148.982 75.8113C148.982 75.7209 149.073 75.6304 149.163 75.6304C149.254 75.6304 149.344 75.7209 149.344 75.8113Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.53 74.7258C148.53 74.9067 148.349 75.0876 148.168 75.0876C147.987 75.0876 147.806 74.9067 147.806 74.7258C147.806 74.5449 147.987 74.3639 148.168 74.3639C148.349 74.3639 148.53 74.5449 148.53 74.7258Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.62 69.3884C148.67 69.3884 148.711 69.3479 148.711 69.2979C148.711 69.248 148.67 69.2075 148.62 69.2075C148.57 69.2075 148.53 69.248 148.53 69.2979C148.53 69.3479 148.57 69.3884 148.62 69.3884Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.253 66.4935C149.253 66.584 149.163 66.7649 148.982 66.7649C148.801 66.7649 148.711 66.6744 148.711 66.4935C148.711 66.403 148.801 66.2221 148.982 66.2221C149.163 66.2221 149.253 66.403 149.253 66.4935Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.434 63.1464C149.434 63.2363 149.434 63.2363 149.434 63.1464C149.344 63.2363 149.344 63.2363 149.434 63.1464C149.344 63.1464 149.344 63.1464 149.434 63.1464Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.716 68.6646C147.716 68.8456 147.625 68.936 147.444 68.936C147.263 68.936 147.173 68.8456 147.173 68.6646C147.173 68.4837 147.263 68.3932 147.444 68.3932C147.625 68.4837 147.716 68.5742 147.716 68.6646Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.173 72.0118C147.423 72.0118 147.625 71.8093 147.625 71.5595C147.625 71.3097 147.423 71.1072 147.173 71.1072C146.923 71.1072 146.72 71.3097 146.72 71.5595C146.72 71.8093 146.923 72.0118 147.173 72.0118Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.535 73.7306C147.535 73.8211 147.444 73.8211 147.444 73.8211L147.354 73.7306L147.444 73.6402C147.444 73.6402 147.535 73.6402 147.535 73.7306Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.163 75.6304C149.163 75.8113 149.073 75.9018 148.892 75.9018C148.711 75.9018 148.62 75.8113 148.62 75.6304C148.62 75.4495 148.711 75.359 148.892 75.359C149.073 75.359 149.163 75.4495 149.163 75.6304Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.207 78.4348C177.257 78.4348 177.297 78.3943 177.297 78.3443C177.297 78.2943 177.257 78.2538 177.207 78.2538C177.157 78.2538 177.116 78.2943 177.116 78.3443C177.116 78.3943 177.157 78.4348 177.207 78.4348Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.931 77.5301C177.931 77.711 177.84 77.8015 177.659 77.8015C177.478 77.8015 177.388 77.711 177.388 77.5301C177.388 77.3492 177.478 77.2587 177.659 77.2587C177.75 77.2587 177.931 77.3492 177.931 77.5301Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.102 73.0974C180.102 73.1879 180.011 73.2783 179.921 73.2783C179.83 73.2783 179.74 73.1879 179.74 73.0974C179.74 73.0069 179.83 72.9165 179.921 72.9165C180.011 72.9165 180.102 72.9165 180.102 73.0974Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.901 56.1806C183.901 56.3615 183.72 56.5425 183.539 56.5425C183.358 56.5425 183.177 56.3615 183.177 56.1806C183.177 55.9997 183.358 55.8188 183.539 55.8188C183.72 55.8188 183.901 55.9997 183.901 56.1806Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.234 86.2147C190.484 86.2147 190.686 86.0122 190.686 85.7624C190.686 85.5126 190.484 85.3101 190.234 85.3101C189.984 85.3101 189.781 85.5126 189.781 85.7624C189.781 86.0122 189.984 86.2147 190.234 86.2147Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.772 88.024C191.772 88.2049 191.591 88.3858 191.41 88.3858C191.229 88.3858 191.048 88.2049 191.048 88.024C191.048 87.843 191.229 87.6621 191.41 87.6621C191.591 87.6621 191.772 87.843 191.772 88.024Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.872 84.2245C189.922 84.2245 189.962 84.184 189.962 84.134C189.962 84.084 189.922 84.0435 189.872 84.0435C189.822 84.0435 189.781 84.084 189.781 84.134C189.781 84.184 189.822 84.2245 189.872 84.2245Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.515 81.782C188.615 81.782 188.696 81.701 188.696 81.601C188.696 81.5011 188.615 81.4201 188.515 81.4201C188.415 81.4201 188.334 81.5011 188.334 81.601C188.334 81.701 188.415 81.782 188.515 81.782Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.601 83.4103C189.701 83.4103 189.782 83.3293 189.782 83.2294C189.782 83.1295 189.701 83.0485 189.601 83.0485C189.501 83.0485 189.42 83.1295 189.42 83.2294C189.42 83.3293 189.501 83.4103 189.601 83.4103Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.953 85.5815C191.953 85.7624 191.862 85.8528 191.681 85.8528C191.5 85.8528 191.41 85.7624 191.41 85.5815C191.41 85.4005 191.5 85.3101 191.681 85.3101C191.862 85.4005 191.953 85.491 191.953 85.5815Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.229 84.5863C191.229 84.6768 191.138 84.6768 191.138 84.6768C191.048 84.6768 191.048 84.5863 191.048 84.5863C191.048 84.4959 191.138 84.4959 191.138 84.4959C191.229 84.4054 191.229 84.4959 191.229 84.5863Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.415 82.8675C190.415 83.0485 190.234 83.2294 190.053 83.2294C189.872 83.2294 189.691 83.0485 189.691 82.8675C189.691 82.6866 189.872 82.5057 190.053 82.5057C190.234 82.5057 190.415 82.5961 190.415 82.8675Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.701 79.249C187.701 79.3395 187.61 79.5204 187.429 79.5204C187.339 79.5204 187.158 79.4299 187.158 79.249C187.158 79.0681 187.248 78.9776 187.429 78.9776C187.61 79.0681 187.701 79.1585 187.701 79.249Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.163 77.8016C186.163 77.9825 185.982 78.1634 185.801 78.1634C185.62 78.1634 185.439 77.9825 185.439 77.8016C185.439 77.6206 185.62 77.4397 185.801 77.4397C185.982 77.4397 186.163 77.6206 186.163 77.8016Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.435 77.2587C186.435 77.3498 186.435 77.3498 186.435 77.2587C186.344 77.3498 186.344 77.2587 186.344 77.2587C186.344 77.2587 186.344 77.2587 186.435 77.2587Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.424 77.6206C188.474 77.6206 188.515 77.5801 188.515 77.5302C188.515 77.4802 188.474 77.4397 188.424 77.4397C188.374 77.4397 188.334 77.4802 188.334 77.5302C188.334 77.5801 188.374 77.6206 188.424 77.6206Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.063 75.9925C188.063 75.9925 188.063 76.0837 188.063 75.9925C187.972 76.0837 187.972 75.9925 187.972 75.9925C187.972 75.9925 187.972 75.9014 188.063 75.9925C188.063 75.9014 188.063 75.9925 188.063 75.9925Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.158 73.8211C187.308 73.8211 187.429 73.6996 187.429 73.5497C187.429 73.3998 187.308 73.2783 187.158 73.2783C187.008 73.2783 186.886 73.3998 186.886 73.5497C186.886 73.6996 187.008 73.8211 187.158 73.8211Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.239 78.9776C189.239 79.068 189.148 79.249 188.967 79.249C188.877 79.249 188.696 79.1585 188.696 78.9776C188.696 78.8871 188.786 78.7062 188.967 78.7062C189.148 78.7966 189.239 78.8871 189.239 78.9776Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.591 75.9018C191.791 75.9018 191.953 75.7398 191.953 75.5399C191.953 75.3401 191.791 75.1781 191.591 75.1781C191.391 75.1781 191.229 75.3401 191.229 75.5399C191.229 75.7398 191.391 75.9018 191.591 75.9018Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.596 86.3957C190.596 86.4861 190.505 86.5766 190.415 86.5766C190.324 86.5766 190.234 86.4861 190.234 86.3957C190.234 86.3052 190.324 86.2147 190.415 86.2147C190.505 86.2147 190.596 86.3052 190.596 86.3957Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.862 86.8479C191.862 86.9384 191.772 86.9384 191.862 86.8479C191.772 86.9384 191.772 86.8479 191.772 86.8479C191.681 86.8479 191.681 86.7575 191.862 86.8479C191.772 86.7575 191.862 86.8479 191.862 86.8479Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.028 87.5717C195.028 87.7526 194.847 87.9335 194.667 87.9335C194.486 87.9335 194.305 87.7526 194.305 87.5717C194.305 87.3907 194.486 87.2098 194.667 87.2098C194.938 87.2098 195.028 87.3907 195.028 87.5717Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.571 87.5717C195.571 87.6621 195.481 87.6621 195.481 87.6621L195.39 87.5717C195.39 87.4812 195.481 87.4812 195.481 87.4812L195.571 87.5717Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.009 88.9287C199.259 88.9287 199.461 88.7261 199.461 88.4763C199.461 88.2265 199.259 88.024 199.009 88.024C198.759 88.024 198.556 88.2265 198.556 88.4763C198.556 88.7261 198.759 88.9287 199.009 88.9287Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.789 89.9237C206.789 90.1047 206.608 90.1951 206.517 90.1951C206.336 90.1951 206.246 90.0142 206.246 89.9237C206.246 89.8333 206.427 89.6523 206.517 89.6523C206.608 89.6523 206.789 89.8333 206.789 89.9237Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.236 90.376C208.236 90.4665 208.146 90.4665 208.236 90.376C208.146 90.4665 208.146 90.376 208.146 90.376C208.055 90.376 208.146 90.376 208.236 90.376C208.146 90.376 208.236 90.376 208.236 90.376Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.894 91.0093C204.044 91.0093 204.165 90.8878 204.165 90.7379C204.165 90.588 204.044 90.4665 203.894 90.4665C203.744 90.4665 203.623 90.588 203.623 90.7379C203.623 90.8878 203.744 91.0093 203.894 91.0093Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.004 89.4714C200.004 89.6523 199.823 89.7428 199.733 89.7428C199.552 89.7428 199.461 89.5619 199.461 89.4714C199.461 89.3809 199.642 89.2 199.733 89.2C199.914 89.2 200.004 89.2905 200.004 89.4714Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.265 89.1096C202.265 89.2905 202.085 89.4714 201.904 89.4714C201.723 89.4714 201.542 89.2905 201.542 89.1096C201.542 88.9286 201.723 88.7477 201.904 88.7477C202.085 88.7477 202.265 88.9286 202.265 89.1096Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.336 88.6572C206.336 88.7477 206.246 88.8382 206.156 88.8382C206.065 88.8382 205.975 88.7477 205.975 88.6572C205.975 88.5668 206.065 88.4763 206.156 88.4763C206.246 88.3859 206.336 88.4763 206.336 88.6572Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.874 88.024C208.024 88.024 208.146 87.9025 208.146 87.7526C208.146 87.6027 208.024 87.4812 207.874 87.4812C207.725 87.4812 207.603 87.6027 207.603 87.7526C207.603 87.9025 207.725 88.024 207.874 88.024Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.679 88.6573C210.679 88.8382 210.498 89.0191 210.317 89.0191C210.136 89.0191 209.955 88.8382 209.955 88.6573C209.955 88.4763 210.136 88.2954 210.317 88.2954C210.498 88.2954 210.679 88.3859 210.679 88.6573Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.598 91.733C208.598 91.8235 208.507 91.9139 208.417 91.9139C208.327 91.9139 208.236 91.8235 208.236 91.733C208.236 91.6425 208.327 91.5521 208.417 91.5521C208.598 91.5521 208.598 91.6425 208.598 91.733Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.945 93.09C211.995 93.09 212.036 93.0495 212.036 92.9995C212.036 92.9495 211.995 92.909 211.945 92.909C211.895 92.909 211.855 92.9495 211.855 92.9995C211.855 93.0495 211.895 93.09 211.945 93.09Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.197 92.5471C216.197 92.7281 216.107 92.8185 215.926 92.8185C215.745 92.8185 215.654 92.7281 215.654 92.5471C215.654 92.3662 215.745 92.2758 215.926 92.2758C216.107 92.2758 216.197 92.4567 216.197 92.5471Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.463 87.7526C217.463 87.9335 217.373 88.024 217.192 88.024C217.011 88.024 216.921 87.9335 216.921 87.7526C216.921 87.5717 217.011 87.4812 217.192 87.4812C217.373 87.4812 217.463 87.6621 217.463 87.7526Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.664 82.0533C213.664 82.2343 213.573 82.3247 213.393 82.3247C213.212 82.3247 213.121 82.2343 213.121 82.0533C213.121 81.8724 213.212 81.782 213.393 81.782C213.573 81.782 213.664 81.8724 213.664 82.0533Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.664 84.7673C213.664 84.9482 213.483 85.1291 213.302 85.1291C213.121 85.1291 212.94 84.9482 212.94 84.7673C212.94 84.5863 213.121 84.4054 213.302 84.4054C213.483 84.4959 213.664 84.5863 213.664 84.7673Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.85 84.134C212.85 84.315 212.759 84.4054 212.579 84.4054C212.398 84.4054 212.307 84.315 212.307 84.134C212.307 83.9531 212.398 83.8626 212.579 83.8626C212.759 83.8626 212.85 83.9531 212.85 84.134Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.884 82.5057C205.984 82.5057 206.065 82.4247 206.065 82.3248C206.065 82.2248 205.984 82.1438 205.884 82.1438C205.784 82.1438 205.703 82.2248 205.703 82.3248C205.703 82.4247 205.784 82.5057 205.884 82.5057Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.713 82.1438C203.713 82.2343 203.622 82.3247 203.532 82.3247C203.442 82.3247 203.351 82.2343 203.351 82.1438C203.351 82.0534 203.442 81.9629 203.532 81.9629C203.622 81.9629 203.713 82.0534 203.713 82.1438Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.151 84.1341C207.351 84.1341 207.513 83.972 207.513 83.7722C207.513 83.5723 207.351 83.4103 207.151 83.4103C206.951 83.4103 206.789 83.5723 206.789 83.7722C206.789 83.972 206.951 84.1341 207.151 84.1341Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.337 85.5814C206.337 85.8528 206.156 86.0338 205.884 86.0338C205.613 86.0338 205.432 85.8528 205.432 85.5814C205.432 85.31 205.613 85.1291 205.884 85.1291C206.065 85.1291 206.337 85.31 206.337 85.5814Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.517 84.4959C206.517 84.5858 206.517 84.5858 206.517 84.4959C206.427 84.5858 206.427 84.5858 206.517 84.4959C206.427 84.4959 206.427 84.4959 206.517 84.4959Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.371 80.5155C199.371 80.6059 199.371 80.6059 199.28 80.6059C199.19 80.6059 199.19 80.6059 199.19 80.5155C199.19 80.425 199.19 80.425 199.28 80.425C199.371 80.425 199.371 80.425 199.371 80.5155Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.39 74.5448C195.39 74.7258 195.209 74.9067 195.028 74.9067C194.847 74.9067 194.667 74.7258 194.667 74.5448C194.667 74.3639 194.847 74.183 195.028 74.183C195.3 74.183 195.39 74.3639 195.39 74.5448Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.938 73.9112C194.848 73.9112 194.848 73.9112 194.938 73.9112C194.848 73.8212 194.848 73.8212 194.938 73.9112C194.938 73.8212 194.938 73.8212 194.938 73.9112Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.214 65.6794C194.214 65.8603 194.033 66.0412 193.852 66.0412C193.671 66.0412 193.49 65.8603 193.49 65.6794C193.49 65.4984 193.671 65.3175 193.852 65.3175C194.033 65.3175 194.214 65.408 194.214 65.6794Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.087 82.3247C220.287 82.3247 220.449 82.1627 220.449 81.9629C220.449 81.763 220.287 81.601 220.087 81.601C219.887 81.601 219.725 81.763 219.725 81.9629C219.725 82.1627 219.887 82.3247 220.087 82.3247Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.938 89.5619C194.938 89.7428 194.757 89.9237 194.576 89.9237C194.395 89.9237 194.214 89.7428 194.214 89.5619C194.214 89.3809 194.395 89.2 194.576 89.2C194.757 89.2 194.938 89.3809 194.938 89.5619Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.742 88.7477C197.792 88.7477 197.833 88.7072 197.833 88.6572C197.833 88.6073 197.792 88.5668 197.742 88.5668C197.692 88.5668 197.652 88.6073 197.652 88.6572C197.652 88.7072 197.692 88.7477 197.742 88.7477Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.671 86.8479C193.671 86.9384 193.581 86.9384 193.581 86.9384C193.49 86.9384 193.49 86.8479 193.49 86.8479L193.581 86.7575C193.581 86.7575 193.671 86.8479 193.671 86.8479Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.405 86.3052C192.555 86.3052 192.676 86.1837 192.676 86.0338C192.676 85.8839 192.555 85.7624 192.405 85.7624C192.255 85.7624 192.134 85.8839 192.134 86.0338C192.134 86.1837 192.255 86.3052 192.405 86.3052Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.34 61.2471C187.249 61.3382 187.249 61.2471 187.249 61.2471C187.249 61.156 187.249 61.156 187.34 61.2471C187.34 61.156 187.34 61.156 187.34 61.2471Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.173 65.5889C184.373 65.5889 184.535 65.4268 184.535 65.227C184.535 65.0272 184.373 64.8651 184.173 64.8651C183.973 64.8651 183.811 65.0272 183.811 65.227C183.811 65.4268 183.973 65.5889 184.173 65.5889Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.449 66.4935C183.449 66.6744 183.359 66.7649 183.178 66.7649C182.997 66.7649 182.906 66.6744 182.906 66.4935C182.906 66.3126 182.997 66.2221 183.178 66.2221C183.359 66.2221 183.449 66.3126 183.449 66.4935Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.916 70.3835C180.916 70.6549 180.735 70.8358 180.464 70.8358C180.192 70.8358 180.011 70.6549 180.011 70.3835C180.011 70.1121 180.192 69.9312 180.464 69.9312C180.735 69.9312 180.916 70.1121 180.916 70.3835Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.102 71.1976C180.102 71.3786 180.011 71.469 179.83 71.469C179.65 71.469 179.559 71.3786 179.559 71.1976C179.559 71.0167 179.65 70.9262 179.83 70.9262C179.921 71.0167 180.102 71.1072 180.102 71.1976Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.74 72.1023C179.74 72.2832 179.559 72.4642 179.378 72.4642C179.197 72.4642 179.016 72.2832 179.016 72.1023C179.016 71.9214 179.197 71.7404 179.378 71.7404C179.559 71.7404 179.74 71.9214 179.74 72.1023Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.217 75.1781C175.217 75.2686 175.126 75.2686 175.126 75.2686C175.036 75.2686 175.036 75.1781 175.036 75.1781C175.036 75.0876 175.126 75.0876 175.126 75.0876C175.126 74.9972 175.217 75.0876 175.217 75.1781Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.478 72.3737C177.478 72.4642 177.388 72.4642 177.388 72.4642C177.297 72.4642 177.297 72.3737 177.297 72.3737C177.297 72.2832 177.388 72.2832 177.388 72.2832C177.388 72.1928 177.478 72.2832 177.478 72.3737Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.578 71.2881C175.578 71.5595 175.398 71.7404 175.126 71.7404C174.855 71.7404 174.674 71.5595 174.674 71.2881C174.674 71.0167 174.855 70.8358 175.126 70.8358C175.398 70.8358 175.578 71.0167 175.578 71.2881Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.906 67.5791C182.906 67.6696 182.816 67.76 182.725 67.76C182.635 67.76 182.544 67.6696 182.544 67.5791C182.544 67.4886 182.635 67.3982 182.725 67.3982C182.816 67.3982 182.906 67.4886 182.906 67.5791Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.067 64.3224C187.067 64.5033 186.977 64.5938 186.796 64.5938C186.615 64.5938 186.525 64.5033 186.525 64.3224C186.525 64.1415 186.615 64.051 186.796 64.051C186.977 64.051 187.067 64.1415 187.067 64.3224Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.686 61.337C190.686 61.4275 190.596 61.4275 190.596 61.4275C190.505 61.4275 190.505 61.337 190.505 61.337C190.505 61.2466 190.596 61.2466 190.596 61.2466C190.596 61.2466 190.686 61.2466 190.686 61.337Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.072 61.8798C186.072 62.0608 185.891 62.2417 185.71 62.2417C185.53 62.2417 185.349 62.0608 185.349 61.8798C185.349 61.6989 185.53 61.518 185.71 61.518C185.891 61.518 186.072 61.6989 186.072 61.8798Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.168 55.4569C185.168 55.4569 185.168 55.5474 185.168 55.4569C185.077 55.5474 184.987 55.5474 184.987 55.4569C185.077 55.3664 185.077 55.3664 185.168 55.4569C185.168 55.3664 185.168 55.3664 185.168 55.4569Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.258 53.0144C185.258 53.1953 185.168 53.2858 184.987 53.2858C184.806 53.2858 184.716 53.1953 184.716 53.0144C184.716 52.8334 184.806 52.743 184.987 52.743C185.168 52.743 185.258 52.9239 185.258 53.0144Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.891 49.7576C185.891 49.9386 185.711 50.1195 185.53 50.1195C185.349 50.1195 185.168 49.9386 185.168 49.7576C185.168 49.5767 185.349 49.3958 185.53 49.3958C185.711 49.3053 185.891 49.4863 185.891 49.7576Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.454 50.7528C182.454 50.9337 182.363 51.0242 182.183 51.0242C182.002 51.0242 181.911 50.9337 181.911 50.7528C181.911 50.5718 182.002 50.4814 182.183 50.4814C182.363 50.3909 182.454 50.5718 182.454 50.7528Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.987 50.9337C184.987 51.0241 184.987 51.0241 184.896 51.0241C184.806 51.0241 184.806 51.0241 184.806 50.9337C184.806 50.8432 184.806 50.8432 184.896 50.8432C184.896 50.8432 184.987 50.9337 184.987 50.9337Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.926 52.562C178.926 52.6525 178.835 52.6525 178.835 52.6525C178.745 52.6525 178.745 52.562 178.745 52.562C178.745 52.4716 178.835 52.4716 178.835 52.4716C178.835 52.4716 178.926 52.4716 178.926 52.562Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.183 51.0242C182.332 51.0242 182.454 50.9027 182.454 50.7528C182.454 50.6029 182.332 50.4814 182.183 50.4814C182.033 50.4814 181.911 50.6029 181.911 50.7528C181.911 50.9027 182.033 51.0242 182.183 51.0242Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.901 51.1146C183.901 51.2051 183.811 51.2956 183.72 51.2956C183.63 51.2956 183.54 51.2051 183.54 51.1146C183.54 51.0242 183.63 50.9337 183.72 50.9337C183.811 50.9337 183.901 51.0242 183.901 51.1146Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.73 54.4618C181.73 54.5523 181.64 54.5523 181.64 54.5523C181.549 54.5523 181.549 54.4618 181.549 54.4618C181.549 54.3713 181.64 54.3713 181.64 54.3713C181.73 54.3713 181.73 54.4618 181.73 54.4618Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.222 62.694C174.222 62.7845 174.131 62.8749 174.041 62.8749C173.95 62.8749 173.86 62.7845 173.86 62.694C173.86 62.6035 173.95 62.5131 174.041 62.5131C174.222 62.5131 174.222 62.6035 174.222 62.694Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.539 56.8134C183.449 56.8134 183.449 56.8134 183.539 56.8134C183.449 56.7235 183.449 56.7235 183.539 56.8134C183.539 56.7235 183.539 56.7235 183.539 56.8134Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.625 56.7234C184.675 56.7234 184.716 56.6829 184.716 56.6329C184.716 56.583 184.675 56.5424 184.625 56.5424C184.575 56.5424 184.535 56.583 184.535 56.6329C184.535 56.6829 184.575 56.7234 184.625 56.7234Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.835 63.5082C178.835 63.5987 178.745 63.5987 178.745 63.5987C178.654 63.5987 178.654 63.5082 178.654 63.5082C178.654 63.4177 178.745 63.4177 178.745 63.4177L178.835 63.5082Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.153 54.2809C188.253 54.2809 188.334 54.1999 188.334 54.0999C188.334 54 188.253 53.919 188.153 53.919C188.053 53.919 187.972 54 187.972 54.0999C187.972 54.1999 188.053 54.2809 188.153 54.2809Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.424 57.1757C188.424 57.3566 188.243 57.628 187.972 57.628C187.791 57.628 187.52 57.4471 187.52 57.1757C187.52 56.9948 187.701 56.7234 187.972 56.7234C188.243 56.7234 188.424 56.9043 188.424 57.1757Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.733 58.0806C162.733 58.0806 162.642 58.0806 162.733 58.0806C162.642 58.1717 162.642 58.0806 162.642 58.0806C162.642 58.0806 162.642 57.9895 162.733 58.0806C162.642 57.9895 162.733 58.0806 162.733 58.0806Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.351 56.9948C166.351 57.0852 166.261 57.2662 166.08 57.2662C165.899 57.2662 165.809 57.1757 165.809 56.9948C165.809 56.9043 165.899 56.7234 166.08 56.7234C166.261 56.7234 166.351 56.9043 166.351 56.9948Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.165 56.6329C167.165 56.7229 167.165 56.7229 167.165 56.6329C167.075 56.7229 167.075 56.7229 167.165 56.6329C167.075 56.6329 167.075 56.6329 167.165 56.6329Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.09 64.051C164.09 64.1415 163.999 64.1415 163.999 64.1415C163.909 64.1415 163.909 64.051 163.909 64.051C163.909 63.9606 163.999 63.9606 163.999 63.9606C163.999 63.8701 164.09 63.9606 164.09 64.051Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.899 62.6035C165.899 62.694 165.809 62.8749 165.628 62.8749C165.537 62.8749 165.356 62.7845 165.356 62.6035C165.356 62.5131 165.447 62.3322 165.628 62.3322C165.809 62.3322 165.899 62.5131 165.899 62.6035Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.806 61.4275C184.856 61.4275 184.897 61.387 184.897 61.337C184.897 61.2871 184.856 61.2466 184.806 61.2466C184.756 61.2466 184.716 61.2871 184.716 61.337C184.716 61.387 184.756 61.4275 184.806 61.4275Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.401 57.7185C193.401 57.8096 193.401 57.8096 193.401 57.7185C193.31 57.8096 193.31 57.7185 193.31 57.7185C193.31 57.7185 193.31 57.7185 193.401 57.7185Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.767 59.4373C192.767 59.6183 192.586 59.7992 192.405 59.7992C192.224 59.7992 192.043 59.6183 192.043 59.4373C192.043 59.2564 192.224 59.0755 192.405 59.0755C192.586 59.0755 192.767 59.2564 192.767 59.4373Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.158 52.8335C187.158 52.9239 187.068 52.9239 187.068 52.9239L186.977 52.8335C186.977 52.743 187.068 52.743 187.068 52.743L187.158 52.8335Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.953 57.7185C191.953 57.809 191.862 57.8995 191.772 57.8995C191.681 57.8995 191.591 57.809 191.591 57.7185C191.591 57.6281 191.681 57.5376 191.772 57.5376C191.862 57.5376 191.953 57.6281 191.953 57.7185Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.324 62.5131C190.324 62.694 190.234 62.7845 190.053 62.7845C189.872 62.7845 189.781 62.694 189.781 62.5131C189.781 62.3322 189.872 62.2417 190.053 62.2417C190.143 62.2417 190.324 62.3322 190.324 62.5131Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.606 73.6402C188.606 73.7307 188.515 73.8211 188.425 73.8211C188.334 73.8211 188.244 73.7307 188.244 73.6402C188.244 73.5497 188.334 73.4593 188.425 73.4593C188.515 73.4593 188.606 73.5497 188.606 73.6402Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.263 67.0363C184.263 67.0363 184.263 67.1262 184.263 67.0363C184.173 67.1262 184.173 67.0363 184.263 67.0363C184.173 67.0363 184.173 67.0363 184.263 67.0363Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.067 65.6794C187.167 65.6794 187.248 65.5984 187.248 65.4984C187.248 65.3985 187.167 65.3175 187.067 65.3175C186.967 65.3175 186.886 65.3985 186.886 65.4984C186.886 65.5984 186.967 65.6794 187.067 65.6794Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.324 62.5131C190.324 62.694 190.234 62.7845 190.053 62.7845C189.872 62.7845 189.781 62.694 189.781 62.5131C189.781 62.3322 189.872 62.2417 190.053 62.2417C190.234 62.2417 190.324 62.3322 190.324 62.5131Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.415 53.919C190.415 54.0999 190.324 54.1904 190.143 54.1904C189.962 54.1904 189.872 54.0999 189.872 53.919C189.872 53.7381 189.962 53.6476 190.143 53.6476C190.324 53.6476 190.415 53.7381 190.415 53.919Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.253 55.9997C186.453 55.9997 186.615 55.8377 186.615 55.6378C186.615 55.438 186.453 55.276 186.253 55.276C186.054 55.276 185.892 55.438 185.892 55.6378C185.892 55.8377 186.054 55.9997 186.253 55.9997Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.129 56.8139C193.129 56.9043 193.038 56.9948 192.948 56.9948C192.857 56.9948 192.767 56.9043 192.767 56.8139C192.767 56.7234 192.857 56.6329 192.948 56.6329C193.038 56.6329 193.129 56.7234 193.129 56.8139Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.148 53.919C189.198 53.919 189.239 53.8785 189.239 53.8285C189.239 53.7786 189.198 53.7381 189.148 53.7381C189.098 53.7381 189.058 53.7786 189.058 53.8285C189.058 53.8785 189.098 53.919 189.148 53.919Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.725 69.9312C182.875 69.9312 182.997 69.8096 182.997 69.6598C182.997 69.5099 182.875 69.3884 182.725 69.3884C182.575 69.3884 182.454 69.5099 182.454 69.6598C182.454 69.8096 182.575 69.9312 182.725 69.9312Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.163 67.5791C186.163 67.6696 186.072 67.76 185.982 67.76C185.891 67.76 185.801 67.6696 185.801 67.5791C185.801 67.4886 185.891 67.3982 185.982 67.3982C186.072 67.3982 186.163 67.4886 186.163 67.5791Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.329 65.0461C189.429 65.0461 189.51 64.9651 189.51 64.8652C189.51 64.7652 189.429 64.6842 189.329 64.6842C189.229 64.6842 189.148 64.7652 189.148 64.8652C189.148 64.9651 189.229 65.0461 189.329 65.0461Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.495 63.3273C192.495 63.5082 192.315 63.6891 192.134 63.6891C191.953 63.6891 191.772 63.5082 191.772 63.3273C191.772 63.1463 191.953 62.9654 192.134 62.9654C192.315 62.9654 192.495 63.1463 192.495 63.3273Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.525 58.5327C186.625 58.5327 186.706 58.4517 186.706 58.3518C186.706 58.2518 186.625 58.1708 186.525 58.1708C186.425 58.1708 186.344 58.2518 186.344 58.3518C186.344 58.4517 186.425 58.5327 186.525 58.5327Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.771 54.552C191.771 54.552 191.681 54.552 191.771 54.552C191.681 54.552 191.681 54.552 191.771 54.552C191.681 54.552 191.681 54.4621 191.771 54.552C191.681 54.4621 191.771 54.552 191.771 54.552Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.229 53.1953C191.329 53.1953 191.41 53.1143 191.41 53.0144C191.41 52.9144 191.329 52.8334 191.229 52.8334C191.129 52.8334 191.048 52.9144 191.048 53.0144C191.048 53.1143 191.129 53.1953 191.229 53.1953Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.926 67.8505C178.926 68.0314 178.835 68.1219 178.654 68.1219C178.474 68.1219 178.383 68.0314 178.383 67.8505C178.383 67.6696 178.474 67.5791 178.654 67.5791C178.835 67.5791 178.926 67.6696 178.926 67.8505Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.197 67.8505C179.347 67.8505 179.469 67.729 179.469 67.5791C179.469 67.4292 179.347 67.3077 179.197 67.3077C179.047 67.3077 178.926 67.4292 178.926 67.5791C178.926 67.729 179.047 67.8505 179.197 67.8505Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.906 64.1414C183.106 64.1414 183.268 63.9794 183.268 63.7796C183.268 63.5797 183.106 63.4177 182.906 63.4177C182.706 63.4177 182.544 63.5797 182.544 63.7796C182.544 63.9794 182.706 64.1414 182.906 64.1414Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.253 60.5229C186.253 60.6134 186.163 60.7038 186.073 60.7038C185.982 60.7038 185.892 60.6134 185.892 60.5229C185.892 60.4324 185.982 60.342 186.073 60.342C186.163 60.342 186.253 60.342 186.253 60.5229Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.041 67.8505C174.041 68.0314 173.86 68.2123 173.679 68.2123C173.498 68.2123 173.317 68.0314 173.317 67.8505C173.317 67.6695 173.498 67.4886 173.679 67.4886C173.86 67.4886 174.041 67.6695 174.041 67.8505Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.077 60.161C185.077 60.2515 185.077 60.2515 184.987 60.2515C184.896 60.2515 184.896 60.2515 184.896 60.161C184.896 60.0706 184.896 60.0706 184.987 60.0706C184.987 60.0706 185.077 60.0706 185.077 60.161Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.283 64.4129C180.383 64.4129 180.464 64.3319 180.464 64.2319C180.464 64.132 180.383 64.051 180.283 64.051C180.183 64.051 180.102 64.132 180.102 64.2319C180.102 64.3319 180.183 64.4129 180.283 64.4129Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.212 66.9458C176.312 66.9458 176.393 66.8648 176.393 66.7649C176.393 66.665 176.312 66.584 176.212 66.584C176.112 66.584 176.031 66.665 176.031 66.7649C176.031 66.8648 176.112 66.9458 176.212 66.9458Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.664 64.8652C176.664 64.9556 176.574 64.9556 176.574 64.9556C176.483 64.9556 176.483 64.8652 176.483 64.8652L176.574 64.7747C176.574 64.7747 176.664 64.7747 176.664 64.8652Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.021 61.9703C178.021 62.0608 178.021 62.0608 178.021 61.9703C177.84 62.0608 177.84 62.0608 177.84 61.9703C177.84 61.9703 177.931 61.9703 178.021 61.9703Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.278 55.0046C181.278 55.0046 181.187 55.095 181.278 55.0046C181.187 55.095 181.097 55.0046 181.097 55.0046C181.097 54.9141 181.097 54.9141 181.278 55.0046C181.187 54.9141 181.278 54.9141 181.278 55.0046Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.187 52.9239C181.187 53.0144 181.187 53.0144 181.097 53.0144C181.006 53.0144 181.006 53.0144 181.006 52.9239C181.006 52.8334 181.006 52.8334 181.097 52.8334C181.097 52.8334 181.187 52.8334 181.187 52.9239Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.73 47.4056C181.73 47.5865 181.549 47.677 181.459 47.677C181.278 47.677 181.187 47.496 181.187 47.4056C181.187 47.3151 181.368 47.1342 181.459 47.1342C181.549 47.1342 181.73 47.2247 181.73 47.4056Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.931 52.8335C177.931 52.9239 177.84 52.9239 177.84 52.9239C177.75 52.9239 177.75 52.8335 177.75 52.8335L177.84 52.743C177.931 52.743 177.931 52.8335 177.931 52.8335Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.046 56.8138C173.046 56.9948 172.865 57.0852 172.774 57.0852C172.684 57.0852 172.503 56.9043 172.503 56.8138C172.503 56.7234 172.684 56.5424 172.774 56.5424C172.865 56.5424 173.046 56.6329 173.046 56.8138Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.141 57.4471C172.141 57.5376 172.05 57.628 171.96 57.628C171.87 57.628 171.779 57.5376 171.779 57.4471C171.779 57.3566 171.87 57.2662 171.96 57.2662C172.05 57.2662 172.141 57.3566 172.141 57.4471Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.246 56.2711C169.246 56.452 169.065 56.633 168.884 56.633C168.703 56.633 168.522 56.452 168.522 56.2711C168.522 56.0902 168.703 55.9092 168.884 55.9092C169.065 55.9092 169.246 55.9997 169.246 56.2711Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.107 52.8334C179.107 52.9239 179.016 53.1048 178.835 53.1048C178.745 53.1048 178.564 53.0144 178.564 52.8334C178.564 52.743 178.654 52.562 178.835 52.562C179.016 52.562 179.107 52.6525 179.107 52.8334Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.711 56.6329C185.761 56.6329 185.801 56.5924 185.801 56.5424C185.801 56.4925 185.761 56.452 185.711 56.452C185.661 56.452 185.62 56.4925 185.62 56.5424C185.62 56.5924 185.661 56.6329 185.711 56.6329Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.603 89.0191C170.603 89.1095 170.513 89.1095 170.513 89.1095C170.422 89.1095 170.422 89.0191 170.422 89.0191L170.513 88.9286C170.513 88.8381 170.603 88.9286 170.603 89.0191Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.136 77.1683C173.286 77.1683 173.408 77.0468 173.408 76.8969C173.408 76.747 173.286 76.6255 173.136 76.6255C172.986 76.6255 172.865 76.747 172.865 76.8969C172.865 77.0468 172.986 77.1683 173.136 77.1683Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.73 82.1438C144.73 82.1438 144.73 82.2343 144.73 82.1438C144.549 82.2343 144.549 82.2343 144.549 82.1438C144.549 82.0533 144.64 82.0533 144.73 82.1438C144.73 82.0533 144.73 82.0533 144.73 82.1438Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.73 81.2392C144.93 81.2392 145.092 81.0771 145.092 80.8773C145.092 80.6775 144.93 80.5154 144.73 80.5154C144.53 80.5154 144.368 80.6775 144.368 80.8773C144.368 81.0771 144.53 81.2392 144.73 81.2392Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.097 85.1291C144.097 85.3101 143.916 85.491 143.735 85.491C143.554 85.491 143.373 85.3101 143.373 85.1291C143.373 84.9482 143.554 84.7673 143.735 84.7673C144.007 84.7673 144.097 84.9482 144.097 85.1291Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.188 88.024C144.188 88.2049 144.007 88.3858 143.826 88.3858C143.645 88.3858 143.464 88.2049 143.464 88.024C143.464 87.843 143.645 87.6621 143.826 87.6621C144.007 87.6621 144.188 87.843 144.188 88.024Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.821 89.4714C144.871 89.4714 144.911 89.4309 144.911 89.381C144.911 89.331 144.871 89.2905 144.821 89.2905C144.771 89.2905 144.73 89.331 144.73 89.381C144.73 89.4309 144.771 89.4714 144.821 89.4714Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.077 87.3003C148.077 87.3907 147.987 87.3907 147.987 87.3907C147.896 87.3907 147.896 87.3003 147.896 87.3003L147.987 87.2098C148.077 87.1193 148.077 87.2098 148.077 87.3003Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.249 89.3809C150.448 89.3809 150.61 89.2189 150.61 89.0191C150.61 88.8192 150.448 88.6572 150.249 88.6572C150.049 88.6572 149.887 88.8192 149.887 89.0191C149.887 89.2189 150.049 89.3809 150.249 89.3809Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.867 88.4763C153.917 88.4763 153.958 88.4358 153.958 88.3859C153.958 88.3359 153.917 88.2954 153.867 88.2954C153.817 88.2954 153.777 88.3359 153.777 88.3859C153.777 88.4358 153.817 88.4763 153.867 88.4763Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.134 83.5912C155.384 83.5912 155.586 83.3887 155.586 83.1389C155.586 82.8891 155.384 82.6866 155.134 82.6866C154.884 82.6866 154.681 82.8891 154.681 83.1389C154.681 83.3887 154.884 83.5912 155.134 83.5912Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.336 84.6768C206.336 84.7673 206.246 84.8577 206.156 84.8577C206.065 84.8577 205.975 84.7673 205.975 84.6768C205.975 84.5863 206.065 84.4959 206.156 84.4959C206.246 84.4959 206.336 84.5863 206.336 84.6768Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.899 83.2294C202.899 83.3199 202.808 83.4103 202.718 83.4103C202.627 83.4103 202.537 83.3199 202.537 83.2294C202.537 83.1389 202.627 83.0485 202.718 83.0485C202.899 83.0485 202.899 83.1389 202.899 83.2294Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.109 82.4152C197.109 82.5056 197.019 82.5961 196.928 82.5961C196.838 82.5961 196.747 82.5056 196.747 82.4152C196.747 82.3247 196.838 82.2343 196.928 82.2343C197.019 82.2343 197.109 82.3247 197.109 82.4152Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.29 84.4959C197.29 84.6768 197.109 84.8577 196.928 84.8577C196.747 84.8577 196.566 84.6768 196.566 84.4959C196.566 84.315 196.747 84.134 196.928 84.134C197.109 84.134 197.29 84.315 197.29 84.4959Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.938 87.7526C194.938 87.8431 194.848 87.9335 194.757 87.9335C194.667 87.9335 194.576 87.8431 194.576 87.7526C194.576 87.6622 194.667 87.5717 194.757 87.5717C194.938 87.6621 194.938 87.6622 194.938 87.7526Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.406 84.5868C192.314 84.6779 192.314 84.5868 192.314 84.5868C192.314 84.4957 192.314 84.4957 192.406 84.5868C192.406 84.4957 192.406 84.4957 192.406 84.5868Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.867 80.0632C190.867 80.1536 190.777 80.2441 190.686 80.2441C190.596 80.2441 190.505 80.1536 190.505 80.0632C190.505 79.9727 190.596 79.8822 190.686 79.8822C190.777 79.8822 190.867 79.9727 190.867 80.0632Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.325 75.5404C190.234 75.6315 190.234 75.5404 190.234 75.5404C190.234 75.4493 190.234 75.4493 190.325 75.5404C190.325 75.4493 190.325 75.4493 190.325 75.5404Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.263 88.9286C221.263 89.0191 221.173 89.1096 221.082 89.1096C220.992 89.1096 220.901 89.0191 220.901 88.9286C220.901 88.8382 220.992 88.7477 221.082 88.7477C221.173 88.7477 221.263 88.8382 221.263 88.9286Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.992 89.9237C220.992 90.1046 220.811 90.2856 220.63 90.2856C220.449 90.2856 220.268 90.1046 220.268 89.9237C220.268 89.7428 220.449 89.5619 220.63 89.5619C220.811 89.5619 220.992 89.7428 220.992 89.9237Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.026 89.9237C214.026 90.0142 213.935 90.1047 213.845 90.1047C213.755 90.1047 213.664 90.0142 213.664 89.9237C213.664 89.8333 213.755 89.7428 213.845 89.7428C213.935 89.8333 214.026 89.9237 214.026 89.9237Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.664 93.4518C213.664 93.5423 213.574 93.6328 213.483 93.6328C213.393 93.6328 213.302 93.5423 213.302 93.4518C213.302 93.3614 213.393 93.2709 213.483 93.2709C213.574 93.2709 213.664 93.3614 213.664 93.4518Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.197 96.8895C216.197 96.98 216.107 97.1609 215.926 97.1609C215.835 97.1609 215.654 97.0704 215.654 96.8895C215.654 96.7086 215.745 96.6181 215.926 96.6181C216.107 96.6181 216.197 96.799 216.197 96.8895Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.268 93.8137C220.268 93.9041 220.177 93.9946 220.087 93.9946C219.996 93.9946 219.906 93.9041 219.906 93.8137C219.906 93.7232 219.996 93.6328 220.087 93.6328C220.177 93.6328 220.268 93.7232 220.268 93.8137Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.439 92.0949C222.439 92.1853 222.349 92.2758 222.258 92.2758C222.168 92.2758 222.077 92.1853 222.077 92.0949C222.077 92.0044 222.168 91.9139 222.258 91.9139C222.349 91.9139 222.439 92.0044 222.439 92.0949Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.072 91.3712C223.072 91.5521 222.891 91.733 222.71 91.733C222.53 91.733 222.349 91.5521 222.349 91.3712C222.349 91.1902 222.53 91.0093 222.71 91.0093C222.891 91.0093 223.072 91.1902 223.072 91.3712Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.525 89.5619C223.525 89.6523 223.434 89.6523 223.434 89.6523C223.344 89.6523 223.344 89.5619 223.344 89.5619C223.344 89.4714 223.434 89.4714 223.434 89.4714C223.434 89.4714 223.525 89.4714 223.525 89.5619Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.439 85.5814C222.439 85.6719 222.349 85.6719 222.349 85.6719C222.258 85.6719 222.258 85.5814 222.258 85.5814C222.258 85.491 222.349 85.491 222.349 85.491C222.439 85.4005 222.439 85.491 222.439 85.5814Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.53 89.4714C222.53 89.6523 222.349 89.8332 222.168 89.8332C221.987 89.8332 221.806 89.6523 221.806 89.4714C221.806 89.2905 221.987 89.1095 222.168 89.1095C222.439 89.1095 222.53 89.2905 222.53 89.4714Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.916 83.0485C217.916 83.2294 217.735 83.4103 217.554 83.4103C217.373 83.4103 217.192 83.2294 217.192 83.0485C217.192 82.8675 217.373 82.6866 217.554 82.6866C217.735 82.5962 217.916 82.7771 217.916 83.0485Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.508 39.3543C171.708 39.3543 171.87 39.1923 171.87 38.9924C171.87 38.7926 171.708 38.6306 171.508 38.6306C171.308 38.6306 171.146 38.7926 171.146 38.9924C171.146 39.1923 171.308 39.3543 171.508 39.3543Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.422 33.3836C170.422 33.4741 170.422 33.4741 170.332 33.4741C170.241 33.4741 170.241 33.4741 170.241 33.3836C170.241 33.2932 170.241 33.2932 170.332 33.2932C170.422 33.2932 170.422 33.3836 170.422 33.3836Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.614 34.1078C168.522 34.1989 168.522 34.1078 168.522 34.1078C168.522 34.0167 168.522 34.0167 168.614 34.1078C168.614 34.0167 168.614 34.0167 168.614 34.1078Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.623 36.0976C166.623 36.2785 166.532 36.369 166.351 36.369C166.17 36.369 166.08 36.2785 166.08 36.0976C166.08 35.9166 166.17 35.8262 166.351 35.8262C166.532 35.8262 166.623 36.0071 166.623 36.0976Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.99 35.8262C165.99 35.9166 165.899 35.9166 165.899 35.9166C165.809 35.9166 165.809 35.8262 165.809 35.8262C165.809 35.7357 165.899 35.7357 165.899 35.7357C165.99 35.7357 165.99 35.8262 165.99 35.8262Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.552 35.6452C162.552 35.8262 162.461 35.9166 162.28 35.9166C162.1 35.9166 162.009 35.8262 162.009 35.6452C162.009 35.4643 162.1 35.3738 162.28 35.3738C162.461 35.3738 162.552 35.4643 162.552 35.6452Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.381 39.6257C160.381 39.7161 160.381 39.7161 160.29 39.7161C160.2 39.7161 160.2 39.7161 160.2 39.6257C160.2 39.5352 160.2 39.5352 160.29 39.5352C160.381 39.5352 160.381 39.5352 160.381 39.6257Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.401 42.8827C156.401 42.8827 156.401 42.9738 156.401 42.8827C156.31 42.9738 156.31 42.8827 156.31 42.8827C156.31 42.8827 156.31 42.7915 156.401 42.8827C156.401 42.7915 156.401 42.8827 156.401 42.8827Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.53 47.1342C148.53 47.3151 148.349 47.4056 148.258 47.4056C148.168 47.4056 147.987 47.2247 147.987 47.1342C147.987 46.9533 148.168 46.8628 148.258 46.8628C148.349 46.8628 148.53 47.0438 148.53 47.1342Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.977 45.144C149.977 45.3249 149.796 45.5058 149.616 45.5058C149.435 45.5058 149.254 45.3249 149.254 45.144C149.254 44.963 149.435 44.7821 149.616 44.7821C149.887 44.7821 149.977 44.963 149.977 45.144Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.667 40.8017C157.667 40.9826 157.486 41.1636 157.305 41.1636C157.124 41.1636 156.943 40.9826 156.943 40.8017C156.943 40.6208 157.124 40.4399 157.305 40.4399C157.486 40.3494 157.667 40.5303 157.667 40.8017Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.843 42.611C159.093 42.611 159.295 42.4085 159.295 42.1587C159.295 41.9088 159.093 41.7063 158.843 41.7063C158.593 41.7063 158.39 41.9088 158.39 42.1587C158.39 42.4085 158.593 42.611 158.843 42.611Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.456 41.3445C163.456 41.435 163.366 41.5254 163.275 41.5254C163.185 41.5254 163.094 41.435 163.094 41.3445C163.094 41.254 163.185 41.1636 163.275 41.1636C163.366 41.1636 163.456 41.3445 163.456 41.3445Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.442 41.1636C166.442 41.254 166.351 41.3445 166.261 41.3445C166.17 41.3445 166.08 41.254 166.08 41.1636C166.08 41.0731 166.17 40.9826 166.261 40.9826C166.351 40.9826 166.442 41.0731 166.442 41.1636Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.327 33.1122C171.477 33.1122 171.598 32.9907 171.598 32.8408C171.598 32.691 171.477 32.5695 171.327 32.5695C171.177 32.5695 171.055 32.691 171.055 32.8408C171.055 32.9907 171.177 33.1122 171.327 33.1122Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.95 38.5401C173.95 38.6306 173.86 38.8115 173.679 38.8115C173.588 38.8115 173.407 38.721 173.407 38.5401C173.407 38.4496 173.498 38.2687 173.679 38.2687C173.86 38.2687 173.95 38.3592 173.95 38.5401Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.791 47.0437C150.791 47.0437 150.791 47.1342 150.791 47.0437C150.701 47.1342 150.61 47.0437 150.61 47.0437C150.701 47.0437 150.701 46.9533 150.791 47.0437C150.791 46.9533 150.791 47.0437 150.791 47.0437Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.334 46.6819C151.434 46.6819 151.515 46.6009 151.515 46.5009C151.515 46.401 151.434 46.32 151.334 46.32C151.234 46.32 151.153 46.401 151.153 46.5009C151.153 46.6009 151.234 46.6819 151.334 46.6819Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.224 45.0535C155.224 45.2344 155.043 45.4154 154.862 45.4154C154.681 45.4154 154.5 45.2344 154.5 45.0535C154.5 44.8726 154.681 44.6917 154.862 44.6917C155.043 44.6917 155.224 44.8726 155.224 45.0535Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.205 46.32C159.205 46.4105 159.114 46.5009 159.024 46.5009C158.933 46.5009 158.843 46.4105 158.843 46.32C158.843 46.2295 158.933 46.1391 159.024 46.1391C159.114 46.1391 159.205 46.2295 159.205 46.32Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.777 34.9215C191.026 34.9215 191.229 34.719 191.229 34.4692C191.229 34.2194 191.026 34.0169 190.777 34.0169C190.527 34.0169 190.324 34.2194 190.324 34.4692C190.324 34.719 190.527 34.9215 190.777 34.9215Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.319 36.0976C191.369 36.0976 191.41 36.0571 191.41 36.0071C191.41 35.9571 191.369 35.9166 191.319 35.9166C191.269 35.9166 191.229 35.9571 191.229 36.0071C191.229 36.0571 191.269 36.0976 191.319 36.0976Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.153 34.2883C188.153 34.4692 187.972 34.6501 187.791 34.6501C187.61 34.6501 187.429 34.4692 187.429 34.2883C187.429 34.1073 187.61 33.9264 187.791 33.9264C187.972 33.9264 188.153 34.1073 188.153 34.2883Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.41 33.3837C191.41 33.4741 191.319 33.5646 191.229 33.5646C191.138 33.5646 191.048 33.4741 191.048 33.3837C191.048 33.2932 191.138 33.2027 191.229 33.2027C191.319 33.2027 191.41 33.2932 191.41 33.3837Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.395 33.2932C194.495 33.2932 194.576 33.2122 194.576 33.1122C194.576 33.0123 194.495 32.9313 194.395 32.9313C194.295 32.9313 194.214 33.0123 194.214 33.1122C194.214 33.2122 194.295 33.2932 194.395 33.2932Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.762 26.5988C193.762 26.7797 193.581 26.8702 193.49 26.8702C193.309 26.8702 193.219 26.6893 193.219 26.5988C193.219 26.4179 193.4 26.3274 193.49 26.3274C193.581 26.3274 193.762 26.4179 193.762 26.5988Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.225 26.9607C192.225 27.0518 192.134 27.0518 192.225 26.9607C192.134 27.0518 192.134 26.9607 192.134 26.9607C192.134 26.9607 192.134 26.9607 192.225 26.9607C192.134 26.9607 192.225 26.9607 192.225 26.9607Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.405 27.0511C192.405 27.2321 192.314 27.3225 192.133 27.3225C191.953 27.3225 191.862 27.2321 191.862 27.0511C191.862 26.8702 191.953 26.7798 192.133 26.7798C192.314 26.7798 192.405 26.8702 192.405 27.0511Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.586 26.4179C192.586 26.5084 192.496 26.5988 192.405 26.5988C192.315 26.5988 192.224 26.5084 192.224 26.4179C192.224 26.3274 192.315 26.237 192.405 26.237C192.496 26.237 192.586 26.4179 192.586 26.4179Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.591 26.5084C191.591 26.7797 191.41 26.9607 191.138 26.9607C190.867 26.9607 190.686 26.7797 190.686 26.5084C190.686 26.237 190.867 26.056 191.138 26.056C191.41 26.056 191.591 26.3274 191.591 26.5084Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.449 26.056C183.449 26.1465 183.449 26.1465 183.449 26.056C183.359 26.1465 183.268 26.1465 183.268 26.056C183.268 26.056 183.359 25.9656 183.449 26.056C183.449 25.9656 183.449 26.056 183.449 26.056Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.71 22.1661C185.71 22.2566 185.62 22.347 185.53 22.347C185.439 22.347 185.349 22.2566 185.349 22.1661C185.349 22.0756 185.439 21.9852 185.53 21.9852C185.62 21.9852 185.71 22.0756 185.71 22.1661Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.087 24.3372C183.087 24.5181 182.997 24.6086 182.816 24.6086C182.635 24.6086 182.544 24.5181 182.544 24.3372C182.544 24.1563 182.635 24.0658 182.816 24.0658C182.997 24.0658 183.087 24.2468 183.087 24.3372Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.344 23.1612C186.344 23.3421 186.163 23.5231 185.982 23.5231C185.801 23.5231 185.62 23.3421 185.62 23.1612C185.62 22.9803 185.801 22.7993 185.982 22.7993C186.163 22.7993 186.344 22.9803 186.344 23.1612Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.777 23.8849C190.877 23.8849 190.958 23.8039 190.958 23.704C190.958 23.604 190.877 23.523 190.777 23.523C190.677 23.523 190.596 23.604 190.596 23.704C190.596 23.8039 190.677 23.8849 190.777 23.8849Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.209 31.7553C195.309 31.7553 195.39 31.6743 195.39 31.5744C195.39 31.4745 195.309 31.3935 195.209 31.3935C195.109 31.3935 195.028 31.4745 195.028 31.5744C195.028 31.6743 195.109 31.7553 195.209 31.7553Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.043 32.5695C192.043 32.7504 191.862 32.9313 191.681 32.9313C191.5 32.9313 191.319 32.7504 191.319 32.5695C191.319 32.3885 191.5 32.2076 191.681 32.2076C191.862 32.2076 192.043 32.3885 192.043 32.5695Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.244 30.8507C188.244 30.9411 188.153 30.9411 188.153 30.9411C188.063 30.9411 188.063 30.8507 188.063 30.8507C188.063 30.7602 188.153 30.7602 188.153 30.7602C188.153 30.7602 188.244 30.7602 188.244 30.8507Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.701 28.6795C187.701 28.77 187.61 28.8604 187.52 28.8604C187.429 28.8604 187.339 28.77 187.339 28.6795C187.339 28.589 187.429 28.4986 187.52 28.4986C187.61 28.4986 187.701 28.4986 187.701 28.6795Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.077 24.9705C185.077 25.0609 184.987 25.0609 184.987 25.0609C184.896 25.0609 184.896 24.9705 184.896 24.9705C184.896 24.88 184.987 24.88 184.987 24.88C185.077 24.88 185.077 24.88 185.077 24.9705Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.916 26.7797C180.916 26.9607 180.735 27.1416 180.554 27.1416C180.373 27.1416 180.192 26.9607 180.192 26.7797C180.192 26.5988 180.373 26.4179 180.554 26.4179C180.735 26.3274 180.916 26.5083 180.916 26.7797Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.097 27.1416C181.097 27.2321 181.007 27.413 180.826 27.413C180.735 27.413 180.554 27.3226 180.554 27.1416C180.554 26.9607 180.645 26.8702 180.826 26.8702C181.007 26.8702 181.097 26.9607 181.097 27.1416Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.862 35.5548C191.862 35.7357 191.772 35.8262 191.591 35.8262C191.41 35.8262 191.319 35.7357 191.319 35.5548C191.319 35.3738 191.41 35.2834 191.591 35.2834C191.772 35.2834 191.862 35.3738 191.862 35.5548Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.224 32.9313C192.224 33.0218 192.133 33.0218 192.133 33.0218C192.043 33.0218 192.043 32.9313 192.043 32.9313C192.043 32.8409 192.133 32.8409 192.133 32.8409C192.133 32.7504 192.224 32.8409 192.224 32.9313Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.495 28.4986C192.495 28.6795 192.315 28.8604 192.134 28.8604C191.953 28.8604 191.772 28.6795 191.772 28.4986C191.772 28.3176 191.953 28.1367 192.134 28.1367C192.405 28.1367 192.495 28.3176 192.495 28.4986Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.439 43.6966C185.439 43.6966 185.439 43.7865 185.439 43.6966C185.349 43.7865 185.349 43.6966 185.439 43.6966C185.349 43.6966 185.349 43.6966 185.439 43.6966Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.71 43.6061C185.71 43.6965 185.62 43.787 185.53 43.787C185.439 43.787 185.349 43.6965 185.349 43.6061C185.349 43.5156 185.439 43.4251 185.53 43.4251C185.71 43.4251 185.71 43.5156 185.71 43.6061Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.52 41.6159C187.52 41.8873 187.339 42.0682 187.068 42.0682C186.796 42.0682 186.615 41.8873 186.615 41.6159C186.615 41.3445 186.796 41.1636 187.068 41.1636C187.339 41.1636 187.52 41.3445 187.52 41.6159Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.506 40.4401C190.506 40.5312 190.506 40.5312 190.506 40.4401C190.415 40.5312 190.415 40.4401 190.415 40.4401C190.415 40.4401 190.415 40.349 190.506 40.4401C190.506 40.349 190.506 40.4401 190.506 40.4401Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.434 58.3517C186.434 58.4422 186.344 58.4422 186.344 58.4422C186.253 58.4422 186.253 58.3517 186.253 58.3517C186.253 58.2613 186.344 58.2613 186.344 58.2613C186.344 58.1708 186.434 58.2613 186.434 58.3517Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.796 52.4716C186.796 52.6525 186.706 52.743 186.525 52.743C186.344 52.743 186.253 52.6525 186.253 52.4716C186.253 52.2907 186.344 52.2002 186.525 52.2002C186.706 52.2002 186.796 52.2907 186.796 52.4716Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.898 82.5057C165.898 82.5956 165.898 82.5956 165.898 82.5057C165.809 82.5956 165.809 82.5956 165.898 82.5057C165.809 82.5057 165.809 82.5057 165.898 82.5057Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.09 85.491C164.09 85.6719 163.909 85.8528 163.728 85.8528C163.547 85.8528 163.366 85.6719 163.366 85.491C163.366 85.31 163.547 85.1291 163.728 85.1291C163.909 85.1291 164.09 85.31 164.09 85.491Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.009 87.6621C162.209 87.6621 162.371 87.5001 162.371 87.3003C162.371 87.1004 162.209 86.9384 162.009 86.9384C161.809 86.9384 161.647 87.1004 161.647 87.3003C161.647 87.5001 161.809 87.6621 162.009 87.6621Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.104 87.5717C161.104 87.7526 161.014 87.843 160.833 87.843C160.652 87.843 160.562 87.7526 160.562 87.5717C160.562 87.3907 160.652 87.3003 160.833 87.3003C161.014 87.3003 161.104 87.3907 161.104 87.5717Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.742 84.0436C160.742 84.134 160.652 84.3149 160.471 84.3149C160.381 84.3149 160.2 84.2245 160.2 84.0436C160.2 83.9531 160.29 83.7722 160.471 83.7722C160.652 83.7722 160.742 83.8626 160.742 84.0436Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.312 75.359C174.312 75.4495 174.222 75.5399 174.131 75.5399C174.041 75.5399 173.95 75.4495 173.95 75.359C173.95 75.2685 174.041 75.1781 174.131 75.1781C174.222 75.1781 174.312 75.2685 174.312 75.359Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.126 71.6497C175.126 71.6497 175.036 71.6497 175.126 71.6497C175.036 71.6497 175.036 71.6497 175.126 71.6497C175.036 71.6497 175.036 71.5598 175.126 71.6497C175.036 71.5598 175.126 71.6497 175.126 71.6497Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.327 73.1879C171.327 73.2784 171.236 73.3688 171.146 73.3688C171.055 73.3688 170.965 73.2784 170.965 73.1879C170.965 73.0974 171.055 73.007 171.146 73.007C171.236 73.007 171.327 73.0974 171.327 73.1879Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.833 73.6402C160.833 73.7307 160.743 73.7307 160.743 73.7307L160.652 73.6402L160.743 73.5497C160.743 73.5497 160.833 73.5497 160.833 73.6402Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2 71.7404C160.2 71.8309 160.109 71.9213 160.019 71.9213C159.928 71.9213 159.838 71.8309 159.838 71.7404C159.838 71.6499 159.928 71.5595 160.019 71.5595C160.109 71.5595 160.2 71.6499 160.2 71.7404Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.772 66.7649C154.772 66.7649 154.681 66.8553 154.772 66.7649C154.681 66.8553 154.681 66.7649 154.681 66.7649C154.591 66.7649 154.681 66.6744 154.772 66.7649C154.681 66.6744 154.772 66.7649 154.772 66.7649Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.867 74.8162C153.867 74.9067 153.777 74.9972 153.686 74.9972C153.596 74.9972 153.505 74.9067 153.505 74.8162C153.505 74.7258 153.596 74.6353 153.686 74.6353C153.777 74.6353 153.867 74.7258 153.867 74.8162Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.231 103.493C172.431 103.493 172.593 103.331 172.593 103.132C172.593 102.932 172.431 102.77 172.231 102.77C172.032 102.77 171.87 102.932 171.87 103.132C171.87 103.331 172.032 103.493 172.231 103.493Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.593 102.408C172.593 102.498 172.503 102.589 172.412 102.589C172.322 102.589 172.231 102.498 172.231 102.408C172.231 102.317 172.322 102.227 172.412 102.227C172.503 102.317 172.593 102.317 172.593 102.408Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.508 98.3369C171.608 98.3369 171.689 98.2559 171.689 98.156C171.689 98.056 171.608 97.975 171.508 97.975C171.408 97.975 171.327 98.056 171.327 98.156C171.327 98.2559 171.408 98.3369 171.508 98.3369Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.708 98.0655C167.708 98.156 167.618 98.156 167.618 98.156L167.527 98.0655L167.618 97.975C167.618 97.975 167.708 97.975 167.708 98.0655Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.779 101.684C171.829 101.684 171.87 101.644 171.87 101.594C171.87 101.544 171.829 101.503 171.779 101.503C171.729 101.503 171.689 101.544 171.689 101.594C171.689 101.644 171.729 101.684 171.779 101.684Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.498 100.327C173.548 100.327 173.588 100.287 173.588 100.237C173.588 100.187 173.548 100.146 173.498 100.146C173.448 100.146 173.407 100.187 173.407 100.237C173.407 100.287 173.448 100.327 173.498 100.327Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.432 92.9995C168.632 92.9995 168.794 92.8375 168.794 92.6376C168.794 92.4378 168.632 92.2758 168.432 92.2758C168.232 92.2758 168.07 92.4378 168.07 92.6376C168.07 92.8375 168.232 92.9995 168.432 92.9995Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.627 92.6377C165.627 92.7281 165.537 92.8186 165.447 92.8186C165.356 92.8186 165.266 92.7281 165.266 92.6377C165.266 92.5472 165.356 92.4567 165.447 92.4567C165.627 92.4567 165.627 92.5472 165.627 92.6377Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.275 93.4518C163.275 93.6327 163.095 93.7232 163.004 93.7232C162.823 93.7232 162.733 93.5423 162.733 93.4518C162.733 93.2709 162.914 93.1804 163.004 93.1804C163.095 93.1804 163.275 93.2709 163.275 93.4518Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.928 94.4469C159.928 94.7183 159.747 94.8993 159.476 94.8993C159.205 94.8993 159.024 94.7183 159.024 94.4469C159.024 94.1756 159.205 93.9946 159.476 93.9946C159.747 93.9946 159.928 94.1756 159.928 94.4469Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.933 94.7184C158.933 94.8993 158.752 95.0802 158.571 95.0802C158.39 95.0802 158.209 94.8993 158.209 94.7184C158.209 94.5374 158.39 94.3565 158.571 94.3565C158.752 94.3565 158.933 94.5374 158.933 94.7184Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.677 95.8039C155.677 95.9848 155.496 96.1658 155.315 96.1658C155.134 96.1658 154.953 95.9848 154.953 95.8039C154.953 95.623 155.134 95.442 155.315 95.442C155.496 95.442 155.677 95.623 155.677 95.8039Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.791 98.5178C150.841 98.5178 150.882 98.4773 150.882 98.4274C150.882 98.3774 150.841 98.3369 150.791 98.3369C150.741 98.3369 150.701 98.3774 150.701 98.4274C150.701 98.4773 150.741 98.5178 150.791 98.5178Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.068 102.317C150.118 102.317 150.158 102.277 150.158 102.227C150.158 102.177 150.118 102.136 150.068 102.136C150.018 102.136 149.977 102.177 149.977 102.227C149.977 102.277 150.018 102.317 150.068 102.317Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.099 97.7037C162.099 97.7941 162.009 97.8846 161.918 97.8846C161.828 97.8846 161.738 97.7941 161.738 97.7037C161.738 97.6132 161.828 97.5227 161.918 97.5227C162.009 97.4323 162.099 97.5227 162.099 97.7037Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.909 96.2562C163.909 96.2562 163.818 96.3467 163.909 96.2562C163.818 96.3467 163.728 96.3467 163.728 96.2562C163.728 96.1658 163.728 96.1658 163.909 96.2562C163.818 96.1658 163.909 96.1658 163.909 96.2562Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.899 95.2611C166.149 95.2611 166.351 95.0586 166.351 94.8088C166.351 94.559 166.149 94.3565 165.899 94.3565C165.649 94.3565 165.447 94.559 165.447 94.8088C165.447 95.0586 165.649 95.2611 165.899 95.2611Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.989 94.6279C165.989 94.7178 165.989 94.7178 165.989 94.6279C165.989 94.7178 165.899 94.7178 165.989 94.6279C165.899 94.6279 165.989 94.6279 165.989 94.6279Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.095 97.0704C163.095 97.2513 163.004 97.3418 162.823 97.3418C162.642 97.3418 162.552 97.2513 162.552 97.0704C162.552 96.8895 162.642 96.799 162.823 96.799C162.914 96.799 163.095 96.8895 163.095 97.0704Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.371 97.5227C162.371 97.6132 162.371 97.6132 162.371 97.5227C162.28 97.6132 162.19 97.5227 162.19 97.5227C162.19 97.5227 162.28 97.5227 162.371 97.5227Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.021 118.42C178.021 118.601 177.84 118.782 177.659 118.782C177.478 118.782 177.297 118.601 177.297 118.42C177.297 118.239 177.478 118.058 177.659 118.058C177.84 117.968 178.021 118.149 178.021 118.42Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.06 105.212C170.06 105.303 169.97 105.303 169.97 105.303C169.879 105.303 169.879 105.212 169.879 105.212C169.879 105.122 169.97 105.122 169.97 105.122L170.06 105.212Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.431 106.207C168.342 106.207 168.342 106.207 168.431 106.207C168.342 106.207 168.342 106.117 168.431 106.207C168.431 106.117 168.431 106.207 168.431 106.207Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.432 107.202C168.432 107.293 168.341 107.383 168.251 107.383C168.161 107.383 168.07 107.293 168.07 107.202C168.07 107.112 168.161 107.021 168.251 107.021C168.341 107.021 168.432 107.021 168.432 107.202Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.904 112.178C164.904 112.268 164.813 112.268 164.813 112.268C164.723 112.268 164.723 112.178 164.723 112.178C164.723 112.087 164.813 112.087 164.813 112.087C164.813 112.087 164.904 112.087 164.904 112.178Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.627 115.796C165.627 115.887 165.537 115.977 165.447 115.977C165.356 115.977 165.266 115.887 165.266 115.796C165.266 115.706 165.356 115.616 165.447 115.616C165.537 115.616 165.627 115.706 165.627 115.796Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.899 118.601C165.899 118.872 165.718 119.053 165.447 119.053C165.175 119.053 164.994 118.872 164.994 118.601C164.994 118.329 165.175 118.149 165.447 118.149C165.718 118.149 165.899 118.42 165.899 118.601Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.09 119.686C164.09 119.777 163.999 119.867 163.909 119.867C163.818 119.867 163.728 119.777 163.728 119.686C163.728 119.596 163.818 119.505 163.909 119.505C163.999 119.505 164.09 119.596 164.09 119.686Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 111.183C160.209 111.183 160.29 111.102 160.29 111.002C160.29 110.902 160.209 110.821 160.109 110.821C160.009 110.821 159.928 110.902 159.928 111.002C159.928 111.102 160.009 111.183 160.109 111.183Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.461 122.219C162.461 122.4 162.28 122.581 162.099 122.581C161.918 122.581 161.738 122.4 161.738 122.219C161.738 122.038 161.918 121.858 162.099 121.858C162.28 121.858 162.461 122.038 162.461 122.219Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.09 120.41C164.09 120.501 163.999 120.682 163.818 120.682C163.728 120.682 163.547 120.591 163.547 120.41C163.547 120.32 163.637 120.139 163.818 120.139C163.909 120.139 164.09 120.229 164.09 120.41Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 117.063C160.109 117.244 159.928 117.334 159.838 117.334C159.747 117.334 159.566 117.153 159.566 117.063C159.566 116.882 159.747 116.792 159.838 116.792C159.928 116.792 160.109 116.882 160.109 117.063Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.843 104.398C158.993 104.398 159.114 104.277 159.114 104.127C159.114 103.977 158.993 103.855 158.843 103.855C158.693 103.855 158.571 103.977 158.571 104.127C158.571 104.277 158.693 104.398 158.843 104.398Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.77 128.642C173.77 128.734 173.77 128.734 173.77 128.642C173.679 128.734 173.679 128.642 173.679 128.642C173.679 128.642 173.679 128.642 173.77 128.642Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.478 129.366C177.578 129.366 177.659 129.285 177.659 129.185C177.659 129.085 177.578 129.004 177.478 129.004C177.378 129.004 177.297 129.085 177.297 129.185C177.297 129.285 177.378 129.366 177.478 129.366Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.916 127.466C180.916 127.557 180.826 127.647 180.735 127.647C180.645 127.647 180.554 127.557 180.554 127.466C180.554 127.376 180.645 127.285 180.735 127.285C180.826 127.285 180.916 127.376 180.916 127.466Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.539 125.295C183.539 125.567 183.358 125.748 183.087 125.748C182.816 125.748 182.635 125.567 182.635 125.295C182.635 125.024 182.816 124.843 183.087 124.843C183.358 124.843 183.539 125.114 183.539 125.295Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.901 124.752C184.101 124.752 184.263 124.59 184.263 124.391C184.263 124.191 184.101 124.029 183.901 124.029C183.702 124.029 183.54 124.191 183.54 124.391C183.54 124.59 183.702 124.752 183.901 124.752Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.544 118.329C182.544 118.329 182.454 118.329 182.544 118.329C182.454 118.42 182.454 118.329 182.454 118.329C182.364 118.239 182.454 118.239 182.544 118.329C182.454 118.239 182.544 118.239 182.544 118.329Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.358 113.444C183.358 113.625 183.268 113.716 183.087 113.716C182.906 113.716 182.816 113.625 182.816 113.444C182.816 113.264 182.906 113.173 183.087 113.173C183.268 113.173 183.358 113.264 183.358 113.444Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.444 114.258C184.354 114.258 184.354 114.258 184.444 114.258C184.354 114.258 184.354 114.168 184.444 114.258C184.444 114.168 184.444 114.258 184.444 114.258Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.168 116.792C185.418 116.792 185.62 116.589 185.62 116.339C185.62 116.089 185.418 115.887 185.168 115.887C184.918 115.887 184.716 116.089 184.716 116.339C184.716 116.589 184.918 116.792 185.168 116.792Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.891 120.681C185.891 120.681 185.801 120.681 185.891 120.681C185.801 120.681 185.801 120.681 185.891 120.681C185.801 120.591 185.801 120.591 185.891 120.681C185.801 120.591 185.891 120.591 185.891 120.681Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.711 124.3C185.711 124.481 185.62 124.572 185.439 124.572C185.258 124.572 185.168 124.481 185.168 124.3C185.168 124.119 185.258 124.029 185.439 124.029C185.53 124.029 185.711 124.119 185.711 124.3Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.202 125.748C178.202 125.838 178.111 125.928 178.021 125.928C177.931 125.928 177.84 125.838 177.84 125.748C177.84 125.657 177.931 125.567 178.021 125.567C178.111 125.567 178.202 125.657 178.202 125.748Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.478 125.295C177.478 125.476 177.297 125.657 177.116 125.657C176.936 125.657 176.755 125.476 176.755 125.295C176.755 125.114 176.936 124.933 177.116 124.933C177.297 124.933 177.478 125.024 177.478 125.295Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.322 129.547C172.322 129.547 172.322 129.637 172.322 129.547C172.141 129.637 172.141 129.637 172.141 129.547C172.141 129.457 172.231 129.457 172.322 129.547C172.322 129.457 172.322 129.457 172.322 129.547Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.774 130.542C172.874 130.542 172.955 130.461 172.955 130.361C172.955 130.261 172.874 130.18 172.774 130.18C172.674 130.18 172.593 130.261 172.593 130.361C172.593 130.461 172.674 130.542 172.774 130.542Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.036 129.276C175.186 129.276 175.307 129.154 175.307 129.004C175.307 128.854 175.186 128.733 175.036 128.733C174.886 128.733 174.764 128.854 174.764 129.004C174.764 129.154 174.886 129.276 175.036 129.276Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.921 128.19C180.071 128.19 180.192 128.069 180.192 127.919C180.192 127.769 180.071 127.647 179.921 127.647C179.771 127.647 179.649 127.769 179.649 127.919C179.649 128.069 179.771 128.19 179.921 128.19Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.821 122.038C181.821 122.219 181.73 122.31 181.549 122.31C181.368 122.31 181.278 122.219 181.278 122.038C181.278 121.858 181.368 121.767 181.549 121.767C181.73 121.767 181.821 121.948 181.821 122.038Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.535 117.877C184.535 118.058 184.354 118.239 184.173 118.239C183.992 118.239 183.811 118.058 183.811 117.877C183.811 117.696 183.992 117.515 184.173 117.515C184.354 117.515 184.535 117.696 184.535 117.877Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.62 121.948C185.62 122.129 185.53 122.219 185.349 122.219C185.168 122.219 185.077 122.129 185.077 121.948C185.077 121.767 185.168 121.677 185.349 121.677C185.53 121.677 185.62 121.767 185.62 121.948Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.539 122.943C183.739 122.943 183.901 122.781 183.901 122.581C183.901 122.381 183.739 122.219 183.539 122.219C183.34 122.219 183.177 122.381 183.177 122.581C183.177 122.781 183.34 122.943 183.539 122.943Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.826 122.853C180.826 122.944 180.826 122.944 180.826 122.853C180.735 122.944 180.735 122.853 180.735 122.853C180.735 122.853 180.735 122.853 180.826 122.853Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.926 123.667C178.926 123.757 178.835 123.757 178.926 123.667C178.835 123.757 178.835 123.667 178.835 123.667C178.745 123.667 178.835 123.667 178.926 123.667C178.835 123.667 178.926 123.667 178.926 123.667Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.664 121.858C176.664 121.948 176.574 122.039 176.483 122.039C176.393 122.039 176.302 121.948 176.302 121.858C176.302 121.767 176.393 121.677 176.483 121.677C176.574 121.677 176.664 121.767 176.664 121.858Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.116 120.682C177.116 120.771 177.116 120.771 177.116 120.682C177.116 120.771 177.026 120.771 177.116 120.682C177.026 120.682 177.116 120.682 177.116 120.682Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.107 124.481C179.107 124.571 179.016 124.572 179.016 124.572C178.926 124.572 178.926 124.481 178.926 124.481C178.926 124.391 179.016 124.391 179.016 124.391C179.016 124.391 179.107 124.391 179.107 124.481Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.564 127.738C178.664 127.738 178.745 127.657 178.745 127.557C178.745 127.457 178.664 127.376 178.564 127.376C178.464 127.376 178.383 127.457 178.383 127.557C178.383 127.657 178.464 127.738 178.564 127.738Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.202 125.205C178.202 125.295 178.111 125.386 178.021 125.386C177.931 125.386 177.84 125.295 177.84 125.205C177.84 125.114 177.931 125.024 178.021 125.024C178.202 125.024 178.202 125.114 178.202 125.205Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.368 125.024C181.618 125.024 181.821 124.821 181.821 124.572C181.821 124.322 181.618 124.119 181.368 124.119C181.119 124.119 180.916 124.322 180.916 124.572C180.916 124.821 181.119 125.024 181.368 125.024Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.64 120.139C181.64 120.229 181.549 120.229 181.549 120.229L181.459 120.139C181.459 120.048 181.549 120.048 181.549 120.048L181.64 120.139Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.916 118.51C181.066 118.51 181.187 118.389 181.187 118.239C181.187 118.089 181.066 117.968 180.916 117.968C180.766 117.968 180.645 118.089 180.645 118.239C180.645 118.389 180.766 118.51 180.916 118.51Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.097 117.153C181.097 117.244 181.006 117.334 180.916 117.334C180.826 117.334 180.735 117.244 180.735 117.153C180.735 117.063 180.826 116.973 180.916 116.973C181.006 116.973 181.097 116.973 181.097 117.153Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.263 119.415C184.263 119.506 184.173 119.506 184.173 119.506C184.082 119.506 184.082 119.415 184.082 119.415C184.082 119.325 184.173 119.325 184.173 119.325C184.173 119.234 184.263 119.325 184.263 119.415Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.71 119.506C185.91 119.506 186.072 119.344 186.072 119.144C186.072 118.944 185.91 118.782 185.71 118.782C185.511 118.782 185.349 118.944 185.349 119.144C185.349 119.344 185.511 119.506 185.71 119.506Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.977 116.882C186.977 117.063 186.887 117.153 186.706 117.153C186.525 117.153 186.434 117.063 186.434 116.882C186.434 116.701 186.525 116.611 186.706 116.611C186.887 116.611 186.977 116.701 186.977 116.882Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.073 113.897C186.073 113.897 186.073 113.988 186.073 113.897C185.982 113.988 185.982 113.897 185.982 113.897C185.982 113.897 185.982 113.806 186.073 113.897C186.073 113.806 186.073 113.897 186.073 113.897Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.354 113.264C184.354 113.354 184.263 113.354 184.263 113.354C184.173 113.354 184.173 113.264 184.173 113.264C184.173 113.173 184.263 113.173 184.263 113.173C184.263 113.173 184.354 113.173 184.354 113.264Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.092 107.836C182.092 107.926 182.002 108.017 181.911 108.017C181.821 108.017 181.73 107.926 181.73 107.836C181.73 107.745 181.821 107.655 181.911 107.655C182.092 107.655 182.092 107.745 182.092 107.836Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.645 107.745C180.744 107.745 180.825 107.664 180.825 107.564C180.825 107.464 180.744 107.383 180.645 107.383C180.545 107.383 180.464 107.464 180.464 107.564C180.464 107.664 180.545 107.745 180.645 107.745Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.84 101.503C177.89 101.503 177.931 101.463 177.931 101.413C177.931 101.363 177.89 101.322 177.84 101.322C177.79 101.322 177.75 101.363 177.75 101.413C177.75 101.463 177.79 101.503 177.84 101.503Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.774 101.865C172.774 101.955 172.684 101.955 172.684 101.955C172.593 101.955 172.593 101.865 172.593 101.865C172.593 101.775 172.684 101.775 172.684 101.775C172.774 101.775 172.774 101.865 172.774 101.865Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.569 112.811C177.569 112.902 177.478 112.992 177.388 112.992C177.297 112.992 177.207 112.902 177.207 112.811C177.207 112.721 177.297 112.63 177.388 112.63C177.569 112.63 177.569 112.721 177.569 112.811Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.112 113.535C178.112 113.625 178.021 113.716 177.931 113.716C177.84 113.716 177.75 113.625 177.75 113.535C177.75 113.444 177.84 113.354 177.931 113.354C178.021 113.263 178.112 113.354 178.112 113.535Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.826 116.792C180.826 116.882 180.735 117.063 180.554 117.063C180.373 117.063 180.283 116.973 180.283 116.792C180.283 116.611 180.373 116.52 180.554 116.52C180.735 116.52 180.826 116.701 180.826 116.792Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.549 117.063C181.549 117.153 181.459 117.244 181.368 117.244C181.278 117.244 181.187 117.153 181.187 117.063C181.187 116.973 181.278 116.882 181.368 116.882C181.459 116.882 181.549 116.973 181.549 117.063Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.368 115.796C181.368 115.977 181.187 116.158 181.006 116.158C180.825 116.158 180.645 115.977 180.645 115.796C180.645 115.616 180.825 115.435 181.006 115.435C181.187 115.435 181.368 115.616 181.368 115.796Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.187 115.073C181.187 115.163 181.097 115.254 181.006 115.254C180.916 115.254 180.825 115.163 180.825 115.073C180.825 114.982 180.916 114.892 181.006 114.892C181.097 114.892 181.187 114.982 181.187 115.073Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.916 113.535C180.916 113.625 180.826 113.806 180.645 113.806C180.554 113.806 180.373 113.716 180.373 113.535C180.373 113.444 180.464 113.263 180.645 113.263C180.826 113.354 180.916 113.444 180.916 113.535Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.92 110.821C179.92 110.821 179.92 110.911 179.92 110.821C179.831 110.911 179.831 110.821 179.92 110.821C179.831 110.821 179.831 110.821 179.92 110.821Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.83 109.916C179.83 110.007 179.74 110.097 179.649 110.097C179.559 110.097 179.469 110.007 179.469 109.916C179.469 109.826 179.559 109.735 179.649 109.735C179.74 109.735 179.83 109.826 179.83 109.916Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.474 107.745C178.623 107.745 178.745 107.624 178.745 107.474C178.745 107.324 178.623 107.202 178.474 107.202C178.324 107.202 178.202 107.324 178.202 107.474C178.202 107.624 178.324 107.745 178.474 107.745Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.297 103.946C177.297 104.036 177.207 104.217 177.026 104.217C176.936 104.217 176.755 104.127 176.755 103.946C176.755 103.855 176.845 103.674 177.026 103.674C177.207 103.765 177.297 103.855 177.297 103.946Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.936 103.403C176.936 103.584 176.755 103.765 176.574 103.765C176.393 103.765 176.212 103.584 176.212 103.403C176.212 103.222 176.393 103.041 176.574 103.041C176.755 103.041 176.936 103.222 176.936 103.403Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.493 100.689C174.493 100.779 174.402 100.87 174.312 100.87C174.222 100.87 174.131 100.779 174.131 100.689C174.131 100.598 174.222 100.508 174.312 100.508C174.402 100.508 174.493 100.598 174.493 100.689Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.065 100.508C169.065 100.689 168.884 100.87 168.703 100.87C168.522 100.87 168.342 100.689 168.342 100.508C168.342 100.327 168.522 100.146 168.703 100.146C168.884 100.146 169.065 100.327 169.065 100.508Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.613 102.136C168.613 102.317 168.432 102.498 168.251 102.498C168.07 102.498 167.889 102.317 167.889 102.136C167.889 101.955 168.07 101.775 168.251 101.775C168.522 101.865 168.613 101.955 168.613 102.136Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.383 112.811C178.383 112.902 178.293 112.902 178.383 112.811C178.293 112.902 178.293 112.811 178.293 112.811C178.202 112.811 178.293 112.811 178.383 112.811C178.293 112.811 178.383 112.811 178.383 112.811Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.106 113.173C179.016 113.173 179.016 113.173 179.106 113.173C179.016 113.083 179.016 113.083 179.106 113.173C179.106 113.083 179.106 113.083 179.106 113.173Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.694 105.936C170.694 106.026 170.603 106.117 170.513 106.117C170.422 106.117 170.332 106.026 170.332 105.936C170.332 105.845 170.422 105.755 170.513 105.755C170.694 105.755 170.694 105.845 170.694 105.936Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.161 104.398C168.361 104.398 168.523 104.236 168.523 104.036C168.523 103.836 168.361 103.674 168.161 103.674C167.961 103.674 167.799 103.836 167.799 104.036C167.799 104.236 167.961 104.398 168.161 104.398Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.537 102.136C165.537 102.227 165.447 102.227 165.447 102.227C165.356 102.227 165.356 102.136 165.356 102.136C165.356 102.046 165.447 102.046 165.447 102.046C165.447 102.046 165.537 102.136 165.537 102.136Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.928 102.498C159.978 102.498 160.019 102.458 160.019 102.408C160.019 102.358 159.978 102.317 159.928 102.317C159.878 102.317 159.838 102.358 159.838 102.408C159.838 102.458 159.878 102.498 159.928 102.498Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.461 106.569C162.461 106.66 162.371 106.75 162.28 106.75C162.19 106.75 162.099 106.66 162.099 106.569C162.099 106.479 162.19 106.388 162.28 106.388C162.371 106.388 162.461 106.479 162.461 106.569Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.627 109.826C165.627 109.916 165.627 109.916 165.627 109.826C165.537 109.916 165.447 109.916 165.447 109.826C165.537 109.826 165.537 109.826 165.627 109.826Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.488 119.415C175.488 119.596 175.398 119.686 175.217 119.686C175.036 119.686 174.945 119.596 174.945 119.415C174.945 119.234 175.036 119.144 175.217 119.144C175.307 119.144 175.488 119.234 175.488 119.415Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.031 121.224C176.081 121.224 176.121 121.184 176.121 121.134C176.121 121.084 176.081 121.043 176.031 121.043C175.981 121.043 175.94 121.084 175.94 121.134C175.94 121.184 175.981 121.224 176.031 121.224Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.833 108.378C161.033 108.378 161.195 108.216 161.195 108.017C161.195 107.817 161.033 107.655 160.833 107.655C160.633 107.655 160.471 107.817 160.471 108.017C160.471 108.216 160.633 108.378 160.833 108.378Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.532 111.635C166.532 111.907 166.351 112.087 166.08 112.087C165.808 112.087 165.627 111.907 165.627 111.635C165.627 111.364 165.808 111.183 166.08 111.183C166.351 111.183 166.532 111.454 166.532 111.635Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.728 106.117C163.728 106.298 163.547 106.479 163.366 106.479C163.185 106.479 163.004 106.298 163.004 106.117C163.004 105.936 163.185 105.755 163.366 105.755C163.547 105.665 163.728 105.845 163.728 106.117Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.918 102.498C161.918 102.589 161.828 102.679 161.738 102.679C161.647 102.679 161.557 102.589 161.557 102.498C161.557 102.408 161.647 102.317 161.738 102.317C161.918 102.317 161.918 102.408 161.918 102.498Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.887 121.405C149.887 121.496 149.796 121.496 149.796 121.496L149.706 121.405C149.706 121.315 149.796 121.315 149.796 121.315C149.796 121.315 149.887 121.315 149.887 121.405Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.53 121.315C148.53 121.315 148.53 121.406 148.53 121.315C148.53 121.406 148.439 121.315 148.53 121.315C148.439 121.315 148.53 121.315 148.53 121.315Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.183 121.405C145.183 121.496 145.092 121.586 145.002 121.586C144.911 121.586 144.821 121.496 144.821 121.405C144.821 121.315 144.911 121.224 145.002 121.224C145.092 121.224 145.183 121.315 145.183 121.405Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.097 121.586C144.097 121.677 144.006 121.677 144.006 121.677C143.916 121.677 143.916 121.586 143.916 121.586C143.916 121.496 144.006 121.496 144.006 121.496C144.006 121.496 144.097 121.496 144.097 121.586Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.926 121.496C141.926 121.586 141.835 121.677 141.745 121.677C141.654 121.677 141.564 121.586 141.564 121.496C141.564 121.405 141.654 121.315 141.745 121.315C141.835 121.315 141.926 121.405 141.926 121.496Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.532 128.099C129.442 128.099 129.442 128.099 129.532 128.099C129.442 128.099 129.442 128.009 129.532 128.099C129.532 128.009 129.532 128.099 129.532 128.099Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.999 130.542C126.999 130.633 126.909 130.633 126.909 130.633C126.818 130.633 126.818 130.542 126.818 130.542C126.818 130.452 126.909 130.452 126.909 130.452C126.999 130.452 126.999 130.452 126.999 130.542Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.281 132.623C125.38 132.623 125.461 132.542 125.461 132.442C125.461 132.342 125.38 132.261 125.281 132.261C125.181 132.261 125.1 132.342 125.1 132.442C125.1 132.542 125.181 132.623 125.281 132.623Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.381 136.422C123.381 136.513 123.29 136.513 123.29 136.513C123.2 136.513 123.2 136.422 123.2 136.422C123.2 136.332 123.29 136.332 123.29 136.332C123.381 136.332 123.381 136.332 123.381 136.422Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.901 129.637C146.811 129.728 146.811 129.637 146.811 129.637C146.72 129.547 146.811 129.547 146.901 129.637C146.901 129.547 146.901 129.547 146.901 129.637Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.557 125.838C161.557 126.019 161.466 126.109 161.285 126.109C161.104 126.109 161.014 126.019 161.014 125.838C161.014 125.657 161.104 125.567 161.285 125.567C161.466 125.567 161.557 125.657 161.557 125.838Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.813 125.114C164.813 125.205 164.723 125.295 164.632 125.295C164.542 125.295 164.451 125.205 164.451 125.114C164.451 125.024 164.542 124.933 164.632 124.933C164.723 125.024 164.813 125.024 164.813 125.114Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.141 129.004C172.141 129.185 171.96 129.366 171.779 129.366C171.598 129.366 171.417 129.185 171.417 129.004C171.417 128.823 171.598 128.642 171.779 128.642C171.96 128.642 172.141 128.823 172.141 129.004Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.241 129.999C170.291 129.999 170.332 129.959 170.332 129.909C170.332 129.859 170.291 129.818 170.241 129.818C170.191 129.818 170.151 129.859 170.151 129.909C170.151 129.959 170.191 129.999 170.241 129.999Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.156 130.452C169.156 130.542 169.065 130.633 168.975 130.633C168.884 130.633 168.794 130.542 168.794 130.452C168.794 130.361 168.884 130.271 168.975 130.271C169.065 130.271 169.156 130.361 169.156 130.452Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.804 131.447C166.804 131.537 166.713 131.718 166.532 131.718C166.442 131.718 166.261 131.628 166.261 131.447C166.261 131.356 166.351 131.175 166.532 131.175C166.713 131.175 166.804 131.266 166.804 131.447Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.466 132.713C161.566 132.713 161.647 132.632 161.647 132.532C161.647 132.432 161.566 132.351 161.466 132.351C161.366 132.351 161.285 132.432 161.285 132.532C161.285 132.632 161.366 132.713 161.466 132.713Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.476 132.623C159.476 132.713 159.385 132.804 159.295 132.804C159.204 132.804 159.114 132.713 159.114 132.623C159.114 132.532 159.204 132.442 159.295 132.442C159.385 132.442 159.476 132.532 159.476 132.623Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.938 132.713C157.938 132.894 157.757 133.075 157.576 133.075C157.395 133.075 157.214 132.894 157.214 132.713C157.214 132.532 157.395 132.351 157.576 132.351C157.757 132.351 157.938 132.532 157.938 132.713Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.897 132.623C147.897 132.804 147.806 132.894 147.625 132.894C147.444 132.894 147.354 132.804 147.354 132.623C147.354 132.442 147.444 132.351 147.625 132.351C147.806 132.351 147.897 132.442 147.897 132.623Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.921 132.713C142.921 132.894 142.83 132.985 142.65 132.985C142.469 132.985 142.378 132.894 142.378 132.713C142.378 132.532 142.469 132.442 142.65 132.442C142.74 132.442 142.921 132.623 142.921 132.713Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.75 133.527C140.75 133.618 140.659 133.708 140.569 133.708C140.478 133.708 140.388 133.618 140.388 133.527C140.388 133.437 140.478 133.347 140.569 133.347C140.659 133.347 140.75 133.347 140.75 133.527Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.131 134.613C137.131 134.703 137.041 134.794 136.95 134.794C136.86 134.794 136.77 134.703 136.77 134.613C136.77 134.523 136.86 134.432 136.95 134.432C137.041 134.523 137.131 134.523 137.131 134.613Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.241 136.06C133.441 136.06 133.603 135.898 133.603 135.699C133.603 135.499 133.441 135.337 133.241 135.337C133.041 135.337 132.879 135.499 132.879 135.699C132.879 135.898 133.041 136.06 133.241 136.06Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.281 138.684C125.281 138.775 125.281 138.775 125.281 138.684C125.19 138.775 125.19 138.684 125.19 138.684C125.19 138.684 125.19 138.684 125.281 138.684Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.437 138.232C130.437 138.412 130.256 138.684 129.985 138.684C129.804 138.684 129.532 138.503 129.532 138.232C129.532 138.051 129.713 137.779 129.985 137.779C130.256 137.779 130.437 137.96 130.437 138.232Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.806 136.422C147.806 136.603 147.625 136.784 147.444 136.784C147.263 136.784 147.082 136.603 147.082 136.422C147.082 136.241 147.263 136.06 147.444 136.06C147.625 136.06 147.806 136.241 147.806 136.422Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.08 136.332C166.23 136.332 166.351 136.21 166.351 136.06C166.351 135.911 166.23 135.789 166.08 135.789C165.93 135.789 165.809 135.911 165.809 136.06C165.809 136.21 165.93 136.332 166.08 136.332Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.146 135.337C171.196 135.337 171.236 135.296 171.236 135.246C171.236 135.196 171.196 135.156 171.146 135.156C171.096 135.156 171.055 135.196 171.055 135.246C171.055 135.296 171.096 135.337 171.146 135.337Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.055 133.527C171.055 133.618 171.055 133.618 171.055 133.527C170.965 133.618 170.875 133.527 170.875 133.527C170.875 133.527 170.965 133.527 171.055 133.527Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.161 134.07C168.21 134.07 168.251 134.03 168.251 133.98C168.251 133.93 168.21 133.889 168.161 133.889C168.111 133.889 168.07 133.93 168.07 133.98C168.07 134.03 168.111 134.07 168.161 134.07Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.537 134.432C165.587 134.432 165.627 134.392 165.627 134.342C165.627 134.292 165.587 134.251 165.537 134.251C165.487 134.251 165.447 134.292 165.447 134.342C165.447 134.392 165.487 134.432 165.537 134.432Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.444 136.694C147.444 136.784 147.354 136.875 147.263 136.875C147.173 136.875 147.082 136.784 147.082 136.694C147.082 136.603 147.173 136.513 147.263 136.513C147.354 136.513 147.444 136.603 147.444 136.694Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.051 139.227C135.15 139.227 135.231 139.146 135.231 139.046C135.231 138.946 135.15 138.865 135.051 138.865C134.951 138.865 134.87 138.946 134.87 139.046C134.87 139.146 134.951 139.227 135.051 139.227Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.613 139.95C131.663 139.95 131.703 139.91 131.703 139.86C131.703 139.81 131.663 139.769 131.613 139.769C131.563 139.769 131.522 139.81 131.522 139.86C131.522 139.91 131.563 139.95 131.613 139.95Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.366 141.76C126.516 141.76 126.638 141.638 126.638 141.488C126.638 141.338 126.516 141.217 126.366 141.217C126.216 141.217 126.095 141.338 126.095 141.488C126.095 141.638 126.216 141.76 126.366 141.76Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.838 137.056C122.838 137.236 122.747 137.327 122.567 137.327C122.386 137.327 122.295 137.236 122.295 137.056C122.295 136.875 122.386 136.784 122.567 136.784C122.657 136.784 122.838 136.875 122.838 137.056Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.965 133.075C133.965 133.256 133.784 133.347 133.694 133.347C133.513 133.347 133.422 133.166 133.422 133.075C133.422 132.894 133.603 132.804 133.694 132.804C133.784 132.804 133.965 132.894 133.965 133.075Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.408 129.547C136.408 129.728 136.317 129.818 136.136 129.818C135.955 129.818 135.865 129.728 135.865 129.547C135.865 129.366 135.955 129.276 136.136 129.276C136.317 129.366 136.408 129.457 136.408 129.547Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.95 128.823C136.95 129.004 136.769 129.185 136.588 129.185C136.407 129.185 136.227 129.004 136.227 128.823C136.227 128.642 136.407 128.461 136.588 128.461C136.769 128.461 136.95 128.552 136.95 128.823Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.217 125.657C138.217 125.838 138.036 126.019 137.855 126.019C137.674 126.019 137.493 125.838 137.493 125.657C137.493 125.476 137.674 125.295 137.855 125.295C138.036 125.295 138.217 125.476 138.217 125.657Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.369 124.662C144.518 124.662 144.64 124.54 144.64 124.391C144.64 124.241 144.518 124.119 144.369 124.119C144.219 124.119 144.097 124.241 144.097 124.391C144.097 124.54 144.219 124.662 144.369 124.662Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.987 123.395C147.987 123.486 147.897 123.486 147.897 123.486C147.806 123.486 147.806 123.395 147.806 123.395C147.806 123.305 147.897 123.305 147.897 123.305C147.987 123.305 147.987 123.305 147.987 123.395Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.031 114.892C139.181 114.892 139.303 114.77 139.303 114.62C139.303 114.471 139.181 114.349 139.031 114.349C138.881 114.349 138.76 114.471 138.76 114.62C138.76 114.77 138.881 114.892 139.031 114.892Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.946 116.158C138.145 116.158 138.307 115.996 138.307 115.796C138.307 115.597 138.145 115.435 137.946 115.435C137.746 115.435 137.584 115.597 137.584 115.796C137.584 115.996 137.746 116.158 137.946 116.158Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.584 116.52C137.584 116.611 137.584 116.611 137.493 116.611C137.403 116.611 137.403 116.611 137.403 116.52C137.403 116.43 137.403 116.43 137.493 116.43C137.584 116.43 137.584 116.52 137.584 116.52Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.655 118.059C141.564 118.15 141.564 118.059 141.564 118.059C141.564 117.967 141.564 117.967 141.655 118.059C141.655 117.967 141.655 117.967 141.655 118.059Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.002 117.606C145.202 117.606 145.364 117.444 145.364 117.244C145.364 117.044 145.202 116.882 145.002 116.882C144.802 116.882 144.64 117.044 144.64 117.244C144.64 117.444 144.802 117.606 145.002 117.606Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.364 117.515C145.364 117.606 145.273 117.696 145.183 117.696C145.092 117.696 145.002 117.606 145.002 117.515C145.002 117.425 145.092 117.334 145.183 117.334C145.273 117.334 145.364 117.425 145.364 117.515Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.716 126.109C147.716 126.29 147.535 126.471 147.354 126.471C147.173 126.471 146.992 126.29 146.992 126.109C146.992 125.928 147.173 125.748 147.354 125.748C147.535 125.657 147.716 125.838 147.716 126.109Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.322 130.452C135.322 130.542 135.232 130.633 135.141 130.633C135.051 130.633 134.96 130.542 134.96 130.452C134.96 130.361 135.051 130.271 135.141 130.271C135.232 130.271 135.322 130.361 135.322 130.452Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.122 141.307C139.122 141.398 139.031 141.398 139.031 141.398C138.941 141.398 138.941 141.307 138.941 141.307C138.941 141.217 139.031 141.217 139.031 141.217C139.122 141.217 139.122 141.217 139.122 141.307Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.708 129.637C167.708 129.728 167.618 129.818 167.527 129.818C167.437 129.818 167.346 129.728 167.346 129.637C167.346 129.547 167.437 129.457 167.527 129.457C167.618 129.457 167.708 129.547 167.708 129.637Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.879 127.919C169.879 128.009 169.789 128.009 169.789 128.009C169.698 128.009 169.698 127.919 169.698 127.919L169.789 127.828C169.879 127.828 169.879 127.828 169.879 127.919Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.703 129.638C168.703 129.727 168.703 129.727 168.703 129.638C168.613 129.727 168.613 129.727 168.703 129.638C168.613 129.638 168.613 129.638 168.703 129.638Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.346 131.447C167.446 131.447 167.527 131.366 167.527 131.266C167.527 131.166 167.446 131.085 167.346 131.085C167.247 131.085 167.166 131.166 167.166 131.266C167.166 131.366 167.247 131.447 167.346 131.447Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.804 130.542C166.804 130.723 166.623 130.904 166.442 130.904C166.261 130.904 166.08 130.723 166.08 130.542C166.08 130.361 166.261 130.18 166.442 130.18C166.623 130.18 166.804 130.361 166.804 130.542Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.18 131.99C164.18 132.17 163.999 132.351 163.818 132.351C163.637 132.351 163.457 132.17 163.457 131.99C163.457 131.809 163.637 131.628 163.818 131.628C163.999 131.628 164.18 131.809 164.18 131.99Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.447 128.642C165.497 128.642 165.537 128.602 165.537 128.552C165.537 128.502 165.497 128.461 165.447 128.461C165.397 128.461 165.356 128.502 165.356 128.552C165.356 128.602 165.397 128.642 165.447 128.642Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.295 131.085C159.545 131.085 159.747 130.882 159.747 130.633C159.747 130.383 159.545 130.18 159.295 130.18C159.045 130.18 158.843 130.383 158.843 130.633C158.843 130.882 159.045 131.085 159.295 131.085Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.41 132.894C154.41 132.894 154.41 132.985 154.41 132.894C154.229 132.985 154.229 132.985 154.229 132.894C154.229 132.804 154.319 132.804 154.41 132.894C154.41 132.804 154.41 132.804 154.41 132.894Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.867 131.085C153.867 131.175 153.777 131.175 153.777 131.175C153.686 131.175 153.686 131.085 153.686 131.085C153.686 130.994 153.777 130.994 153.777 130.994C153.867 130.904 153.867 130.994 153.867 131.085Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.175 124.572C165.175 124.752 164.994 124.933 164.813 124.933C164.632 124.933 164.451 124.752 164.451 124.572C164.451 124.391 164.632 124.21 164.813 124.21C164.994 124.21 165.175 124.3 165.175 124.572Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.799 123.305C167.799 123.395 167.708 123.395 167.708 123.395L167.618 123.305L167.708 123.215L167.799 123.305Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.344 106.75C149.344 106.931 149.163 107.112 148.982 107.112C148.801 107.112 148.62 106.931 148.62 106.75C148.62 106.569 148.801 106.388 148.982 106.388C149.254 106.388 149.344 106.569 149.344 106.75Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.721 107.112C146.721 107.203 146.721 107.203 146.721 107.112C146.63 107.203 146.63 107.112 146.63 107.112C146.63 107.112 146.63 107.112 146.721 107.112Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.449 110.188C146.549 110.188 146.63 110.107 146.63 110.007C146.63 109.907 146.549 109.826 146.449 109.826C146.349 109.826 146.268 109.907 146.268 110.007C146.268 110.107 146.349 110.188 146.449 110.188Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.877 112.268C151.877 112.359 151.787 112.449 151.696 112.449C151.606 112.449 151.515 112.359 151.515 112.268C151.515 112.178 151.606 112.087 151.696 112.087C151.787 112.087 151.877 112.087 151.877 112.268Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.948 115.254C155.948 115.435 155.857 115.525 155.676 115.525C155.495 115.525 155.405 115.435 155.405 115.254C155.405 115.073 155.495 114.982 155.676 114.982C155.857 114.982 155.948 115.163 155.948 115.254Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.652 115.163C160.652 115.344 160.562 115.435 160.381 115.435C160.2 115.435 160.109 115.344 160.109 115.163C160.109 114.982 160.2 114.892 160.381 114.892C160.562 114.892 160.652 115.073 160.652 115.163Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.667 114.168C157.667 114.349 157.576 114.44 157.395 114.44C157.214 114.44 157.124 114.349 157.124 114.168C157.124 113.987 157.214 113.897 157.395 113.897C157.486 113.897 157.667 113.987 157.667 114.168Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.767 113.716C155.767 113.897 155.586 114.078 155.405 114.078C155.224 114.078 155.043 113.897 155.043 113.716C155.043 113.535 155.224 113.354 155.405 113.354C155.586 113.354 155.767 113.444 155.767 113.716Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.229 113.263C154.229 113.354 154.139 113.444 154.048 113.444C153.958 113.444 153.867 113.354 153.867 113.263C153.867 113.173 153.958 113.083 154.048 113.083C154.139 113.083 154.229 113.173 154.229 113.263Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.616 111.002C149.616 111.092 149.525 111.183 149.435 111.183C149.344 111.183 149.254 111.092 149.254 111.002C149.254 110.911 149.344 110.821 149.435 110.821C149.525 110.821 149.616 110.911 149.616 111.002Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.987 109.373C147.987 109.645 147.806 109.826 147.535 109.826C147.263 109.826 147.082 109.645 147.082 109.373C147.082 109.102 147.263 108.921 147.535 108.921C147.806 108.921 147.987 109.102 147.987 109.373Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.972 110.097C150.972 110.278 150.791 110.459 150.61 110.459C150.429 110.459 150.249 110.278 150.249 110.097C150.249 109.916 150.429 109.735 150.61 109.735C150.791 109.645 150.972 109.826 150.972 110.097Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.134 113.354C155.134 113.444 155.043 113.535 154.953 113.535C154.862 113.535 154.772 113.444 154.772 113.354C154.772 113.263 154.862 113.173 154.953 113.173C155.043 113.173 155.134 113.263 155.134 113.354Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.657 115.706C159.707 115.706 159.747 115.666 159.747 115.616C159.747 115.566 159.707 115.525 159.657 115.525C159.607 115.525 159.566 115.566 159.566 115.616C159.566 115.666 159.607 115.706 159.657 115.706Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.547 116.611C163.547 116.701 163.456 116.701 163.456 116.701C163.366 116.701 163.366 116.611 163.366 116.611C163.366 116.52 163.456 116.52 163.456 116.52C163.456 116.52 163.547 116.611 163.547 116.611Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.129 108.017C156.279 108.017 156.4 107.895 156.4 107.745C156.4 107.595 156.279 107.474 156.129 107.474C155.979 107.474 155.857 107.595 155.857 107.745C155.857 107.895 155.979 108.017 156.129 108.017Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.811 103.674C147.011 103.674 147.173 103.512 147.173 103.312C147.173 103.113 147.011 102.951 146.811 102.951C146.611 102.951 146.449 103.113 146.449 103.312C146.449 103.512 146.611 103.674 146.811 103.674Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.73 102.77C144.78 102.77 144.821 102.729 144.821 102.679C144.821 102.629 144.78 102.589 144.73 102.589C144.68 102.589 144.64 102.629 144.64 102.679C144.64 102.729 144.68 102.77 144.73 102.77Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.922 102.136C142.922 102.227 142.922 102.227 142.922 102.136C142.831 102.227 142.831 102.136 142.831 102.136H142.922Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.826 105.393C143.826 105.574 143.645 105.755 143.464 105.755C143.283 105.755 143.102 105.574 143.102 105.393C143.102 105.212 143.283 105.031 143.464 105.031C143.645 105.031 143.826 105.212 143.826 105.393Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.821 106.931C144.821 107.021 144.73 107.112 144.64 107.112C144.549 107.112 144.459 107.021 144.459 106.931C144.459 106.841 144.549 106.75 144.64 106.75C144.73 106.75 144.821 106.841 144.821 106.931Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.816 108.65C145.816 108.921 145.635 109.102 145.364 109.102C145.092 109.102 144.911 108.921 144.911 108.65C144.911 108.378 145.092 108.197 145.364 108.197C145.635 108.197 145.816 108.378 145.816 108.65Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.64 107.745C144.64 107.836 144.549 107.926 144.459 107.926C144.369 107.926 144.278 107.836 144.278 107.745C144.278 107.655 144.369 107.564 144.459 107.564C144.549 107.655 144.64 107.655 144.64 107.745Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.479 105.122C140.479 105.212 140.388 105.303 140.298 105.303C140.207 105.303 140.117 105.212 140.117 105.122C140.117 105.031 140.207 104.941 140.298 104.941C140.388 104.941 140.479 104.941 140.479 105.122Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.95 102.498C136.95 102.589 136.95 102.589 136.95 102.498C136.86 102.589 136.77 102.498 136.77 102.498C136.77 102.498 136.86 102.408 136.95 102.498C136.95 102.408 136.95 102.498 136.95 102.498Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.865 101.955C136.015 101.955 136.136 101.834 136.136 101.684C136.136 101.534 136.015 101.413 135.865 101.413C135.715 101.413 135.594 101.534 135.594 101.684C135.594 101.834 135.715 101.955 135.865 101.955Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.96 100.598C135.16 100.598 135.322 100.436 135.322 100.237C135.322 100.037 135.16 99.8748 134.96 99.8748C134.76 99.8748 134.598 100.037 134.598 100.237C134.598 100.436 134.76 100.598 134.96 100.598Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.97 92.1849C132.97 92.1849 132.88 92.1849 132.97 92.1849C132.88 92.1849 132.88 92.1849 132.97 92.1849C132.88 92.095 132.88 92.095 132.97 92.1849C132.88 92.095 132.97 92.095 132.97 92.1849Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.769 96.8895C136.769 97.0704 136.588 97.2513 136.408 97.2513C136.227 97.2513 136.046 97.0704 136.046 96.8895C136.046 96.7085 136.227 96.5276 136.408 96.5276C136.588 96.5276 136.769 96.6181 136.769 96.8895Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.679 87.4812C136.679 87.5717 136.589 87.7526 136.408 87.7526C136.317 87.7526 136.136 87.6621 136.136 87.4812C136.136 87.3907 136.227 87.2098 136.408 87.2098C136.589 87.2098 136.679 87.3907 136.679 87.4812Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.503 91.4616C135.653 91.4616 135.774 91.3401 135.774 91.1902C135.774 91.0403 135.653 90.9188 135.503 90.9188C135.353 90.9188 135.232 91.0403 135.232 91.1902C135.232 91.3401 135.353 91.4616 135.503 91.4616Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.865 96.1658C135.865 96.2562 135.774 96.2562 135.774 96.2562C135.684 96.2562 135.684 96.1658 135.684 96.1658C135.684 96.0753 135.774 96.0753 135.774 96.0753C135.774 96.0753 135.865 96.1658 135.865 96.1658Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.941 100.056C139.09 100.056 139.212 99.9342 139.212 99.7843C139.212 99.6344 139.09 99.5129 138.941 99.5129C138.791 99.5129 138.669 99.6344 138.669 99.7843C138.669 99.9342 138.791 100.056 138.941 100.056Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.026 100.599C140.176 100.599 140.298 100.477 140.298 100.327C140.298 100.177 140.176 100.056 140.026 100.056C139.876 100.056 139.755 100.177 139.755 100.327C139.755 100.477 139.876 100.599 140.026 100.599Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.74 101.413C142.74 101.413 142.74 101.503 142.74 101.413C142.65 101.503 142.65 101.413 142.74 101.413C142.65 101.413 142.65 101.413 142.74 101.413Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.087 102.77C146.087 102.77 145.997 102.77 146.087 102.77C145.997 102.86 145.906 102.77 145.906 102.77C145.906 102.77 145.906 102.679 146.087 102.77C145.997 102.679 146.087 102.679 146.087 102.77Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.635 100.96C145.635 101.141 145.454 101.232 145.363 101.232C145.182 101.232 145.092 101.051 145.092 100.96C145.092 100.779 145.273 100.689 145.363 100.689C145.544 100.689 145.635 100.779 145.635 100.96Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.926 100.327C142.076 100.327 142.197 100.206 142.197 100.056C142.197 99.9058 142.076 99.7843 141.926 99.7843C141.776 99.7843 141.655 99.9058 141.655 100.056C141.655 100.206 141.776 100.327 141.926 100.327Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.021 99.9652C141.121 99.9652 141.202 99.8842 141.202 99.7843C141.202 99.6844 141.121 99.6034 141.021 99.6034C140.921 99.6034 140.84 99.6844 140.84 99.7843C140.84 99.8842 140.921 99.9652 141.021 99.9652Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.117 85.491C140.117 85.5815 140.026 85.6719 139.936 85.6719C139.845 85.6719 139.755 85.5815 139.755 85.491C139.755 85.4005 139.845 85.3101 139.936 85.3101C140.026 85.2196 140.117 85.3101 140.117 85.491Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.094 125.295C163.094 125.386 163.004 125.386 163.094 125.295C163.004 125.386 162.914 125.295 162.914 125.295C162.914 125.295 162.914 125.205 163.094 125.295C163.004 125.205 163.094 125.295 163.094 125.295Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.833 124.933C160.743 124.933 160.743 124.933 160.833 124.933C160.743 124.933 160.743 124.843 160.833 124.933C160.833 124.843 160.833 124.933 160.833 124.933Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.752 124.662C158.752 124.843 158.571 125.024 158.39 125.024C158.21 125.024 158.029 124.843 158.029 124.662C158.029 124.481 158.21 124.3 158.39 124.3C158.571 124.3 158.752 124.481 158.752 124.662Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.858 125.748C155.858 125.839 155.767 125.839 155.858 125.748C155.767 125.839 155.767 125.748 155.767 125.748C155.767 125.748 155.767 125.748 155.858 125.748C155.767 125.748 155.858 125.748 155.858 125.748Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.787 127.557C151.936 127.557 152.058 127.435 152.058 127.285C152.058 127.136 151.936 127.014 151.787 127.014C151.637 127.014 151.515 127.136 151.515 127.285C151.515 127.435 151.637 127.557 151.787 127.557Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.354 129.276C147.504 129.276 147.625 129.154 147.625 129.004C147.625 128.854 147.504 128.733 147.354 128.733C147.204 128.733 147.082 128.854 147.082 129.004C147.082 129.154 147.204 129.276 147.354 129.276Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.62 129.637C148.62 129.728 148.53 129.818 148.439 129.818C148.349 129.818 148.258 129.728 148.258 129.637C148.258 129.547 148.349 129.457 148.439 129.457C148.53 129.457 148.62 129.547 148.62 129.637Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.083 129.367C146.992 129.458 146.992 129.367 146.992 129.367C146.992 129.276 146.992 129.276 147.083 129.367C147.083 129.276 147.083 129.276 147.083 129.367Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.207 130.633C140.207 130.814 140.117 130.904 139.936 130.904C139.755 130.904 139.664 130.814 139.664 130.633C139.664 130.452 139.755 130.361 139.936 130.361C140.117 130.361 140.207 130.452 140.207 130.633Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.73 129.185C144.73 129.366 144.549 129.547 144.368 129.547C144.188 129.547 144.007 129.366 144.007 129.185C144.007 129.004 144.188 128.823 144.368 128.823C144.549 128.823 144.73 129.004 144.73 129.185Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.726 133.618C145.726 133.618 145.635 133.618 145.726 133.618C145.635 133.71 145.635 133.618 145.635 133.618C145.635 133.527 145.635 133.527 145.726 133.618C145.635 133.527 145.726 133.527 145.726 133.618Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.007 134.07C144.007 134.161 143.916 134.342 143.735 134.342C143.645 134.342 143.464 134.251 143.464 134.07C143.464 133.98 143.554 133.799 143.735 133.799C143.916 133.889 144.007 133.98 144.007 134.07Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.378 134.07C142.378 134.161 142.288 134.161 142.288 134.161C142.197 134.161 142.197 134.07 142.197 134.07C142.197 133.98 142.288 133.98 142.288 133.98C142.288 133.98 142.378 133.98 142.378 134.07Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.774 134.704C135.774 134.794 135.684 134.794 135.684 134.794C135.593 134.794 135.594 134.704 135.594 134.704C135.594 134.613 135.684 134.613 135.684 134.613C135.684 134.613 135.774 134.704 135.774 134.704Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.523 134.432C131.523 134.523 131.432 134.613 131.342 134.613C131.251 134.613 131.161 134.523 131.161 134.432C131.161 134.342 131.251 134.251 131.342 134.251C131.432 134.251 131.523 134.251 131.523 134.432Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.919 133.708C124.919 133.799 124.828 133.799 124.828 133.799C124.738 133.799 124.738 133.708 124.738 133.708C124.738 133.618 124.828 133.618 124.828 133.618C124.828 133.618 124.919 133.618 124.919 133.708Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.844 133.437C121.844 133.528 121.844 133.528 121.844 133.437C121.752 133.528 121.752 133.437 121.752 133.437H121.844Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.295 133.889C122.295 134.07 122.114 134.251 121.933 134.251C121.752 134.251 121.572 134.07 121.572 133.889C121.572 133.708 121.752 133.527 121.933 133.527C122.114 133.527 122.295 133.708 122.295 133.889Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.285 135.156C124.485 135.156 124.647 134.994 124.647 134.794C124.647 134.594 124.485 134.432 124.285 134.432C124.086 134.432 123.924 134.594 123.924 134.794C123.924 134.994 124.086 135.156 124.285 135.156Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.742 135.156C123.742 135.246 123.652 135.246 123.742 135.156C123.652 135.246 123.652 135.246 123.742 135.156C123.652 135.156 123.652 135.156 123.742 135.156C123.652 135.156 123.742 135.156 123.742 135.156Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.119 134.342C121.119 134.432 121.119 134.432 121.029 134.432C120.938 134.432 120.938 134.432 120.938 134.342C120.938 134.251 120.938 134.251 121.029 134.251C121.119 134.251 121.119 134.251 121.119 134.342Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.762 133.799C119.862 133.799 119.943 133.718 119.943 133.618C119.943 133.518 119.862 133.437 119.762 133.437C119.662 133.437 119.581 133.518 119.581 133.618C119.581 133.718 119.662 133.799 119.762 133.799Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.767 132.985C118.767 133.075 118.677 133.075 118.677 133.075C118.586 133.075 118.586 132.985 118.586 132.985C118.586 132.894 118.677 132.894 118.677 132.894C118.767 132.894 118.767 132.985 118.767 132.985Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.857 137.96C118.857 138.051 118.767 138.141 118.677 138.141C118.586 138.141 118.496 138.051 118.496 137.96C118.496 137.87 118.586 137.779 118.677 137.779C118.767 137.779 118.857 137.87 118.857 137.96Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.577 140.131C120.577 140.403 120.396 140.584 120.124 140.584C119.853 140.584 119.672 140.403 119.672 140.131C119.672 139.86 119.853 139.679 120.124 139.679C120.396 139.769 120.577 139.95 120.577 140.131Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.753 141.398C121.662 141.489 121.662 141.398 121.662 141.398C121.662 141.307 121.753 141.307 121.753 141.398C121.753 141.307 121.753 141.307 121.753 141.398Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.601 146.645C115.601 146.645 115.601 146.735 115.601 146.645C115.51 146.735 115.42 146.645 115.42 146.645C115.42 146.554 115.51 146.554 115.601 146.645C115.601 146.554 115.601 146.554 115.601 146.645Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.339 148.454C113.339 148.635 113.249 148.725 113.068 148.725C112.887 148.725 112.796 148.635 112.796 148.454C112.796 148.273 112.887 148.183 113.068 148.183C113.249 148.183 113.339 148.273 113.339 148.454Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.44 150.173C111.44 150.354 111.349 150.444 111.168 150.444C110.987 150.444 110.897 150.354 110.897 150.173C110.897 149.992 110.987 149.901 111.168 149.901C111.259 149.992 111.44 150.082 111.44 150.173Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.002 154.606C108.002 154.696 107.911 154.787 107.821 154.787C107.73 154.787 107.64 154.696 107.64 154.606C107.64 154.515 107.73 154.425 107.821 154.425C107.911 154.425 108.002 154.515 108.002 154.606Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.193 157.591C106.193 157.681 106.102 157.772 106.012 157.772C105.921 157.772 105.831 157.681 105.831 157.591C105.831 157.5 105.921 157.41 106.012 157.41C106.102 157.41 106.193 157.5 106.193 157.591Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.378 157.772C105.378 157.862 105.288 157.953 105.198 157.953C105.107 157.953 105.017 157.862 105.017 157.772C105.017 157.681 105.107 157.591 105.198 157.591C105.288 157.591 105.378 157.681 105.378 157.772Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.559 154.153C105.659 154.153 105.74 154.072 105.74 153.972C105.74 153.872 105.659 153.791 105.559 153.791C105.459 153.791 105.378 153.872 105.378 153.972C105.378 154.072 105.459 154.153 105.559 154.153Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.102 151.711C106.102 151.801 106.012 151.892 105.921 151.892C105.831 151.892 105.74 151.801 105.74 151.711C105.74 151.62 105.831 151.53 105.921 151.53C106.012 151.439 106.102 151.53 106.102 151.711Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.916 149.63C106.916 149.721 106.826 149.721 106.826 149.721C106.735 149.721 106.735 149.63 106.735 149.63C106.735 149.54 106.826 149.54 106.826 149.54C106.826 149.449 106.916 149.54 106.916 149.63Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.183 145.65C108.333 145.65 108.454 145.528 108.454 145.378C108.454 145.228 108.333 145.107 108.183 145.107C108.033 145.107 107.911 145.228 107.911 145.378C107.911 145.528 108.033 145.65 108.183 145.65Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.449 140.041C109.449 140.222 109.268 140.403 109.087 140.403C108.907 140.403 108.726 140.222 108.726 140.041C108.726 139.86 108.907 139.679 109.087 139.679C109.268 139.679 109.449 139.86 109.449 140.041Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.073 127.376C112.123 127.376 112.163 127.335 112.163 127.285C112.163 127.235 112.123 127.195 112.073 127.195C112.023 127.195 111.982 127.235 111.982 127.285C111.982 127.335 112.023 127.376 112.073 127.376Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.968 126.019C114.968 126.109 114.877 126.109 114.877 126.109C114.787 126.109 114.787 126.019 114.787 126.019L114.877 125.928L114.968 126.019Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.872 126.924C115.872 127.014 115.782 127.014 115.782 127.014C115.691 127.014 115.691 126.924 115.691 126.924C115.691 126.833 115.782 126.833 115.782 126.833C115.782 126.833 115.872 126.833 115.872 126.924Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.691 134.613C115.691 134.613 115.601 134.613 115.691 134.613C115.601 134.613 115.601 134.613 115.691 134.613C115.601 134.613 115.601 134.523 115.691 134.613C115.601 134.523 115.691 134.613 115.691 134.613Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.848 137.327C120.998 137.327 121.119 137.205 121.119 137.056C121.119 136.906 120.998 136.784 120.848 136.784C120.698 136.784 120.576 136.906 120.576 137.056C120.576 137.205 120.698 137.327 120.848 137.327Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.264 147.64C110.264 147.821 110.083 148.002 109.902 148.002C109.721 148.002 109.54 147.821 109.54 147.64C109.54 147.459 109.721 147.278 109.902 147.278C110.173 147.368 110.264 147.459 110.264 147.64Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.731 153.61C107.731 153.701 107.64 153.791 107.55 153.791C107.459 153.791 107.369 153.701 107.369 153.61C107.369 153.52 107.459 153.43 107.55 153.43C107.64 153.43 107.731 153.52 107.731 153.61Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.078 155.601C111.078 155.782 110.987 155.872 110.806 155.872C110.625 155.872 110.535 155.782 110.535 155.601C110.535 155.42 110.625 155.329 110.806 155.329C110.987 155.329 111.078 155.42 111.078 155.601Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.52 155.782C113.52 155.872 113.43 155.872 113.43 155.872C113.339 155.872 113.339 155.782 113.339 155.782C113.339 155.691 113.43 155.691 113.43 155.691C113.52 155.601 113.52 155.691 113.52 155.782Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.168 156.958C111.168 157.229 110.987 157.41 110.716 157.41C110.444 157.41 110.263 157.229 110.263 156.958C110.263 156.686 110.444 156.505 110.716 156.505C110.987 156.596 111.168 156.777 111.168 156.958Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.273 158.134C108.323 158.134 108.364 158.093 108.364 158.043C108.364 157.993 108.323 157.953 108.273 157.953C108.223 157.953 108.183 157.993 108.183 158.043C108.183 158.093 108.223 158.134 108.273 158.134Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.449 159.853C109.449 159.943 109.359 160.033 109.268 160.033C109.178 160.033 109.087 159.943 109.087 159.853C109.087 159.762 109.178 159.672 109.268 159.672C109.359 159.672 109.449 159.762 109.449 159.853Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.193 158.767C106.193 158.857 106.102 158.948 106.012 158.948C105.921 158.948 105.831 158.857 105.831 158.767C105.831 158.676 105.921 158.586 106.012 158.586C106.193 158.586 106.193 158.676 106.193 158.767Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.474 159.31C104.524 159.31 104.564 159.269 104.564 159.219C104.564 159.169 104.524 159.129 104.474 159.129C104.424 159.129 104.383 159.169 104.383 159.219C104.383 159.269 104.424 159.31 104.474 159.31Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.66 156.596C103.66 156.687 103.569 156.687 103.66 156.596C103.569 156.687 103.569 156.596 103.569 156.596C103.569 156.596 103.569 156.596 103.66 156.596C103.569 156.596 103.66 156.596 103.66 156.596Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.107 155.601C105.107 155.872 104.926 156.053 104.655 156.053C104.383 156.053 104.202 155.872 104.202 155.601C104.202 155.329 104.383 155.148 104.655 155.148C104.926 155.148 105.107 155.329 105.107 155.601Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.926 156.958C104.976 156.958 105.017 156.917 105.017 156.867C105.017 156.817 104.976 156.777 104.926 156.777C104.876 156.777 104.836 156.817 104.836 156.867C104.836 156.917 104.876 156.958 104.926 156.958Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.283 157.139C106.283 157.32 106.193 157.41 106.012 157.41C105.831 157.41 105.74 157.32 105.74 157.139C105.74 156.958 105.831 156.867 106.012 156.867C106.193 156.867 106.283 156.958 106.283 157.139Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.735 154.153C106.735 154.244 106.645 154.244 106.645 154.244C106.554 154.244 106.554 154.153 106.554 154.153L106.645 154.063C106.735 154.063 106.735 154.063 106.735 154.153Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.097 152.706C107.147 152.706 107.188 152.665 107.188 152.615C107.188 152.565 107.147 152.525 107.097 152.525C107.047 152.525 107.007 152.565 107.007 152.615C107.007 152.665 107.047 152.706 107.097 152.706Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.997 148.092C108.997 148.183 108.906 148.273 108.816 148.273C108.725 148.273 108.635 148.183 108.635 148.092C108.635 148.002 108.725 147.911 108.816 147.911C108.906 147.911 108.997 147.911 108.997 148.092Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.078 144.202C111.078 144.383 110.897 144.564 110.716 144.564C110.535 144.564 110.354 144.383 110.354 144.202C110.354 144.021 110.535 143.84 110.716 143.84C110.897 143.84 111.078 144.021 111.078 144.202Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.982 143.298C111.982 143.569 111.801 143.75 111.53 143.75C111.259 143.75 111.078 143.569 111.078 143.298C111.078 143.026 111.259 142.845 111.53 142.845C111.801 142.845 111.982 143.026 111.982 143.298Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.259 144.293C111.259 144.383 111.168 144.564 110.987 144.564C110.897 144.564 110.716 144.474 110.716 144.293C110.716 144.202 110.806 144.021 110.987 144.021C111.168 144.021 111.259 144.112 111.259 144.293Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.997 147.911C108.907 147.911 108.907 147.911 108.997 147.911C108.907 147.821 108.907 147.821 108.997 147.911C108.997 147.821 108.997 147.821 108.997 147.911Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.545 148.545C108.545 148.635 108.454 148.635 108.454 148.635C108.364 148.635 108.364 148.545 108.364 148.545C108.364 148.454 108.454 148.454 108.454 148.454C108.454 148.364 108.545 148.454 108.545 148.545Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.263 144.835C110.263 144.926 110.173 144.926 110.173 144.926L110.083 144.835C110.083 144.745 110.173 144.745 110.173 144.745C110.173 144.745 110.263 144.745 110.263 144.835Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.334 135.065C114.334 135.246 114.153 135.337 114.063 135.337C113.882 135.337 113.792 135.156 113.792 135.065C113.792 134.884 113.972 134.794 114.063 134.794C114.244 134.794 114.334 134.975 114.334 135.065Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.158 138.774C113.158 138.955 112.977 139.136 112.796 139.136C112.615 139.136 112.435 138.955 112.435 138.774C112.435 138.593 112.615 138.413 112.796 138.413C112.977 138.413 113.158 138.593 113.158 138.774Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.968 136.513C114.968 136.603 114.877 136.694 114.787 136.694C114.696 136.694 114.606 136.603 114.606 136.513C114.606 136.422 114.696 136.332 114.787 136.332C114.877 136.332 114.968 136.422 114.968 136.513Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.872 135.789C115.872 135.97 115.691 136.151 115.51 136.151C115.329 136.151 115.148 135.97 115.148 135.789C115.148 135.608 115.329 135.427 115.51 135.427C115.691 135.518 115.872 135.608 115.872 135.789Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.982 145.559C111.982 145.65 111.892 145.65 111.892 145.65C111.801 145.65 111.801 145.559 111.801 145.559L111.892 145.469C111.892 145.378 111.982 145.469 111.982 145.559Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.63 149.901C109.63 149.992 109.54 149.992 109.54 149.992C109.449 149.992 109.449 149.901 109.449 149.901L109.54 149.811C109.54 149.721 109.63 149.811 109.63 149.901Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.192 152.344C106.192 152.525 106.012 152.706 105.831 152.706C105.65 152.706 105.469 152.525 105.469 152.344C105.469 152.163 105.65 151.982 105.831 151.982C106.012 151.982 106.192 152.163 106.192 152.344Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.469 149.992C105.469 150.173 105.288 150.354 105.107 150.354C104.926 150.354 104.745 150.173 104.745 149.992C104.745 149.811 104.926 149.63 105.107 149.63C105.378 149.63 105.469 149.811 105.469 149.992Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.193 146.192C106.193 146.373 106.102 146.464 105.921 146.464C105.74 146.464 105.65 146.373 105.65 146.192C105.65 146.011 105.74 145.921 105.921 145.921C106.012 145.921 106.193 146.011 106.193 146.192Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.836 146.916C104.836 147.007 104.745 147.097 104.655 147.097C104.564 147.097 104.474 147.007 104.474 146.916C104.474 146.826 104.564 146.735 104.655 146.735C104.836 146.735 104.836 146.826 104.836 146.916Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.987 133.437C111.037 133.437 111.078 133.396 111.078 133.347C111.078 133.297 111.037 133.256 110.987 133.256C110.937 133.256 110.897 133.297 110.897 133.347C110.897 133.396 110.937 133.437 110.987 133.437Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.606 130.633C114.706 130.633 114.787 130.552 114.787 130.452C114.787 130.352 114.706 130.271 114.606 130.271C114.506 130.271 114.425 130.352 114.425 130.452C114.425 130.552 114.506 130.633 114.606 130.633Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.134 131.447C118.184 131.447 118.224 131.406 118.224 131.356C118.224 131.306 118.184 131.266 118.134 131.266C118.084 131.266 118.043 131.306 118.043 131.356C118.043 131.406 118.084 131.447 118.134 131.447Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.858 131.628C118.958 131.628 119.039 131.547 119.039 131.447C119.039 131.347 118.958 131.266 118.858 131.266C118.758 131.266 118.677 131.347 118.677 131.447C118.677 131.547 118.758 131.628 118.858 131.628Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.288 113.083C179.288 113.263 179.107 113.444 178.926 113.444C178.745 113.444 178.564 113.263 178.564 113.083C178.564 112.902 178.745 112.721 178.926 112.721C179.107 112.721 179.288 112.902 179.288 113.083Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.745 109.464C178.745 109.645 178.654 109.735 178.474 109.735C178.293 109.735 178.202 109.645 178.202 109.464C178.202 109.283 178.293 109.193 178.474 109.193C178.564 109.193 178.745 109.283 178.745 109.464Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.75 107.202C177.75 107.383 177.569 107.564 177.388 107.564C177.207 107.564 177.026 107.383 177.026 107.202C177.026 107.021 177.207 106.841 177.388 106.841C177.569 106.841 177.75 107.021 177.75 107.202Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.393 104.85C176.393 105.031 176.212 105.303 175.94 105.303C175.759 105.303 175.488 105.122 175.488 104.85C175.488 104.669 175.669 104.398 175.94 104.398C176.212 104.488 176.393 104.669 176.393 104.85Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.051 98.0655C172.051 98.3369 171.87 98.5178 171.598 98.5178C171.327 98.5178 171.146 98.3369 171.146 98.0655C171.146 97.7941 171.327 97.6132 171.598 97.6132C171.87 97.6132 172.051 97.7941 172.051 98.0655Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.232 97.0704C135.381 97.0704 135.503 96.9489 135.503 96.799C135.503 96.6491 135.381 96.5276 135.232 96.5276C135.082 96.5276 134.96 96.6491 134.96 96.799C134.96 96.9489 135.082 97.0704 135.232 97.0704Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.674 92.1853C137.674 92.2758 137.584 92.3663 137.493 92.3663C137.403 92.3663 137.312 92.2758 137.312 92.1853C137.312 92.0949 137.403 92.0044 137.493 92.0044C137.584 92.0044 137.674 92.0949 137.674 92.1853Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.855 91.914C138.055 91.914 138.217 91.752 138.217 91.5521C138.217 91.3523 138.055 91.1902 137.855 91.1902C137.655 91.1902 137.493 91.3523 137.493 91.5521C137.493 91.752 137.655 91.914 137.855 91.914Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.08 130.18C166.23 130.18 166.351 130.059 166.351 129.909C166.351 129.759 166.23 129.638 166.08 129.638C165.93 129.638 165.809 129.759 165.809 129.909C165.809 130.059 165.93 130.18 166.08 130.18Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.98 128.009C167.98 128.19 167.889 128.281 167.708 128.281C167.527 128.281 167.437 128.19 167.437 128.009C167.437 127.828 167.527 127.738 167.708 127.738C167.889 127.828 167.98 127.919 167.98 128.009Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.246 128.1C169.346 128.1 169.427 128.019 169.427 127.919C169.427 127.819 169.346 127.738 169.246 127.738C169.146 127.738 169.065 127.819 169.065 127.919C169.065 128.019 169.146 128.1 169.246 128.1Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.845 128.19C176.845 128.371 176.755 128.461 176.574 128.461C176.393 128.461 176.302 128.371 176.302 128.19C176.302 128.009 176.393 127.919 176.574 127.919C176.664 127.919 176.845 128.1 176.845 128.19Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.83 127.828C179.88 127.828 179.921 127.788 179.921 127.738C179.921 127.688 179.88 127.647 179.83 127.647C179.78 127.647 179.74 127.688 179.74 127.738C179.74 127.788 179.78 127.828 179.83 127.828Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.415 122.129C153.415 122.31 153.234 122.491 153.053 122.491C152.872 122.491 152.691 122.31 152.691 122.129C152.691 121.948 152.872 121.767 153.053 121.767C153.234 121.767 153.415 121.948 153.415 122.129Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.058 121.496C152.058 121.677 151.877 121.858 151.696 121.858C151.515 121.858 151.334 121.677 151.334 121.496C151.334 121.315 151.515 121.134 151.696 121.134C151.877 121.134 152.058 121.315 152.058 121.496Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.073 124.752C149.073 124.933 148.892 125.114 148.711 125.114C148.53 125.114 148.349 124.933 148.349 124.752C148.349 124.572 148.53 124.391 148.711 124.391C148.892 124.391 149.073 124.572 149.073 124.752Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.249 121.767C150.249 121.948 150.068 122.129 149.887 122.129C149.706 122.129 149.525 121.948 149.525 121.767C149.525 121.586 149.706 121.405 149.887 121.405C150.068 121.405 150.249 121.586 150.249 121.767Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.701 121.134C150.701 121.224 150.611 121.315 150.52 121.315C150.43 121.315 150.339 121.224 150.339 121.134C150.339 121.043 150.43 120.953 150.52 120.953C150.611 120.953 150.701 121.134 150.701 121.134Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.42 120.953C152.42 121.134 152.239 121.315 152.058 121.315C151.877 121.315 151.696 121.134 151.696 120.953C151.696 120.772 151.877 120.591 152.058 120.591C152.239 120.501 152.42 120.682 152.42 120.953Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.144 118.51C153.343 118.51 153.505 118.348 153.505 118.149C153.505 117.949 153.343 117.787 153.144 117.787C152.944 117.787 152.782 117.949 152.782 118.149C152.782 118.348 152.944 118.51 153.144 118.51Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.007 146.373C144.007 146.464 143.916 146.464 143.916 146.464C143.826 146.464 143.826 146.373 143.826 146.373L143.916 146.283C143.916 146.283 144.007 146.283 144.007 146.373Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.053 63.1463C116.053 63.2368 115.963 63.3273 115.872 63.3273C115.782 63.3273 115.691 63.2368 115.691 63.1463C115.691 63.0559 115.782 62.9654 115.872 62.9654C115.963 62.9654 116.053 62.9654 116.053 63.1463Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.586 59.1659C118.786 59.1659 118.948 59.0039 118.948 58.8041C118.948 58.6042 118.786 58.4422 118.586 58.4422C118.386 58.4422 118.224 58.6042 118.224 58.8041C118.224 59.0039 118.386 59.1659 118.586 59.1659Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.938 56.3616C120.938 56.633 120.757 56.8139 120.486 56.8139C120.215 56.8139 120.034 56.633 120.034 56.3616C120.034 56.0902 120.215 55.9092 120.486 55.9092C120.757 55.9092 120.938 56.1806 120.938 56.3616Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.743 54.1904C123.843 54.1904 123.924 54.1094 123.924 54.0095C123.924 53.9096 123.843 53.8286 123.743 53.8286C123.643 53.8286 123.562 53.9096 123.562 54.0095C123.562 54.1094 123.643 54.1904 123.743 54.1904Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.031 48.3102C139.031 48.4912 138.941 48.5816 138.76 48.5816C138.579 48.5816 138.488 48.4912 138.488 48.3102C138.488 48.1293 138.579 48.0388 138.76 48.0388C138.85 47.9484 139.031 48.1293 139.031 48.3102Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.442 52.1097C129.442 52.2907 129.261 52.4716 129.08 52.4716C128.899 52.4716 128.718 52.2907 128.718 52.1097C128.718 51.9288 128.899 51.7479 129.08 51.7479C129.261 51.7479 129.442 51.9288 129.442 52.1097Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.236 52.3811C134.236 52.4716 134.146 52.5621 134.055 52.5621C133.965 52.5621 133.875 52.4716 133.875 52.3811C133.875 52.2907 133.965 52.2002 134.055 52.2002C134.146 52.2002 134.236 52.2907 134.236 52.3811Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.312 52.9239C137.312 53.0144 137.222 53.1048 137.131 53.1048C137.041 53.1048 136.95 53.0144 136.95 52.9239C136.95 52.8334 137.041 52.743 137.131 52.743C137.222 52.743 137.312 52.8334 137.312 52.9239Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.655 50.8432C141.655 50.9337 141.564 51.0242 141.474 51.0242C141.383 51.0242 141.293 50.9337 141.293 50.8432C141.293 50.7528 141.383 50.6623 141.474 50.6623C141.564 50.6623 141.655 50.7528 141.655 50.8432Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.263 50.4814C147.263 50.7528 147.082 50.9337 146.811 50.9337C146.54 50.9337 146.359 50.7528 146.359 50.4814C146.359 50.21 146.54 50.0291 146.811 50.0291C147.082 50.0291 147.263 50.21 147.263 50.4814Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.158 49.7576C150.158 49.9386 149.977 50.1195 149.796 50.1195C149.616 50.1195 149.435 49.9386 149.435 49.7576C149.435 49.5767 149.616 49.3958 149.796 49.3958C150.068 49.3053 150.158 49.4863 150.158 49.7576Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.596 47.9484C153.596 48.0389 153.505 48.1293 153.415 48.1293C153.324 48.1293 153.234 48.0389 153.234 47.9484C153.234 47.8579 153.324 47.7675 153.415 47.7675C153.505 47.7675 153.596 47.8579 153.596 47.9484Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.038 46.5914C156.188 46.5914 156.31 46.4699 156.31 46.32C156.31 46.1701 156.188 46.0486 156.038 46.0486C155.888 46.0486 155.767 46.1701 155.767 46.32C155.767 46.4699 155.888 46.5914 156.038 46.5914Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 46.1391C160.109 46.32 159.928 46.5009 159.747 46.5009C159.566 46.5009 159.385 46.32 159.385 46.1391C159.385 45.9582 159.566 45.7772 159.747 45.7772C159.928 45.7772 160.109 45.9582 160.109 46.1391Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.828 44.5107C161.828 44.6916 161.737 44.7821 161.557 44.7821C161.376 44.7821 161.285 44.6916 161.285 44.5107C161.285 44.3298 161.376 44.2393 161.557 44.2393C161.647 44.2393 161.828 44.4202 161.828 44.5107Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.547 42.9728C163.697 42.9728 163.818 42.8513 163.818 42.7014C163.818 42.5516 163.697 42.4301 163.547 42.4301C163.397 42.4301 163.275 42.5516 163.275 42.7014C163.275 42.8513 163.397 42.9728 163.547 42.9728Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.718 40.9826C165.818 40.9826 165.899 40.9016 165.899 40.8017C165.899 40.7018 165.818 40.6208 165.718 40.6208C165.618 40.6208 165.537 40.7018 165.537 40.8017C165.537 40.9016 165.618 40.9826 165.718 40.9826Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.818 37.0022C163.818 37.1831 163.637 37.364 163.456 37.364C163.275 37.364 163.094 37.1831 163.094 37.0022C163.094 36.8212 163.275 36.6403 163.456 36.6403C163.637 36.6403 163.818 36.8212 163.818 37.0022Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.581 70.293C119.581 70.3835 119.491 70.4739 119.4 70.4739C119.31 70.4739 119.219 70.3835 119.219 70.293C119.219 70.2026 119.31 70.1121 119.4 70.1121C119.491 70.0216 119.581 70.1121 119.581 70.293Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.762 65.0461C119.762 65.1365 119.672 65.227 119.581 65.227C119.491 65.227 119.4 65.1365 119.4 65.0461C119.4 64.9556 119.491 64.8651 119.581 64.8651C119.672 64.8651 119.762 64.9556 119.762 65.0461Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.481 65.1366C121.481 65.227 121.391 65.3175 121.3 65.3175C121.21 65.3175 121.119 65.227 121.119 65.1366C121.119 65.0461 121.21 64.9556 121.3 64.9556C121.391 64.9556 121.481 65.0461 121.481 65.1366Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.919 59.9801C124.919 60.0706 124.828 60.161 124.738 60.161C124.647 60.161 124.557 60.0706 124.557 59.9801C124.557 59.8896 124.647 59.7992 124.738 59.7992C124.919 59.7992 124.919 59.8896 124.919 59.9801Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.557 57.4471C124.757 57.4471 124.919 57.2851 124.919 57.0852C124.919 56.8854 124.757 56.7234 124.557 56.7234C124.357 56.7234 124.195 56.8854 124.195 57.0852C124.195 57.2851 124.357 57.4471 124.557 57.4471Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.689 57.2662C134.598 57.3566 134.508 57.2662 134.508 57.2662C134.508 57.2662 134.598 57.1757 134.689 57.2662C134.689 57.1757 134.689 57.1757 134.689 57.2662Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.659 47.0438C140.659 47.1342 140.569 47.2247 140.479 47.2247C140.388 47.2247 140.298 47.1342 140.298 47.0438C140.298 46.9533 140.388 46.8628 140.479 46.8628C140.569 46.8628 140.659 46.9533 140.659 47.0438Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.278 50.9337C144.278 51.1146 144.097 51.2955 143.916 51.2955C143.735 51.2955 143.554 51.1146 143.554 50.9337C143.554 50.7527 143.735 50.5718 143.916 50.5718C144.097 50.5718 144.278 50.7527 144.278 50.9337Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.268 55.6378C146.268 55.6378 146.178 55.7283 146.268 55.6378C146.087 55.7283 146.087 55.7283 146.087 55.6378C146.087 55.5474 146.087 55.5474 146.268 55.6378C146.178 55.5474 146.268 55.5474 146.268 55.6378Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8138 72.2832C53.8138 72.4641 53.7233 72.5546 53.5424 72.5546C53.3615 72.5546 53.271 72.4641 53.271 72.2832C53.271 72.1023 53.3615 72.0118 53.5424 72.0118C53.7233 71.9213 53.8138 72.1023 53.8138 72.2832Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4324 66.4935C57.4324 66.6744 57.2515 66.8554 57.0706 66.8554C56.8897 66.8554 56.7087 66.6744 56.7087 66.4935C56.7087 66.3126 56.8897 66.1317 57.0706 66.1317C57.2515 66.1317 57.4324 66.3126 57.4324 66.4935Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.699 66.8554C58.8989 66.8554 59.0609 66.6934 59.0609 66.4935C59.0609 66.2937 58.8989 66.1317 58.699 66.1317C58.4992 66.1317 58.3372 66.2937 58.3372 66.4935C58.3372 66.6934 58.4992 66.8554 58.699 66.8554Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1316 65.4079C63.1316 65.4984 63.0412 65.5888 62.9507 65.5888C62.8602 65.5888 62.7698 65.4984 62.7698 65.4079C62.7698 65.3174 62.8602 65.227 62.9507 65.227C63.0412 65.1365 63.1316 65.227 63.1316 65.4079Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6646 58.2613C65.7645 58.2613 65.8455 58.1803 65.8455 58.0803C65.8455 57.9804 65.7645 57.8994 65.6646 57.8994C65.5647 57.8994 65.4836 57.9804 65.4836 58.0803C65.4836 58.1803 65.5647 58.2613 65.6646 58.2613Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9971 60.6134C71.9971 60.7038 71.9066 60.7038 71.9066 60.7038C71.8162 60.7038 71.8162 60.6134 71.8162 60.6134C71.8162 60.5229 71.9066 60.5229 71.9066 60.5229C71.9066 60.5229 71.9971 60.6134 71.9971 60.6134Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5252 61.9703C75.5252 62.1512 75.3443 62.3322 75.1634 62.3322C74.9824 62.3322 74.8015 62.1512 74.8015 61.9703C74.8015 61.7894 74.9824 61.6085 75.1634 61.6085C75.3443 61.6085 75.5252 61.6989 75.5252 61.9703Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9726 56.1806C77.1225 56.1806 77.244 56.0591 77.244 55.9092C77.244 55.7593 77.1225 55.6378 76.9726 55.6378C76.8227 55.6378 76.7012 55.7593 76.7012 55.9092C76.7012 56.0591 76.8227 56.1806 76.9726 56.1806Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1341 57.5376C81.1341 57.628 81.0436 57.7185 80.9531 57.7185C80.8627 57.7185 80.7722 57.628 80.7722 57.5376C80.7722 57.4471 80.8627 57.3566 80.9531 57.3566C81.0436 57.3566 81.1341 57.4471 81.1341 57.5376Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6474 56.3615C87.7973 56.3615 87.9188 56.24 87.9188 56.0902C87.9188 55.9403 87.7973 55.8188 87.6474 55.8188C87.4975 55.8188 87.376 55.9403 87.376 56.0902C87.376 56.24 87.4975 56.3615 87.6474 56.3615Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8235 60.7943C88.8235 60.8847 88.8235 60.8847 88.8235 60.7943C88.733 60.8847 88.6426 60.7943 88.6426 60.7943C88.733 60.7943 88.733 60.7943 88.8235 60.7943Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8186 60.9752C89.8186 61.0657 89.7282 61.1561 89.6377 61.1561C89.5473 61.1561 89.4568 61.0657 89.4568 60.9752C89.4568 60.8847 89.5473 60.7943 89.6377 60.7943C89.7282 60.7943 89.8186 60.8847 89.8186 60.9752Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8944 59.7087C92.8944 59.8896 92.7134 60.0705 92.5325 60.0705C92.3516 60.0705 92.1707 59.8896 92.1707 59.7087C92.1707 59.5278 92.3516 59.3468 92.5325 59.3468C92.8039 59.3468 92.8944 59.4373 92.8944 59.7087Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7941 67.5791C94.944 67.5791 95.0655 67.4576 95.0655 67.3077C95.0655 67.1578 94.944 67.0363 94.7941 67.0363C94.6442 67.0363 94.5227 67.1578 94.5227 67.3077C94.5227 67.4576 94.6442 67.5791 94.7941 67.5791Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.22 82.4152C119.22 82.5056 119.129 82.5961 119.039 82.5961C118.948 82.5961 118.858 82.5056 118.858 82.4152C118.858 82.3247 118.948 82.2343 119.039 82.2343C119.129 82.2343 119.22 82.3247 119.22 82.4152Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.412 82.958C135.412 83.1389 135.322 83.2294 135.141 83.2294C134.96 83.2294 134.87 83.1389 134.87 82.958C134.87 82.777 134.96 82.6866 135.141 82.6866C135.322 82.6866 135.412 82.777 135.412 82.958Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.559 76.7159C142.559 76.8064 142.469 76.9873 142.288 76.9873C142.197 76.9873 142.016 76.8969 142.016 76.7159C142.016 76.535 142.107 76.4445 142.288 76.4445C142.469 76.4445 142.559 76.535 142.559 76.7159Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.811 68.4837C146.811 68.5742 146.721 68.6647 146.63 68.6647C146.54 68.6647 146.449 68.5742 146.449 68.4837C146.449 68.3933 146.54 68.3028 146.63 68.3028C146.63 68.3028 146.811 68.3933 146.811 68.4837Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.992 66.584C147.142 66.584 147.263 66.4625 147.263 66.3126C147.263 66.1627 147.142 66.0412 146.992 66.0412C146.842 66.0412 146.72 66.1627 146.72 66.3126C146.72 66.4625 146.842 66.584 146.992 66.584Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.058 67.6696C152.058 67.76 151.967 67.9409 151.787 67.9409C151.696 67.9409 151.515 67.8505 151.515 67.6696C151.515 67.5791 151.606 67.3982 151.787 67.3982C151.967 67.4886 152.058 67.5791 152.058 67.6696Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.963 64.3224C153.063 64.3224 153.144 64.2414 153.144 64.1414C153.144 64.0415 153.063 63.9605 152.963 63.9605C152.863 63.9605 152.782 64.0415 152.782 64.1414C152.782 64.2414 152.863 64.3224 152.963 64.3224Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.779 64.4128C134.829 64.4128 134.87 64.3723 134.87 64.3224C134.87 64.2724 134.829 64.2319 134.779 64.2319C134.729 64.2319 134.689 64.2724 134.689 64.3224C134.689 64.3723 134.729 64.4128 134.779 64.4128Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.87 67.8505C134.87 67.941 134.779 68.0314 134.689 68.0314C134.598 68.0314 134.508 67.941 134.508 67.8505C134.508 67.76 134.598 67.6696 134.689 67.6696C134.779 67.76 134.87 67.76 134.87 67.8505Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.246 66.3126C132.246 66.403 132.156 66.4935 132.065 66.4935C131.975 66.4935 131.885 66.403 131.885 66.3126C131.885 66.2221 131.975 66.1317 132.065 66.1317C132.156 66.1317 132.246 66.2221 132.246 66.3126Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.532 68.3933C129.532 68.4837 129.442 68.6647 129.261 68.6647C129.08 68.6647 128.99 68.5742 128.99 68.3933C128.99 68.2124 129.08 68.1219 129.261 68.1219C129.442 68.1219 129.532 68.2124 129.532 68.3933Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.461 72.3737C125.611 72.3737 125.733 72.2521 125.733 72.1023C125.733 71.9524 125.611 71.8309 125.461 71.8309C125.311 71.8309 125.19 71.9524 125.19 72.1023C125.19 72.2521 125.311 72.3737 125.461 72.3737Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.576 76.716C120.576 76.716 120.486 76.716 120.576 76.716C120.486 76.8064 120.396 76.716 120.396 76.716C120.396 76.716 120.396 76.6255 120.576 76.716C120.486 76.6255 120.576 76.6255 120.576 76.716Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.295 80.9678C122.295 81.0583 122.205 81.1487 122.114 81.1487C122.024 81.1487 121.933 81.0583 121.933 80.9678C121.933 80.8773 122.024 80.7869 122.114 80.7869C122.205 80.7869 122.295 80.8773 122.295 80.9678Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.491 84.315C119.491 84.4054 119.4 84.4054 119.4 84.4054L119.31 84.315C119.31 84.2245 119.4 84.2245 119.4 84.2245L119.491 84.315Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.601 90.1951C115.601 90.2856 115.51 90.2856 115.51 90.2856C115.42 90.2856 115.42 90.1951 115.42 90.1951L115.51 90.1047C115.51 90.0142 115.601 90.1047 115.601 90.1951Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.911 86.667C107.911 86.7575 107.821 86.8479 107.73 86.8479C107.64 86.8479 107.55 86.7575 107.55 86.667C107.55 86.5765 107.64 86.4861 107.73 86.4861C107.821 86.4861 107.911 86.5765 107.911 86.667Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.193 90.7379C106.193 90.9188 106.102 91.0093 105.921 91.0093C105.74 91.0093 105.65 90.9188 105.65 90.7379C105.65 90.557 105.74 90.4665 105.921 90.4665C106.012 90.376 106.193 90.557 106.193 90.7379Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.116 90.1044C103.026 90.1044 103.026 90.1044 103.116 90.1044C103.026 90.1044 103.026 90.0145 103.116 90.1044C103.116 90.0145 103.116 90.1044 103.116 90.1044Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.765 120.048C63.765 120.229 63.584 120.41 63.4031 120.41C63.2222 120.41 63.0413 120.229 63.0413 120.048C63.0413 119.867 63.2222 119.686 63.4031 119.686C63.584 119.777 63.765 119.867 63.765 120.048Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7183 125.024C91.7183 125.205 91.5374 125.386 91.3565 125.386C91.1756 125.386 90.9946 125.205 90.9946 125.024C90.9946 124.843 91.1756 124.662 91.3565 124.662C91.5374 124.662 91.7183 124.843 91.7183 125.024Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7843 124.572C96.7843 124.752 96.6033 124.933 96.4224 124.933C96.2415 124.933 96.0605 124.752 96.0605 124.572C96.0605 124.391 96.2415 124.21 96.4224 124.21C96.6938 124.21 96.7843 124.391 96.7843 124.572Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.026 118.51C103.226 118.51 103.388 118.348 103.388 118.149C103.388 117.949 103.226 117.787 103.026 117.787C102.827 117.787 102.665 117.949 102.665 118.149C102.665 118.348 102.827 118.51 103.026 118.51Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.831 122.038C105.881 122.038 105.921 121.998 105.921 121.948C105.921 121.898 105.881 121.858 105.831 121.858C105.781 121.858 105.74 121.898 105.74 121.948C105.74 121.998 105.781 122.038 105.831 122.038Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.826 120.501C106.826 120.501 106.826 120.591 106.826 120.501C106.735 120.591 106.645 120.501 106.645 120.501C106.735 120.501 106.735 120.41 106.826 120.501C106.826 120.41 106.826 120.501 106.826 120.501Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.992 116.158C110.142 116.158 110.263 116.037 110.263 115.887C110.263 115.737 110.142 115.616 109.992 115.616C109.842 115.616 109.721 115.737 109.721 115.887C109.721 116.037 109.842 116.158 109.992 116.158Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.682 116.43C117.682 116.43 117.682 116.521 117.682 116.43C117.591 116.521 117.591 116.43 117.591 116.43C117.591 116.43 117.591 116.339 117.682 116.43C117.682 116.339 117.682 116.43 117.682 116.43Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.109 115.435C123.109 115.616 123.019 115.706 122.838 115.706C122.657 115.706 122.567 115.616 122.567 115.435C122.567 115.254 122.657 115.163 122.838 115.163C122.929 115.163 123.109 115.254 123.109 115.435Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.733 109.193C125.733 109.283 125.642 109.464 125.461 109.464C125.28 109.464 125.19 109.373 125.19 109.193C125.19 109.012 125.28 108.921 125.461 108.921C125.642 108.921 125.733 109.102 125.733 109.193Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.246 107.021C132.246 107.202 132.065 107.383 131.884 107.383C131.703 107.383 131.522 107.202 131.522 107.021C131.522 106.84 131.703 106.66 131.884 106.66C132.065 106.66 132.246 106.84 132.246 107.021Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.332 105.393C133.332 105.574 133.241 105.665 133.06 105.665C132.88 105.665 132.789 105.574 132.789 105.393C132.789 105.212 132.88 105.122 133.06 105.122C133.151 105.122 133.332 105.303 133.332 105.393Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.498 104.217C136.598 104.217 136.679 104.136 136.679 104.036C136.679 103.936 136.598 103.855 136.498 103.855C136.398 103.855 136.317 103.936 136.317 104.036C136.317 104.136 136.398 104.217 136.498 104.217Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.383 99.5129C141.383 99.6034 141.293 99.6939 141.202 99.6939C141.112 99.6939 141.021 99.6034 141.021 99.5129C141.021 99.4225 141.112 99.332 141.202 99.332C141.293 99.332 141.383 99.4225 141.383 99.5129Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.806 89.9237C147.806 90.0142 147.716 90.1047 147.625 90.1047C147.535 90.1047 147.444 90.0142 147.444 89.9237C147.444 89.8333 147.535 89.7428 147.625 89.7428C147.806 89.7428 147.806 89.8333 147.806 89.9237Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.51 89.1096C152.56 89.1096 152.601 89.0691 152.601 89.0191C152.601 88.9692 152.56 88.9286 152.51 88.9286C152.46 88.9286 152.42 88.9692 152.42 89.0191C152.42 89.0691 152.46 89.1096 152.51 89.1096Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.938 91.733C158.088 91.733 158.21 91.6115 158.21 91.4616C158.21 91.3118 158.088 91.1902 157.938 91.1902C157.788 91.1902 157.667 91.3118 157.667 91.4616C157.667 91.6115 157.788 91.733 157.938 91.733Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.362 89.4714C164.362 89.5625 164.362 89.5625 164.362 89.4714C164.27 89.5625 164.271 89.4714 164.271 89.4714H164.362Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.899 92.0044C166.049 92.0044 166.17 91.8829 166.17 91.733C166.17 91.5831 166.049 91.4616 165.899 91.4616C165.749 91.4616 165.627 91.5831 165.627 91.733C165.627 91.8829 165.749 92.0044 165.899 92.0044Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.608 89.9237C169.658 89.9237 169.699 89.8832 169.699 89.8333C169.699 89.7833 169.658 89.7428 169.608 89.7428C169.558 89.7428 169.518 89.7833 169.518 89.8333C169.518 89.8832 169.558 89.9237 169.608 89.9237Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.454 93.9946C182.454 94.0851 182.363 94.0851 182.363 94.0851C182.273 94.0851 182.273 93.9946 182.273 93.9946C182.273 93.9042 182.363 93.9042 182.363 93.9042C182.454 93.9042 182.454 93.9042 182.454 93.9946Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.028 98.3369C195.028 98.4274 194.938 98.6083 194.757 98.6083C194.667 98.6083 194.486 98.5178 194.486 98.3369C194.486 98.2464 194.576 98.0655 194.757 98.0655C194.938 98.0655 195.028 98.156 195.028 98.3369Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.913 100.327C200.063 100.327 200.185 100.206 200.185 100.056C200.185 99.9058 200.063 99.7843 199.913 99.7843C199.764 99.7843 199.642 99.9058 199.642 100.056C199.642 100.206 199.764 100.327 199.913 100.327Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.116 90.2856C214.316 90.2856 214.478 90.1236 214.478 89.9237C214.478 89.7239 214.316 89.5619 214.116 89.5619C213.916 89.5619 213.754 89.7239 213.754 89.9237C213.754 90.1236 213.916 90.2856 214.116 90.2856Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.916 89.7428C217.916 89.8332 217.825 89.9237 217.735 89.9237C217.644 89.9237 217.554 89.8332 217.554 89.7428C217.554 89.6523 217.644 89.5619 217.735 89.5619C217.825 89.5619 217.916 89.6523 217.916 89.7428Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.168 82.4152C222.268 82.4152 222.349 82.3342 222.349 82.2343C222.349 82.1344 222.268 82.0533 222.168 82.0533C222.068 82.0533 221.987 82.1344 221.987 82.2343C221.987 82.3342 222.068 82.4152 222.168 82.4152Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.625 87.4812C221.625 87.5717 221.534 87.5717 221.534 87.5717C221.444 87.5717 221.444 87.4812 221.444 87.4812C221.444 87.3907 221.534 87.3907 221.534 87.3907C221.534 87.3907 221.625 87.3907 221.625 87.4812Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.273 88.6572C219.273 88.7477 219.182 88.7477 219.182 88.7477C219.092 88.7477 219.092 88.6572 219.092 88.6572L219.182 88.5668C219.182 88.5668 219.273 88.6572 219.273 88.6572Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.05 89.0191C209.05 89.0191 208.96 89.1095 209.05 89.0191C208.96 89.1095 208.869 89.0191 208.869 89.0191C208.869 88.9286 208.869 88.9286 209.05 89.0191C208.96 88.9286 209.05 88.9286 209.05 89.0191Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.713 87.6621C203.713 87.843 203.532 88.024 203.351 88.024C203.17 88.024 202.989 87.843 202.989 87.6621C202.989 87.4812 203.17 87.3003 203.351 87.3003C203.623 87.3907 203.713 87.4812 203.713 87.6621Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.833 92.7281C197.833 92.9091 197.652 93.09 197.471 93.09C197.29 93.09 197.109 92.9091 197.109 92.7281C197.109 92.5472 197.29 92.3663 197.471 92.3663C197.652 92.3663 197.833 92.4567 197.833 92.7281Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.676 85.9433C192.676 86.0338 192.586 86.0338 192.586 86.0338C192.495 86.0338 192.495 85.9433 192.495 85.9433L192.586 85.8529C192.676 85.7624 192.676 85.8529 192.676 85.9433Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.867 88.4763C190.867 88.5667 190.867 88.5667 190.777 88.5667C190.686 88.5667 190.686 88.5667 190.686 88.4763C190.686 88.3858 190.686 88.3858 190.777 88.3858C190.777 88.3858 190.867 88.3858 190.867 88.4763Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.063 85.5814C188.063 85.6719 187.972 85.6719 187.972 85.6719C187.882 85.6719 187.882 85.5814 187.882 85.5814C187.882 85.491 187.972 85.491 187.972 85.491C187.972 85.491 188.063 85.491 188.063 85.5814Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.525 90.0142C186.675 90.0142 186.796 89.8927 186.796 89.7428C186.796 89.5929 186.675 89.4714 186.525 89.4714C186.375 89.4714 186.253 89.5929 186.253 89.7428C186.253 89.8927 186.375 90.0142 186.525 90.0142Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.544 85.0387C182.694 85.0387 182.816 84.9172 182.816 84.7673C182.816 84.6174 182.694 84.4959 182.544 84.4959C182.394 84.4959 182.273 84.6174 182.273 84.7673C182.273 84.9172 182.394 85.0387 182.544 85.0387Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.373 90.557C180.373 90.6474 180.283 90.7379 180.192 90.7379C180.102 90.7379 180.011 90.6474 180.011 90.557C180.011 90.4665 180.102 90.376 180.192 90.376C180.283 90.4665 180.373 90.4665 180.373 90.557Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.493 90.1047C174.493 90.1951 174.402 90.2856 174.312 90.2856C174.222 90.2856 174.131 90.1951 174.131 90.1047C174.131 90.0142 174.222 89.9237 174.312 89.9237C174.402 89.9237 174.493 90.0142 174.493 90.1047Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.696 95.8039C151.696 95.8944 151.696 95.8944 151.696 95.8039C151.606 95.8944 151.515 95.8039 151.515 95.8039C151.515 95.8039 151.606 95.7134 151.696 95.8039C151.696 95.7134 151.696 95.8039 151.696 95.8039Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.053 98.246C153.053 98.246 152.963 98.246 153.053 98.246C152.963 98.246 152.963 98.246 153.053 98.246C152.963 98.1561 152.963 98.1561 153.053 98.246C152.963 98.1561 153.053 98.1561 153.053 98.246Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.706 108.831C149.706 108.922 149.706 108.922 149.706 108.831C149.615 108.922 149.615 108.831 149.615 108.831C149.615 108.831 149.615 108.831 149.706 108.831Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.293 109.554C141.293 109.735 141.202 109.826 141.021 109.826C140.84 109.826 140.75 109.735 140.75 109.554C140.75 109.374 140.84 109.283 141.021 109.283C141.202 109.283 141.293 109.374 141.293 109.554Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.016 115.525C142.016 115.616 141.926 115.706 141.835 115.706C141.745 115.706 141.655 115.616 141.655 115.525C141.655 115.435 141.745 115.344 141.835 115.344C141.926 115.344 142.016 115.435 142.016 115.525Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.175 143.117C128.225 143.117 128.266 143.076 128.266 143.026C128.266 142.976 128.225 142.936 128.175 142.936C128.125 142.936 128.085 142.976 128.085 143.026C128.085 143.076 128.125 143.117 128.175 143.117Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.929 154.425C122.929 154.606 122.748 154.696 122.657 154.696C122.476 154.696 122.386 154.515 122.386 154.425C122.386 154.244 122.567 154.153 122.657 154.153C122.748 154.063 122.929 154.244 122.929 154.425Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.757 157.681C120.757 157.681 120.757 157.772 120.757 157.681C120.576 157.772 120.576 157.772 120.576 157.681C120.576 157.591 120.667 157.591 120.757 157.681C120.757 157.591 120.757 157.591 120.757 157.681Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.42 156.867C115.42 157.048 115.33 157.139 115.149 157.139C114.968 157.139 114.877 157.048 114.877 156.867C114.877 156.686 114.968 156.596 115.149 156.596C115.33 156.686 115.42 156.777 115.42 156.867Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.515 160.395C114.515 160.486 114.425 160.576 114.335 160.576C114.244 160.576 114.154 160.486 114.154 160.395C114.154 160.305 114.244 160.214 114.335 160.214C114.425 160.214 114.515 160.305 114.515 160.395Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.872 167.723C115.872 167.813 115.782 167.904 115.691 167.904C115.601 167.904 115.51 167.813 115.51 167.723C115.51 167.632 115.601 167.542 115.691 167.542C115.782 167.542 115.872 167.632 115.872 167.723Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.987 167.542C110.987 167.723 110.806 167.904 110.625 167.904C110.444 167.904 110.263 167.723 110.263 167.542C110.263 167.361 110.444 167.18 110.625 167.18C110.806 167.18 110.987 167.361 110.987 167.542Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.635 168.266C108.785 168.266 108.907 168.144 108.907 167.994C108.907 167.844 108.785 167.723 108.635 167.723C108.485 167.723 108.364 167.844 108.364 167.994C108.364 168.144 108.485 168.266 108.635 168.266Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.107 164.285C105.107 164.376 105.017 164.466 104.926 164.466C104.836 164.466 104.745 164.376 104.745 164.285C104.745 164.195 104.836 164.104 104.926 164.104C105.017 164.014 105.107 164.104 105.107 164.285Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6791 168.628C99.829 168.628 99.9505 168.506 99.9505 168.356C99.9505 168.206 99.829 168.085 99.6791 168.085C99.5292 168.085 99.4077 168.206 99.4077 168.356C99.4077 168.506 99.5292 168.628 99.6791 168.628Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.674 163.562C100.674 163.742 100.493 163.923 100.313 163.923C100.132 163.923 99.9507 163.742 99.9507 163.562C99.9507 163.381 100.132 163.2 100.313 163.2C100.493 163.2 100.674 163.381 100.674 163.562Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8773 143.569C77.8773 143.75 77.7868 143.84 77.6059 143.84C77.4249 143.84 77.3345 143.75 77.3345 143.569C77.3345 143.388 77.4249 143.298 77.6059 143.298C77.6963 143.298 77.8773 143.388 77.8773 143.569Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8821 133.075C76.8821 133.166 76.7917 133.256 76.7012 133.256C76.6107 133.256 76.5203 133.166 76.5203 133.075C76.5203 132.985 76.6107 132.894 76.7012 132.894C76.8821 132.894 76.8821 132.985 76.8821 133.075Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4544 133.708C71.5543 133.708 71.6353 133.627 71.6353 133.527C71.6353 133.428 71.5543 133.347 71.4544 133.347C71.3544 133.347 71.2734 133.428 71.2734 133.527C71.2734 133.627 71.3544 133.708 71.4544 133.708Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7478 122.4C48.7478 122.4 48.6573 122.4 48.7478 122.4C48.6573 122.491 48.6573 122.4 48.6573 122.4C48.5669 122.31 48.6573 122.31 48.7478 122.4C48.6573 122.31 48.7478 122.31 48.7478 122.4Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.481 117.063C47.481 117.153 47.481 117.153 47.481 117.063C47.3911 117.153 47.3911 117.153 47.481 117.063C47.3911 117.063 47.3911 117.063 47.481 117.063Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7528 104.669C10.9027 104.669 11.0242 104.548 11.0242 104.398C11.0242 104.248 10.9027 104.127 10.7528 104.127C10.603 104.127 10.4814 104.248 10.4814 104.398C10.4814 104.548 10.603 104.669 10.7528 104.669Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67704 103.041C7.67704 103.132 7.58658 103.222 7.49611 103.222C7.40565 103.222 7.31519 103.132 7.31519 103.041C7.31519 102.951 7.40565 102.86 7.49611 102.86C7.58658 102.951 7.67704 102.951 7.67704 103.041Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52554 100.87C1.67543 100.87 1.79694 100.748 1.79694 100.598C1.79694 100.449 1.67543 100.327 1.52554 100.327C1.37566 100.327 1.25415 100.449 1.25415 100.598C1.25415 100.748 1.37566 100.87 1.52554 100.87Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87759 119.596C4.02748 119.596 4.14898 119.474 4.14898 119.325C4.14898 119.175 4.02748 119.053 3.87759 119.053C3.72771 119.053 3.6062 119.175 3.6062 119.325C3.6062 119.474 3.72771 119.596 3.87759 119.596Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67702 125.205C7.77695 125.205 7.85795 125.124 7.85795 125.024C7.85795 124.924 7.77695 124.843 7.67702 124.843C7.5771 124.843 7.49609 124.924 7.49609 125.024C7.49609 125.124 7.5771 125.205 7.67702 125.205Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.034 100.327C46.034 100.418 45.9435 100.418 45.9435 100.418C45.853 100.418 45.853 100.327 45.853 100.327C45.853 100.237 45.9435 100.237 45.9435 100.237C46.034 100.237 46.034 100.327 46.034 100.327Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.034 97.6132C46.2338 97.6132 46.3958 97.4512 46.3958 97.2513C46.3958 97.0515 46.2338 96.8895 46.034 96.8895C45.8341 96.8895 45.6721 97.0515 45.6721 97.2513C45.6721 97.4512 45.8341 97.6132 46.034 97.6132Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9288 95.4421C48.9788 95.4421 49.0193 95.4016 49.0193 95.3516C49.0193 95.3016 48.9788 95.2611 48.9288 95.2611C48.8789 95.2611 48.8384 95.3016 48.8384 95.3516C48.8384 95.4016 48.8789 95.4421 48.9288 95.4421Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9824 74.9067C74.9824 74.9972 74.9824 74.9972 74.9824 74.9067C74.892 74.9972 74.8015 74.9972 74.8015 74.9067C74.892 74.9067 74.892 74.8162 74.9824 74.9067C74.9824 74.8162 74.9824 74.9067 74.9824 74.9067Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6009 76.6255C78.6009 76.8064 78.42 76.9874 78.239 76.9874C78.0581 76.9874 77.8772 76.8064 77.8772 76.6255C77.8772 76.4446 78.0581 76.2636 78.239 76.2636C78.42 76.1732 78.6009 76.3541 78.6009 76.6255Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9776 69.3884C75.9776 69.4788 75.8871 69.5693 75.7966 69.5693C75.7062 69.5693 75.6157 69.4788 75.6157 69.3884C75.6157 69.2979 75.7062 69.2075 75.7966 69.2075C75.8871 69.2075 75.9776 69.2979 75.9776 69.3884Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2293 74.6353C80.2293 74.8162 80.0484 74.9972 79.8675 74.9972C79.6865 74.9972 79.5056 74.8162 79.5056 74.6353C79.5056 74.4544 79.6865 74.2734 79.8675 74.2734C80.0484 74.2734 80.2293 74.4544 80.2293 74.6353Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7239 74.8167C90.6328 74.9078 90.6328 74.8167 90.6328 74.8167C90.6328 74.7256 90.6328 74.7256 90.7239 74.8167C90.7239 74.7256 90.7239 74.7256 90.7239 74.8167Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7427 78.3443C86.9426 78.3443 87.1046 78.1823 87.1046 77.9825C87.1046 77.7826 86.9426 77.6206 86.7427 77.6206C86.5429 77.6206 86.3809 77.7826 86.3809 77.9825C86.3809 78.1823 86.5429 78.3443 86.7427 78.3443Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0044 82.6866C89.2043 82.6866 89.3663 82.5246 89.3663 82.3247C89.3663 82.1249 89.2043 81.9629 89.0044 81.9629C88.8046 81.9629 88.6426 82.1249 88.6426 82.3247C88.6426 82.5246 88.8046 82.6866 89.0044 82.6866Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.095 86.2147C89.1949 86.2147 89.2759 86.1337 89.2759 86.0337C89.2759 85.9338 89.1949 85.8528 89.095 85.8528C88.9951 85.8528 88.9141 85.9338 88.9141 86.0337C88.9141 86.1337 88.9951 86.2147 89.095 86.2147Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0704 87.3003C94.0704 87.4812 93.8895 87.6621 93.7085 87.6621C93.5276 87.6621 93.3467 87.4812 93.3467 87.3003C93.3467 87.1193 93.5276 86.9384 93.7085 86.9384C93.8895 86.9384 94.0704 87.1193 94.0704 87.3003Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6279 93.09C91.6279 93.09 91.6279 93.1804 91.6279 93.09C91.5375 93.1804 91.447 93.09 91.447 93.09C91.5375 92.9995 91.5375 92.9995 91.6279 93.09C91.6279 92.9995 91.6279 92.9995 91.6279 93.09Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.674 95.9848C100.674 96.1658 100.493 96.2562 100.403 96.2562C100.313 96.2562 100.132 96.0753 100.132 95.9848C100.132 95.8944 100.313 95.7134 100.403 95.7134C100.493 95.7134 100.674 95.8039 100.674 95.9848Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.036 99.4225C101.036 99.513 100.946 99.513 100.946 99.513C100.855 99.513 100.855 99.4225 100.855 99.4225L100.946 99.332C101.036 99.2416 101.036 99.332 101.036 99.4225Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.902 186.811C109.902 186.901 109.811 186.901 109.811 186.901C109.721 186.901 109.721 186.811 109.721 186.811C109.721 186.72 109.811 186.72 109.811 186.72C109.811 186.72 109.902 186.72 109.902 186.811Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.178 183.192C109.178 183.283 109.087 183.373 108.997 183.373C108.906 183.373 108.816 183.283 108.816 183.192C108.816 183.102 108.906 183.011 108.997 183.011C109.087 183.011 109.178 183.102 109.178 183.192Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.283 184.821C106.283 185.002 106.102 185.182 105.921 185.182C105.74 185.182 105.559 185.002 105.559 184.821C105.559 184.64 105.74 184.459 105.921 184.459C106.102 184.459 106.283 184.549 106.283 184.821Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.62 186.268C111.62 186.359 111.62 186.359 111.62 186.268C111.53 186.359 111.439 186.359 111.439 186.268C111.439 186.178 111.53 186.178 111.62 186.268C111.62 186.178 111.62 186.268 111.62 186.268Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.591 187.263C117.591 187.444 117.41 187.625 117.229 187.625C117.048 187.625 116.867 187.444 116.867 187.263C116.867 187.082 117.048 186.901 117.229 186.901C117.41 186.992 117.591 187.082 117.591 187.263Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.224 180.026C118.424 180.026 118.586 179.864 118.586 179.664C118.586 179.464 118.424 179.302 118.224 179.302C118.024 179.302 117.862 179.464 117.862 179.664C117.862 179.864 118.024 180.026 118.224 180.026Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.295 179.664C122.495 179.664 122.657 179.502 122.657 179.302C122.657 179.102 122.495 178.94 122.295 178.94C122.095 178.94 121.933 179.102 121.933 179.302C121.933 179.502 122.095 179.664 122.295 179.664Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.723 182.197C127.723 182.288 127.632 182.378 127.542 182.378C127.452 182.378 127.361 182.288 127.361 182.197C127.361 182.107 127.452 182.016 127.542 182.016C127.632 182.016 127.723 182.016 127.723 182.197Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.699 182.83C132.699 182.921 132.608 182.921 132.608 182.921L132.518 182.83C132.518 182.74 132.608 182.74 132.608 182.74C132.608 182.74 132.699 182.74 132.699 182.83Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.413 176.679C135.413 176.769 135.322 176.86 135.232 176.86C135.141 176.86 135.051 176.769 135.051 176.679C135.051 176.588 135.141 176.498 135.232 176.498C135.322 176.588 135.413 176.588 135.413 176.679Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.65 178.76C142.65 178.94 142.559 179.031 142.378 179.031C142.197 179.031 142.107 178.94 142.107 178.76C142.107 178.579 142.197 178.488 142.378 178.488C142.559 178.488 142.65 178.579 142.65 178.76Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.725 170.708C145.725 170.799 145.635 170.889 145.544 170.889C145.454 170.889 145.364 170.799 145.364 170.708C145.364 170.618 145.454 170.527 145.544 170.527C145.635 170.527 145.725 170.618 145.725 170.708Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.134 171.07C155.134 171.251 154.953 171.432 154.772 171.432C154.591 171.432 154.41 171.251 154.41 171.07C154.41 170.889 154.591 170.708 154.772 170.708C154.953 170.708 155.134 170.889 155.134 171.07Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.185 165.913C163.185 165.913 163.095 165.913 163.185 165.913C163.095 165.913 163.095 165.913 163.185 165.913C163.095 165.913 163.095 165.823 163.185 165.913C163.095 165.823 163.185 165.913 163.185 165.913Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.422 156.777C170.622 156.777 170.784 156.615 170.784 156.415C170.784 156.215 170.622 156.053 170.422 156.053C170.222 156.053 170.06 156.215 170.06 156.415C170.06 156.615 170.222 156.777 170.422 156.777Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2 147.007C160.2 147.097 160.109 147.097 160.2 147.007C160.019 147.097 160.019 147.097 160.019 147.007C160.019 146.916 160.019 146.916 160.2 147.007C160.109 146.916 160.2 147.007 160.2 147.007Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.043 147.097C155.093 147.097 155.134 147.057 155.134 147.007C155.134 146.957 155.093 146.916 155.043 146.916C154.993 146.916 154.953 146.957 154.953 147.007C154.953 147.057 154.993 147.097 155.043 147.097Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.452 136.423C164.452 136.423 164.361 136.423 164.452 136.423C164.361 136.423 164.452 136.331 164.452 136.423C164.452 136.331 164.452 136.423 164.452 136.423Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.98 137.417C167.98 137.508 167.889 137.689 167.708 137.689C167.618 137.689 167.437 137.598 167.437 137.417C167.437 137.327 167.527 137.146 167.708 137.146C167.889 137.146 167.98 137.236 167.98 137.417Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.163 118.149C186.163 118.239 186.072 118.329 185.982 118.329C185.891 118.329 185.801 118.239 185.801 118.149C185.801 118.058 185.891 117.968 185.982 117.968C186.072 117.968 186.163 118.058 186.163 118.149Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.696 121.496C188.696 121.677 188.515 121.858 188.334 121.858C188.153 121.858 187.972 121.677 187.972 121.496C187.972 121.315 188.153 121.134 188.334 121.134C188.515 121.134 188.696 121.315 188.696 121.496Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53 121.496C185.68 121.496 185.801 121.374 185.801 121.224C185.801 121.074 185.68 120.953 185.53 120.953C185.38 120.953 185.258 121.074 185.258 121.224C185.258 121.374 185.38 121.496 185.53 121.496Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.882 127.828C187.882 127.919 187.791 128.1 187.61 128.1C187.52 128.1 187.339 128.009 187.339 127.828C187.339 127.738 187.429 127.557 187.61 127.557C187.791 127.557 187.882 127.647 187.882 127.828Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.449 132.985C183.449 133.075 183.449 133.075 183.359 133.075C183.268 133.075 183.268 133.075 183.268 132.985C183.268 132.894 183.268 132.894 183.359 132.894L183.449 132.985Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.026 135.97C177.026 136.06 176.935 136.151 176.845 136.151C176.755 136.151 176.664 136.06 176.664 135.97C176.664 135.88 176.755 135.789 176.845 135.789C176.935 135.789 177.026 135.88 177.026 135.97Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.84 138.593C177.94 138.593 178.021 138.512 178.021 138.412C178.021 138.313 177.94 138.232 177.84 138.232C177.74 138.232 177.659 138.313 177.659 138.412C177.659 138.512 177.74 138.593 177.84 138.593Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.583 141.76C174.633 141.76 174.674 141.719 174.674 141.669C174.674 141.619 174.633 141.579 174.583 141.579C174.533 141.579 174.493 141.619 174.493 141.669C174.493 141.719 174.533 141.76 174.583 141.76Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.408 141.669C173.408 141.85 173.227 142.031 173.046 142.031C172.865 142.031 172.684 141.85 172.684 141.669C172.684 141.488 172.865 141.307 173.046 141.307C173.227 141.398 173.408 141.488 173.408 141.669Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.241 148.002C170.291 148.002 170.332 147.961 170.332 147.911C170.332 147.861 170.291 147.821 170.241 147.821C170.191 147.821 170.151 147.861 170.151 147.911C170.151 147.961 170.191 148.002 170.241 148.002Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7088 175.684C56.7088 175.774 56.6183 175.955 56.4374 175.955C56.3469 175.955 56.166 175.865 56.166 175.684C56.166 175.593 56.2565 175.412 56.4374 175.412C56.6183 175.412 56.7088 175.503 56.7088 175.684Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.76 176.86C64.86 176.86 64.941 176.779 64.941 176.679C64.941 176.579 64.86 176.498 64.76 176.498C64.6601 176.498 64.5791 176.579 64.5791 176.679C64.5791 176.779 64.6601 176.86 64.76 176.86Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.046 175.503C62.046 175.684 61.8651 175.865 61.6841 175.865C61.5032 175.865 61.3223 175.684 61.3223 175.503C61.3223 175.322 61.5032 175.141 61.6841 175.141C61.8651 175.141 62.046 175.231 62.046 175.503Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7747 174.146C61.7747 174.236 61.7747 174.236 61.7747 174.146C61.6842 174.236 61.5938 174.146 61.5938 174.146C61.5938 174.146 61.6842 174.055 61.7747 174.146C61.7747 174.055 61.7747 174.146 61.7747 174.146Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4276 172.789C58.5775 172.789 58.699 172.667 58.699 172.518C58.699 172.368 58.5775 172.246 58.4276 172.246C58.2778 172.246 58.1562 172.368 58.1562 172.518C58.1562 172.667 58.2778 172.789 58.4276 172.789Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7901 170.98C58.7901 170.98 58.699 171.071 58.7901 170.98C58.699 171.071 58.699 170.98 58.699 170.98C58.699 170.98 58.699 170.889 58.7901 170.98C58.699 170.889 58.7901 170.98 58.7901 170.98Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8504 161.571C64.8504 161.662 64.7599 161.752 64.6695 161.752C64.579 161.752 64.4885 161.662 64.4885 161.571C64.4885 161.481 64.579 161.39 64.6695 161.39C64.7599 161.39 64.8504 161.481 64.8504 161.571Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5594 160.848C68.5594 161.029 68.3785 161.209 68.1976 161.209C68.0166 161.209 67.8357 161.029 67.8357 160.848C67.8357 160.667 68.0166 160.486 68.1976 160.486C68.3785 160.486 68.5594 160.667 68.5594 160.848Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4471 163.923C91.6469 163.923 91.8089 163.761 91.8089 163.562C91.8089 163.362 91.6469 163.2 91.4471 163.2C91.2472 163.2 91.0852 163.362 91.0852 163.562C91.0852 163.761 91.2472 163.923 91.4471 163.923Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5081 161.029C97.5081 161.119 97.4176 161.119 97.4176 161.119L97.3271 161.029C97.3271 160.938 97.4176 160.938 97.4176 160.938C97.4176 160.938 97.5081 160.938 97.5081 161.029Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.76 165.371C101.76 165.461 101.669 165.552 101.579 165.552C101.488 165.552 101.398 165.461 101.398 165.371C101.398 165.28 101.488 165.19 101.579 165.19C101.669 165.19 101.76 165.371 101.76 165.371Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.178 162.476C109.178 162.657 109.087 162.747 108.906 162.747C108.725 162.747 108.635 162.657 108.635 162.476C108.635 162.295 108.725 162.205 108.906 162.205C109.087 162.205 109.178 162.295 109.178 162.476Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.701 167.09C113.701 167.271 113.611 167.361 113.43 167.361C113.249 167.361 113.158 167.271 113.158 167.09C113.158 166.909 113.249 166.818 113.43 166.818C113.52 166.818 113.701 166.909 113.701 167.09Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.029 168.628C121.228 168.628 121.39 168.466 121.39 168.266C121.39 168.066 121.228 167.904 121.029 167.904C120.829 167.904 120.667 168.066 120.667 168.266C120.667 168.466 120.829 168.628 121.029 168.628Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.728 154.877C163.728 154.967 163.637 155.058 163.547 155.058C163.456 155.058 163.366 154.967 163.366 154.877C163.366 154.787 163.456 154.696 163.547 154.696C163.637 154.787 163.728 154.787 163.728 154.877Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.085 153.43C165.085 153.52 164.994 153.61 164.904 153.61C164.813 153.61 164.723 153.52 164.723 153.43C164.723 153.339 164.813 153.249 164.904 153.249C164.994 153.249 165.085 153.339 165.085 153.43Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.075 148.364C167.075 148.545 166.894 148.635 166.804 148.635C166.713 148.635 166.532 148.454 166.532 148.364C166.532 148.273 166.713 148.092 166.804 148.092C166.894 148.092 167.075 148.183 167.075 148.364Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.271 142.031C164.321 142.031 164.361 141.991 164.361 141.941C164.361 141.891 164.321 141.85 164.271 141.85C164.221 141.85 164.18 141.891 164.18 141.941C164.18 141.991 164.221 142.031 164.271 142.031Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.794 140.493C168.794 140.674 168.613 140.765 168.522 140.765C168.432 140.765 168.251 140.584 168.251 140.493C168.251 140.312 168.432 140.222 168.522 140.222C168.613 140.222 168.794 140.312 168.794 140.493Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.613 131.99C168.813 131.99 168.975 131.828 168.975 131.628C168.975 131.428 168.813 131.266 168.613 131.266C168.413 131.266 168.251 131.428 168.251 131.628C168.251 131.828 168.413 131.99 168.613 131.99Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.317 133.347C173.317 133.527 173.226 133.618 173.046 133.618C172.865 133.618 172.774 133.527 172.774 133.347C172.774 133.166 172.865 133.075 173.046 133.075C173.226 133.075 173.317 133.166 173.317 133.347Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.945 128.823C174.945 128.914 174.855 128.914 174.855 128.914C174.764 128.914 174.764 128.823 174.764 128.823C174.764 128.733 174.855 128.733 174.855 128.733C174.855 128.642 174.945 128.733 174.945 128.823Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.625 123.757C184.625 123.848 184.625 123.848 184.535 123.848C184.444 123.848 184.444 123.848 184.444 123.757C184.444 123.667 184.444 123.667 184.535 123.667C184.625 123.667 184.625 123.757 184.625 123.757Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.327 188.168C171.377 188.168 171.417 188.127 171.417 188.077C171.417 188.027 171.377 187.987 171.327 187.987C171.277 187.987 171.236 188.027 171.236 188.077C171.236 188.127 171.277 188.168 171.327 188.168Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.412 186.992C172.412 187.173 172.232 187.354 172.051 187.354C171.87 187.354 171.689 187.173 171.689 186.992C171.689 186.811 171.87 186.63 172.051 186.63C172.232 186.63 172.412 186.811 172.412 186.992Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.657 168.808C196.657 168.899 196.566 168.899 196.566 168.899C196.476 168.899 196.476 168.808 196.476 168.808C196.476 168.718 196.566 168.718 196.566 168.718C196.657 168.628 196.657 168.718 196.657 168.808Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.632 163.833C201.682 163.833 201.723 163.792 201.723 163.742C201.723 163.693 201.682 163.652 201.632 163.652C201.582 163.652 201.542 163.693 201.542 163.742C201.542 163.792 201.582 163.833 201.632 163.833Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.989 159.4C203.189 159.4 203.351 159.238 203.351 159.038C203.351 158.838 203.189 158.676 202.989 158.676C202.789 158.676 202.627 158.838 202.627 159.038C202.627 159.238 202.789 159.4 202.989 159.4Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.918 155.601C199.118 155.601 199.28 155.439 199.28 155.239C199.28 155.039 199.118 154.877 198.918 154.877C198.718 154.877 198.556 155.039 198.556 155.239C198.556 155.439 198.718 155.601 198.918 155.601Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.642 152.072C199.552 152.072 199.552 152.072 199.642 152.072C199.552 152.072 199.552 151.982 199.642 152.072C199.642 151.982 199.642 152.072 199.642 152.072Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.315 149.268C192.315 149.449 192.224 149.54 192.043 149.54C191.862 149.54 191.772 149.449 191.772 149.268C191.772 149.087 191.862 148.997 192.043 148.997C192.224 148.997 192.315 149.087 192.315 149.268Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.134 146.102C192.134 146.192 192.134 146.192 192.043 146.192C191.953 146.192 191.953 146.192 191.953 146.102C191.953 146.011 191.953 146.012 192.043 146.012C192.043 146.012 192.134 146.011 192.134 146.102Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.158 137.598C187.208 137.598 187.249 137.558 187.249 137.508C187.249 137.458 187.208 137.417 187.158 137.417C187.108 137.417 187.068 137.458 187.068 137.508C187.068 137.558 187.108 137.598 187.158 137.598Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.053 132.261C190.053 132.442 189.872 132.623 189.691 132.623C189.51 132.623 189.329 132.442 189.329 132.261C189.329 132.08 189.51 131.899 189.691 131.899C189.962 131.99 190.053 132.08 190.053 132.261Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.444 129.366C184.494 129.366 184.534 129.326 184.534 129.276C184.534 129.226 184.494 129.185 184.444 129.185C184.394 129.185 184.354 129.226 184.354 129.276C184.354 129.326 184.394 129.366 184.444 129.366Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.669 174.417C212.579 174.417 212.579 174.417 212.669 174.417C212.579 174.327 212.579 174.327 212.669 174.417C212.669 174.327 212.669 174.327 212.669 174.417Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.725 172.065C219.725 172.156 219.725 172.156 219.725 172.065C219.635 172.156 219.544 172.065 219.544 172.065C219.544 172.065 219.635 171.975 219.725 172.065C219.725 171.975 219.725 172.065 219.725 172.065Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.558 164.376C216.558 164.466 216.468 164.466 216.558 164.376C216.468 164.466 216.468 164.466 216.558 164.376C216.468 164.376 216.468 164.376 216.558 164.376C216.468 164.376 216.558 164.376 216.558 164.376Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.93 156.958C214.93 157.139 214.75 157.32 214.569 157.32C214.388 157.32 214.207 157.139 214.207 156.958C214.207 156.777 214.388 156.596 214.569 156.596C214.75 156.596 214.93 156.777 214.93 156.958Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.955 149.992C209.955 150.082 209.864 150.173 209.774 150.173C209.683 150.173 209.593 150.082 209.593 149.992C209.593 149.901 209.683 149.811 209.774 149.811C209.864 149.811 209.955 149.901 209.955 149.992Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.813 147.73C201.813 147.821 201.813 147.821 201.813 147.73C201.632 147.821 201.632 147.821 201.632 147.73C201.632 147.73 201.723 147.64 201.813 147.73C201.813 147.64 201.813 147.73 201.813 147.73Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.295 146.192C196.445 146.192 196.566 146.071 196.566 145.921C196.566 145.771 196.445 145.65 196.295 145.65C196.145 145.65 196.023 145.771 196.023 145.921C196.023 146.071 196.145 146.192 196.295 146.192Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.857 141.669C192.857 141.76 192.767 141.76 192.857 141.669C192.767 141.76 192.676 141.669 192.676 141.669C192.676 141.669 192.767 141.579 192.857 141.669C192.767 141.579 192.857 141.669 192.857 141.669Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.94368 87.0289C8.94368 87.2098 8.76276 87.3908 8.58183 87.3908C8.4009 87.3908 8.21997 87.2098 8.21997 87.0289C8.21997 86.848 8.4009 86.6671 8.58183 86.6671C8.85322 86.6671 8.94368 86.848 8.94368 87.0289Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7945 76.6255C20.7945 76.7159 20.704 76.8064 20.6135 76.8064C20.5231 76.8064 20.4326 76.7159 20.4326 76.6255C20.4326 76.535 20.5231 76.4445 20.6135 76.4445C20.704 76.4445 20.7945 76.535 20.7945 76.6255Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7601 66.403C27.7601 66.4935 27.6696 66.6744 27.4887 66.6744C27.3982 66.6744 27.2173 66.584 27.2173 66.403C27.2173 66.3126 27.3077 66.1317 27.4887 66.1317C27.6696 66.2221 27.7601 66.3126 27.7601 66.403Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9215 62.2417C31.9215 62.4226 31.7405 62.6035 31.5596 62.6035C31.3787 62.6035 31.1978 62.4226 31.1978 62.2417C31.1978 62.0607 31.3787 61.8798 31.5596 61.8798C31.7405 61.8798 31.9215 62.0607 31.9215 62.2417Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6208 63.2368C37.7706 63.2368 37.8921 63.1153 37.8921 62.9654C37.8921 62.8155 37.7706 62.694 37.6208 62.694C37.4709 62.694 37.3494 62.8155 37.3494 62.9654C37.3494 63.1153 37.4709 63.2368 37.6208 63.2368Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0951 68.936C52.245 68.936 52.3665 68.8145 52.3665 68.6646C52.3665 68.5148 52.245 68.3932 52.0951 68.3932C51.9452 68.3932 51.8237 68.5148 51.8237 68.6646C51.8237 68.8145 51.9452 68.936 52.0951 68.936Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6377 77.4397C52.6377 77.5301 52.5473 77.6206 52.4568 77.6206C52.3663 77.6206 52.2759 77.5301 52.2759 77.4397C52.2759 77.3492 52.3663 77.2587 52.4568 77.2587C52.5473 77.2587 52.6377 77.3492 52.6377 77.4397Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4441 89.8329C73.3542 89.8329 73.3542 89.8329 73.4441 89.8329C73.3542 89.743 73.3542 89.743 73.4441 89.8329C73.4441 89.743 73.4441 89.743 73.4441 89.8329Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4251 90.6475C77.525 90.6475 77.606 90.5665 77.606 90.4665C77.606 90.3666 77.525 90.2856 77.4251 90.2856C77.3251 90.2856 77.2441 90.3666 77.2441 90.4665C77.2441 90.5665 77.3251 90.6475 77.4251 90.6475Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.491 85.2196C82.491 85.4005 82.3101 85.5814 82.1292 85.5814C81.9483 85.5814 81.7673 85.4005 81.7673 85.2196C81.7673 85.0387 81.9483 84.8577 82.1292 84.8577C82.3101 84.8577 82.491 85.0387 82.491 85.2196Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5813 90.1047C82.7812 90.1047 82.9432 89.9427 82.9432 89.7428C82.9432 89.543 82.7812 89.381 82.5813 89.381C82.3815 89.381 82.2195 89.543 82.2195 89.7428C82.2195 89.9427 82.3815 90.1047 82.5813 90.1047Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1853 91.1903C89.1853 91.2807 89.0949 91.2807 89.0949 91.2807C89.0044 91.2807 89.0044 91.1903 89.0044 91.1903C89.0044 91.0998 89.0949 91.0998 89.0949 91.0998C89.0949 91.0093 89.1853 91.0998 89.1853 91.1903Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2416 89.4714C96.2916 89.4714 96.332 89.4309 96.332 89.381C96.332 89.331 96.2916 89.2905 96.2416 89.2905C96.1916 89.2905 96.1511 89.331 96.1511 89.381C96.1511 89.4309 96.1916 89.4714 96.2416 89.4714Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.021 84.2245C104.171 84.2245 104.293 84.103 104.293 83.9531C104.293 83.8032 104.171 83.6817 104.021 83.6817C103.872 83.6817 103.75 83.8032 103.75 83.9531C103.75 84.103 103.872 84.2245 104.021 84.2245Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.112 80.6059C104.112 80.6964 104.021 80.7868 103.931 80.7868C103.84 80.7868 103.75 80.6964 103.75 80.6059C103.75 80.5154 103.84 80.425 103.931 80.425C104.021 80.425 104.112 80.5154 104.112 80.6059Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.806 81.3297C110.806 81.5106 110.716 81.601 110.535 81.601C110.354 81.601 110.263 81.5106 110.263 81.3297C110.263 81.1487 110.354 81.0583 110.535 81.0583C110.716 81.0583 110.806 81.1487 110.806 81.3297Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.867 78.7966C116.917 78.7966 116.958 78.7561 116.958 78.7062C116.958 78.6562 116.917 78.6157 116.867 78.6157C116.817 78.6157 116.777 78.6562 116.777 78.7062C116.777 78.7561 116.817 78.7966 116.867 78.7966Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.586 70.6545C118.586 70.6545 118.496 70.6545 118.586 70.6545C118.496 70.6545 118.496 70.6545 118.586 70.6545C118.496 70.5646 118.496 70.5646 118.586 70.6545C118.496 70.5646 118.586 70.5646 118.586 70.6545Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.743 65.5889C123.743 65.6794 123.652 65.7698 123.562 65.7698C123.471 65.7698 123.381 65.6794 123.381 65.5889C123.381 65.4984 123.471 65.408 123.562 65.408C123.652 65.408 123.743 65.4984 123.743 65.5889Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.809 61.518C128.809 61.6989 128.718 61.7894 128.537 61.7894C128.356 61.7894 128.266 61.6989 128.266 61.518C128.266 61.337 128.356 61.2466 128.537 61.2466C128.718 61.2466 128.809 61.337 128.809 61.518Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.99 60.7943C128.99 60.8847 128.899 60.8847 128.899 60.8847C128.809 60.8847 128.809 60.7943 128.809 60.7943C128.809 60.7038 128.899 60.7038 128.899 60.7038C128.899 60.6133 128.99 60.7038 128.99 60.7943Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0728 71.2882C75.0728 71.3786 74.9823 71.3786 74.9823 71.3786C74.8918 71.3786 74.8918 71.2882 74.8918 71.2882C74.8918 71.1977 74.9823 71.1977 74.9823 71.1977C74.9823 71.1977 75.0728 71.1977 75.0728 71.2882Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3199 66.7649C80.3199 66.9458 80.139 67.1268 79.958 67.1268C79.7771 67.1268 79.5962 66.9458 79.5962 66.7649C79.5962 66.584 79.7771 66.403 79.958 66.403C80.139 66.403 80.3199 66.4935 80.3199 66.7649Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3907 61.4275C84.3907 61.518 84.3002 61.6989 84.1193 61.6989C84.0288 61.6989 83.8479 61.6085 83.8479 61.4275C83.8479 61.3371 83.9384 61.1561 84.1193 61.1561C84.3002 61.2466 84.3907 61.3371 84.3907 61.4275Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5423 57.0853C90.5423 57.1757 90.4518 57.1757 90.5423 57.0853C90.3613 57.1757 90.3613 57.1757 90.3613 57.0853C90.3613 57.0853 90.3613 56.9948 90.5423 57.0853C90.4518 56.9948 90.5423 57.0853 90.5423 57.0853Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8797 58.1708C95.8797 58.3517 95.6988 58.5327 95.5179 58.5327C95.3369 58.5327 95.156 58.3517 95.156 58.1708C95.156 57.9899 95.3369 57.809 95.5179 57.809C95.6988 57.809 95.8797 57.9899 95.8797 58.1708Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0606 57.3566C96.1605 57.3566 96.2415 57.2756 96.2415 57.1757C96.2415 57.0758 96.1605 56.9948 96.0606 56.9948C95.9606 56.9948 95.8796 57.0758 95.8796 57.1757C95.8796 57.2756 95.9606 57.3566 96.0606 57.3566Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.122 52.743C102.122 52.8341 102.122 52.8341 102.122 52.743C102.031 52.8341 102.031 52.743 102.031 52.743H102.122Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.288 57.628C105.288 57.809 105.107 57.9899 104.926 57.9899C104.745 57.9899 104.564 57.809 104.564 57.628C104.564 57.4471 104.745 57.2662 104.926 57.2662C105.107 57.2662 105.288 57.3566 105.288 57.628Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.158 51.8383C113.158 51.9283 113.158 51.9283 113.158 51.8383C113.068 51.9283 113.068 51.9283 113.158 51.8383C113.068 51.8383 113.068 51.8383 113.158 51.8383Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.701 54.6427C113.701 54.7332 113.611 54.7332 113.611 54.7332L113.52 54.6427C113.52 54.5523 113.611 54.5523 113.611 54.5523C113.611 54.5523 113.701 54.5523 113.701 54.6427Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.234 54.0095C116.234 54.1904 116.144 54.2809 115.963 54.2809C115.782 54.2809 115.691 54.1904 115.691 54.0095C115.691 53.8285 115.782 53.7381 115.963 53.7381C116.053 53.7381 116.234 53.8285 116.234 54.0095Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.591 53.2858C117.591 53.3763 117.501 53.4667 117.41 53.4667C117.32 53.4667 117.229 53.3763 117.229 53.2858C117.229 53.1953 117.32 53.1049 117.41 53.1049C117.501 53.1049 117.591 53.1953 117.591 53.2858Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.124 52.8334C120.124 52.9239 120.034 53.0144 119.943 53.0144C119.853 53.0144 119.762 52.9239 119.762 52.8334C119.762 52.743 119.853 52.6525 119.943 52.6525C120.124 52.743 120.124 52.743 120.124 52.8334Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.553 54.1907C125.461 54.2818 125.461 54.1907 125.461 54.1907C125.461 54.1907 125.461 54.0996 125.553 54.1907C125.553 54.0996 125.553 54.1907 125.553 54.1907Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.241 52.2002C133.241 52.2907 133.151 52.2907 133.151 52.2907C133.061 52.2907 133.061 52.2002 133.061 52.2002C133.061 52.1097 133.151 52.1097 133.151 52.1097C133.241 52.0193 133.241 52.1097 133.241 52.2002Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.327 41.6159C134.327 41.7063 134.236 41.7968 134.146 41.7968C134.056 41.7968 133.965 41.7063 133.965 41.6159C133.965 41.5254 134.056 41.4349 134.146 41.4349C134.236 41.4349 134.327 41.5254 134.327 41.6159Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.464 39.5352C143.464 39.7162 143.283 39.8971 143.102 39.8971C142.921 39.8971 142.74 39.7162 142.74 39.5352C142.74 39.3543 142.921 39.1734 143.102 39.1734C143.283 39.1734 143.464 39.3543 143.464 39.5352Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.373 37.0927C143.523 37.0927 143.645 36.9711 143.645 36.8213C143.645 36.6714 143.523 36.5499 143.373 36.5499C143.224 36.5499 143.102 36.6714 143.102 36.8213C143.102 36.9711 143.224 37.0927 143.373 37.0927Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.54 34.6501C146.59 34.6501 146.63 34.6096 146.63 34.5597C146.63 34.5097 146.59 34.4692 146.54 34.4692C146.49 34.4692 146.449 34.5097 146.449 34.5597C146.449 34.6096 146.49 34.6501 146.54 34.6501Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.972 29.7651C150.972 29.8556 150.882 29.946 150.791 29.946C150.701 29.946 150.61 29.8556 150.61 29.7651C150.61 29.6746 150.701 29.5842 150.791 29.5842C150.972 29.5842 150.972 29.6746 150.972 29.7651Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.667 31.7556C157.667 31.7556 157.667 31.8467 157.667 31.7556C157.576 31.8467 157.576 31.7556 157.576 31.7556C157.576 31.7556 157.576 31.6645 157.667 31.7556C157.667 31.6645 157.667 31.7556 157.667 31.7556Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.994 26.5084C164.994 26.6893 164.904 26.7798 164.723 26.7798C164.542 26.7798 164.451 26.6893 164.451 26.5084C164.451 26.3274 164.542 26.237 164.723 26.237C164.904 26.237 164.994 26.4179 164.994 26.5084Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.165 26.6893C167.165 26.8702 167.075 26.9607 166.894 26.9607C166.713 26.9607 166.623 26.8702 166.623 26.6893C166.623 26.5083 166.713 26.4179 166.894 26.4179C166.984 26.4179 167.165 26.5988 167.165 26.6893Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.618 27.9558C167.618 28.0462 167.527 28.0463 167.527 28.0463C167.437 28.0463 167.437 27.9558 167.437 27.9558C167.437 27.8653 167.527 27.8653 167.527 27.8653C167.527 27.7749 167.618 27.8653 167.618 27.9558Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.588 26.8702C173.588 26.9607 173.498 27.0511 173.407 27.0511C173.317 27.0511 173.227 26.9607 173.227 26.8702C173.227 26.7797 173.317 26.6893 173.407 26.6893C173.588 26.6893 173.588 26.7797 173.588 26.8702Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.483 29.8555C176.483 30.0364 176.302 30.2174 176.121 30.2174C175.94 30.2174 175.76 30.0364 175.76 29.8555C175.76 29.6746 175.94 29.4937 176.121 29.4937C176.302 29.4937 176.483 29.6746 176.483 29.8555Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.302 26.8702C176.302 26.9607 176.212 26.9607 176.212 26.9607C176.121 26.9607 176.121 26.8702 176.121 26.8702C176.121 26.7798 176.212 26.7798 176.212 26.7798C176.302 26.6893 176.302 26.7798 176.302 26.8702Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3501 150.716C37.3501 150.807 37.3501 150.807 37.3501 150.716C37.259 150.807 37.259 150.716 37.259 150.716C37.259 150.716 37.259 150.716 37.3501 150.716Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1392 151.077C43.1392 151.168 43.0488 151.349 42.8678 151.349C42.7774 151.349 42.5964 151.258 42.5964 151.077C42.5964 150.897 42.6869 150.806 42.8678 150.806C43.0488 150.897 43.1392 150.987 43.1392 151.077Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.095 142.031C52.095 142.122 52.0045 142.212 51.9141 142.212C51.8236 142.212 51.7332 142.122 51.7332 142.031C51.7332 141.941 51.8236 141.85 51.9141 141.85C52.0045 141.941 52.095 141.941 52.095 142.031Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8406 105.122C66.8406 105.303 66.7502 105.393 66.5692 105.393C66.3883 105.393 66.2979 105.303 66.2979 105.122C66.2979 104.941 66.3883 104.85 66.5692 104.85C66.7502 104.85 66.8406 105.031 66.8406 105.122Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1023 99.332C69.1023 99.4225 69.0118 99.4225 69.0118 99.4225C68.9214 99.4225 68.9214 99.332 68.9214 99.332C68.9214 99.2415 69.0118 99.2415 69.0118 99.2415C69.0118 99.2415 69.1023 99.2415 69.1023 99.332Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7209 93.7232C72.8707 93.7232 72.9922 93.6017 72.9922 93.4518C72.9922 93.3019 72.8707 93.1804 72.7209 93.1804C72.571 93.1804 72.4495 93.3019 72.4495 93.4518C72.4495 93.6017 72.571 93.7232 72.7209 93.7232Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5252 88.9286C75.5252 89.1095 75.4347 89.2 75.2538 89.2C75.0729 89.2 74.9824 89.1095 74.9824 88.9286C74.9824 88.7477 75.0729 88.6572 75.2538 88.6572C75.4347 88.6572 75.5252 88.7477 75.5252 88.9286Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4153 79.4299C79.4153 79.6108 79.3249 79.7013 79.1439 79.7013C78.963 79.7013 78.8726 79.6108 78.8726 79.4299C78.8726 79.2489 78.963 79.1585 79.1439 79.1585C79.3249 79.1585 79.4153 79.2489 79.4153 79.4299Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4055 73.5497C81.4055 73.6402 81.3151 73.6402 81.4055 73.5497C81.3151 73.6402 81.2246 73.5497 81.2246 73.5497C81.2246 73.5497 81.3151 73.5497 81.4055 73.5497C81.3151 73.5497 81.4055 73.5497 81.4055 73.5497Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9384 70.1121C84.0883 70.1121 84.2098 69.9905 84.2098 69.8407C84.2098 69.6908 84.0883 69.5693 83.9384 69.5693C83.7885 69.5693 83.667 69.6908 83.667 69.8407C83.667 69.9905 83.7885 70.1121 83.9384 70.1121Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3914 61.6989C84.3914 61.79 84.3914 61.79 84.3914 61.6989C84.3003 61.79 84.3003 61.6989 84.3003 61.6989C84.3003 61.6989 84.3003 61.6989 84.3914 61.6989Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3809 62.0608C86.5807 62.0608 86.7428 61.8988 86.7428 61.6989C86.7428 61.4991 86.5807 61.3371 86.3809 61.3371C86.181 61.3371 86.019 61.4991 86.019 61.6989C86.019 61.8988 86.181 62.0608 86.3809 62.0608Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3565 62.5131C91.3565 62.6035 91.266 62.694 91.1756 62.694C91.0851 62.694 90.9946 62.6035 90.9946 62.5131C90.9946 62.4226 91.0851 62.3322 91.1756 62.3322C91.266 62.3322 91.3565 62.3322 91.3565 62.5131Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8943 58.8945C92.8943 59.0755 92.8039 59.1659 92.623 59.1659C92.442 59.1659 92.3516 59.0755 92.3516 58.8945C92.3516 58.7136 92.442 58.6231 92.623 58.6231C92.8039 58.7136 92.8943 58.8041 92.8943 58.8945Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7996 54.1909C93.7085 54.282 93.7085 54.1909 93.7085 54.1909C93.7085 54.1909 93.7085 54.0998 93.7996 54.1909C93.7996 54.0998 93.7996 54.0998 93.7996 54.1909Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.508 52.2002C97.6579 52.2002 97.7794 52.0787 97.7794 51.9288C97.7794 51.7789 97.6579 51.6574 97.508 51.6574C97.3581 51.6574 97.2366 51.7789 97.2366 51.9288C97.2366 52.0787 97.3581 52.2002 97.508 52.2002Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.388 54.4618C103.388 54.6427 103.298 54.7332 103.117 54.7332C102.936 54.7332 102.845 54.6427 102.845 54.4618C102.845 54.2809 102.936 54.1904 103.117 54.1904C103.207 54.1904 103.388 54.3713 103.388 54.4618Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.645 51.8383C106.645 51.9288 106.554 52.0193 106.464 52.0193C106.373 52.0193 106.283 51.9288 106.283 51.8383C106.283 51.7479 106.373 51.6574 106.464 51.6574C106.554 51.6574 106.645 51.7479 106.645 51.8383Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.334 50.5718C114.384 50.5718 114.425 50.5313 114.425 50.4814C114.425 50.4314 114.384 50.3909 114.334 50.3909C114.284 50.3909 114.244 50.4314 114.244 50.4814C114.244 50.5313 114.284 50.5718 114.334 50.5718Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.31 57.4471C119.31 57.5376 119.219 57.5376 119.219 57.5376C119.129 57.5376 119.129 57.4471 119.129 57.4471C119.129 57.3566 119.219 57.3566 119.219 57.3566C119.219 57.2662 119.31 57.3566 119.31 57.4471Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.728 50.3004C126.728 50.4814 126.547 50.6623 126.366 50.6623C126.185 50.6623 126.004 50.4814 126.004 50.3004C126.004 50.1195 126.185 49.9386 126.366 49.9386C126.637 50.029 126.728 50.1195 126.728 50.3004Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.818 46.0486C126.818 46.2295 126.637 46.32 126.547 46.32C126.366 46.32 126.276 46.1391 126.276 46.0486C126.276 45.8677 126.457 45.7772 126.547 45.7772C126.728 45.6867 126.818 45.8677 126.818 46.0486Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.674 46.8628C137.674 47.0437 137.493 47.2246 137.312 47.2246C137.131 47.2246 136.95 47.0437 136.95 46.8628C136.95 46.6818 137.131 46.5009 137.312 46.5009C137.493 46.5009 137.674 46.6818 137.674 46.8628Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7185 184.64C54.9184 184.64 55.0804 184.478 55.0804 184.278C55.0804 184.078 54.9184 183.916 54.7185 183.916C54.5187 183.916 54.3567 184.078 54.3567 184.278C54.3567 184.478 54.5187 184.64 54.7185 184.64Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3761 189.525C50.4261 189.525 50.4666 189.484 50.4666 189.434C50.4666 189.384 50.4261 189.344 50.3761 189.344C50.3261 189.344 50.2856 189.384 50.2856 189.434C50.2856 189.484 50.3261 189.525 50.3761 189.525Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5059 188.62C42.5059 188.801 42.325 188.982 42.1441 188.982C41.9632 188.982 41.7822 188.801 41.7822 188.62C41.7822 188.439 41.9632 188.258 42.1441 188.258C42.325 188.258 42.5059 188.349 42.5059 188.62Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9363 192.239C29.0362 192.239 29.1172 192.158 29.1172 192.058C29.1172 191.958 29.0362 191.877 28.9363 191.877C28.8364 191.877 28.7554 191.958 28.7554 192.058C28.7554 192.158 28.8364 192.239 28.9363 192.239Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8653 193.505C24.7748 193.596 24.6843 193.505 24.6843 193.505C24.7748 193.415 24.7748 193.415 24.8653 193.505C24.8653 193.415 24.8653 193.415 24.8653 193.505Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6624 194.048C10.6624 194.229 10.5719 194.319 10.391 194.319C10.2101 194.319 10.1196 194.229 10.1196 194.048C10.1196 193.867 10.2101 193.777 10.391 193.777C10.5719 193.777 10.6624 193.867 10.6624 194.048Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.30544 193.053C9.30544 193.053 9.21498 193.143 9.30544 193.053C9.21498 193.143 9.12451 193.143 9.12451 193.053C9.12451 192.962 9.12451 192.962 9.30544 193.053C9.21498 192.962 9.30544 192.962 9.30544 193.053Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.04383 193.686C7.0938 193.686 7.1343 193.646 7.1343 193.596C7.1343 193.546 7.0938 193.505 7.04383 193.505C6.99387 193.505 6.95337 193.546 6.95337 193.596C6.95337 193.646 6.99387 193.686 7.04383 193.686Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.16872 167.09C0.16872 167.18 0.0782557 167.18 0.0782557 167.18L-0.012207 167.09C-0.012207 166.999 0.0782557 166.999 0.0782557 166.999C0.0782557 166.999 0.16872 166.999 0.16872 167.09Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.59157 163.109C6.59157 163.2 6.50111 163.2 6.50111 163.2C6.41064 163.2 6.41064 163.109 6.41064 163.109C6.41064 163.019 6.50111 163.019 6.50111 163.019C6.59157 163.019 6.59157 163.019 6.59157 163.109Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.49123 162.566C8.59115 162.566 8.67216 162.485 8.67216 162.386C8.67216 162.286 8.59115 162.205 8.49123 162.205C8.3913 162.205 8.3103 162.286 8.3103 162.386C8.3103 162.485 8.3913 162.566 8.49123 162.566Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3763 157.591C13.3763 157.681 13.2858 157.772 13.1953 157.772C13.1049 157.772 13.0144 157.681 13.0144 157.591C13.0144 157.5 13.1049 157.41 13.1953 157.41C13.2858 157.41 13.3763 157.5 13.3763 157.591Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8189 156.777C15.8189 156.958 15.7284 157.048 15.5475 157.048C15.3666 157.048 15.2761 156.958 15.2761 156.777C15.2761 156.596 15.3666 156.505 15.5475 156.505C15.7284 156.505 15.8189 156.596 15.8189 156.777Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.814 148.545C16.814 148.635 16.7235 148.725 16.6331 148.725C16.5426 148.725 16.4521 148.635 16.4521 148.545C16.4521 148.454 16.5426 148.364 16.6331 148.364C16.7235 148.364 16.814 148.454 16.814 148.545Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7235 147.73C16.8734 147.73 16.9949 147.609 16.9949 147.459C16.9949 147.309 16.8734 147.188 16.7235 147.188C16.5737 147.188 16.4521 147.309 16.4521 147.459C16.4521 147.609 16.5737 147.73 16.7235 147.73Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1148 150.535C11.1148 150.716 10.9339 150.897 10.753 150.897C10.572 150.897 10.3911 150.716 10.3911 150.535C10.3911 150.354 10.572 150.173 10.753 150.173C10.9339 150.173 11.1148 150.354 11.1148 150.535Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.96806 150.806C4.16791 150.806 4.32991 150.644 4.32991 150.444C4.32991 150.244 4.16791 150.082 3.96806 150.082C3.76821 150.082 3.6062 150.244 3.6062 150.444C3.6062 150.644 3.76821 150.806 3.96806 150.806Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.713 170.618C129.913 170.618 130.075 170.456 130.075 170.256C130.075 170.056 129.913 169.894 129.713 169.894C129.514 169.894 129.352 170.056 129.352 170.256C129.352 170.456 129.514 170.618 129.713 170.618Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.523 178.126C131.523 178.307 131.342 178.488 131.161 178.488C130.98 178.488 130.799 178.307 130.799 178.126C130.799 177.945 130.98 177.764 131.161 177.764C131.342 177.674 131.523 177.855 131.523 178.126Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.356 183.645C128.556 183.645 128.718 183.483 128.718 183.283C128.718 183.083 128.556 182.921 128.356 182.921C128.156 182.921 127.994 183.083 127.994 183.283C127.994 183.483 128.156 183.645 128.356 183.645Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.175 188.711C128.225 188.711 128.266 188.67 128.266 188.62C128.266 188.57 128.225 188.53 128.175 188.53C128.125 188.53 128.085 188.57 128.085 188.62C128.085 188.67 128.125 188.711 128.175 188.711Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.06 193.958C133.06 194.138 132.879 194.319 132.699 194.319C132.518 194.319 132.337 194.138 132.337 193.958C132.337 193.777 132.518 193.596 132.699 193.596C132.879 193.596 133.06 193.777 133.06 193.958Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.332 192.962C96.432 192.962 96.513 192.881 96.513 192.781C96.513 192.682 96.432 192.601 96.332 192.601C96.2321 192.601 96.1511 192.682 96.1511 192.781C96.1511 192.881 96.2321 192.962 96.332 192.962Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9947 185.997C90.9947 186.087 90.9042 186.178 90.8137 186.178C90.7233 186.178 90.6328 186.087 90.6328 185.997C90.6328 185.906 90.7233 185.816 90.8137 185.816C90.9947 185.816 90.9947 185.906 90.9947 185.997Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1194 186.811C84.1194 186.901 84.029 186.992 83.9385 186.992C83.848 186.992 83.7576 186.901 83.7576 186.811C83.7576 186.72 83.848 186.63 83.9385 186.63C84.1194 186.63 84.1194 186.72 84.1194 186.811Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2195 187.625C82.2195 187.715 82.2195 187.715 82.2195 187.625C82.129 187.715 82.0386 187.625 82.0386 187.625C82.0386 187.625 82.129 187.535 82.2195 187.625C82.2195 187.535 82.2195 187.625 82.2195 187.625Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8774 187.625C78.0272 187.625 78.1487 187.503 78.1487 187.354C78.1487 187.204 78.0272 187.082 77.8774 187.082C77.7275 187.082 77.606 187.204 77.606 187.354C77.606 187.503 77.7275 187.625 77.8774 187.625Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9776 180.388C76.1774 180.388 76.3394 180.226 76.3394 180.026C76.3394 179.826 76.1774 179.664 75.9776 179.664C75.7777 179.664 75.6157 179.826 75.6157 180.026C75.6157 180.226 75.7777 180.388 75.9776 180.388Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8211 183.011C70.8211 183.192 70.7306 183.283 70.5497 183.283C70.3688 183.283 70.2783 183.192 70.2783 183.011C70.2783 182.83 70.3688 182.74 70.5497 182.74C70.7306 182.74 70.8211 182.921 70.8211 183.011Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.579 185.544C64.629 185.544 64.6695 185.504 64.6695 185.454C64.6695 185.404 64.629 185.363 64.579 185.363C64.529 185.363 64.4885 185.404 64.4885 185.454C64.4885 185.504 64.529 185.544 64.579 185.544Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0657 188.077C58.0657 188.168 57.9752 188.168 57.9752 188.168L57.8848 188.077C57.8848 187.987 57.9752 187.987 57.9752 187.987C57.9752 187.987 58.0657 187.987 58.0657 188.077Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8748 191.877C59.8748 191.967 59.7843 192.148 59.6034 192.148C59.513 192.148 59.332 192.058 59.332 191.877C59.332 191.786 59.4225 191.605 59.6034 191.605C59.7843 191.696 59.8748 191.786 59.8748 191.877Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7381 193.234C50.7381 193.415 50.5572 193.596 50.3763 193.596C50.1953 193.596 50.0144 193.415 50.0144 193.234C50.0144 193.053 50.1953 192.872 50.3763 192.872C50.5572 192.872 50.7381 192.962 50.7381 193.234Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.757 27.1416L197.199 30.3078L192.495 28.4081L194.757 27.1416Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.762 26.5083L191.5 26.4179L192.495 28.4081L193.762 26.5083Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.762 23.6135L193.219 25.5132L191.138 23.6135H193.762Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.138 20.8996L193.762 23.6135H191.138V20.8996Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.762 26.5084L193.219 25.5133L192.495 28.4081L193.762 26.5084Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.762 23.6135V26.5083L193.219 25.5132L193.762 23.6135Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.757 27.1416L193.762 26.5084L196.295 30.6697L194.757 27.1416Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.5 26.4179L193.219 25.5132L191.138 23.6135L191.5 26.4179Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.163 20.4473L186.887 18.7285L191.138 20.8996L186.163 20.4473Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.253 23.0707L191.138 20.8996L186.163 20.4473L186.253 23.0707Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.109 31.4839L197.2 30.3079L196.295 30.6697L197.109 31.4839Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.019 33.7455L197.109 31.4839L195.209 33.2932L197.019 33.7455Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.566 34.0169L197.109 31.4839L195.209 33.2932L196.566 34.0169Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.295 30.6697L195.571 31.3935L197.019 33.7455L196.295 30.6697Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.471 36.369L196.566 34.0169L196.114 36.4594L197.471 36.369Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.833 37.8164L196.747 38.9924L196.476 38.1783L197.833 37.8164Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.114 36.4594L197.833 37.8164L197.471 36.369L196.114 36.4594Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.119 36.369L195.571 37.9973L196.114 36.4594L195.119 36.369Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.49 39.9875L196.295 39.3543L195.571 37.9973L193.49 39.9875Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.747 38.9924L196.295 39.3543L196.476 38.1783L196.747 38.9924Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.134 32.479L191.138 34.2883L194.395 34.1074L192.134 32.479Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.209 33.2932L194.486 34.0169H196.566L195.209 33.2932Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.953 35.4643L189.239 37.1831L192.224 38.4496L191.953 35.4643Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.571 37.9973L192.224 38.4496L195.119 36.369L195.571 37.9973Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.395 34.1074L191.953 35.4643L195.119 36.369L194.395 34.1074Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.134 32.479L192.495 28.4081L195.571 31.3935L192.134 32.479Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.791 28.4986L184.263 30.5792L188.425 30.7602L187.791 28.4986Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.253 23.0707L191.138 23.6135L187.791 28.4986L186.253 23.0707Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.5 26.4179L186.253 23.0707L191.138 23.6135L191.5 26.4179Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.63 18.8189L186.887 18.7285L186.163 20.4473L183.63 18.8189Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.222 24.88L174.764 23.2516L175.036 25.6942L174.222 24.88Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.202 20.1759L181.368 19.6331L179.831 20.8996L178.202 20.1759Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.63 18.8189L181.368 19.6331L184.082 21.0805L183.63 18.8189Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.163 20.4473L184.082 21.0805L186.887 18.7285L186.163 20.4473Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.202 20.1759L174.764 23.2517L178.564 22.2565L178.202 20.1759Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.906 22.7089L184.082 21.0805L186.253 23.0707L182.906 22.7089Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.83 20.8996L184.082 21.0805L183.63 18.8189L179.83 20.8996Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.906 22.7089L183.178 24.2467L178.564 22.2565L182.906 22.7089Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.83 20.8996L182.906 22.7089L181.368 19.6331L179.83 20.8996Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.564 22.2565L179.83 20.8996L180.916 26.5988L178.564 22.2565Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.178 24.2468L180.916 26.5988L186.796 29.1318L183.178 24.2468Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.163 23.0707L183.177 24.2468L184.082 21.0805L186.163 23.0707Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.674 29.4032L173.769 26.6893L175.036 25.6942L174.674 29.4032Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.222 24.88L173.86 26.6893L175.036 25.6942L174.222 24.88Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.564 22.2565L177.84 23.7944L174.764 23.2516L178.564 22.2565Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.116 25.6942L180.916 26.5988L177.84 23.7944L177.116 25.6942Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.036 25.6942H177.117L177.84 23.7944L175.036 25.6942Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.483 28.3177L176.031 29.8555L174.674 29.4032L176.483 28.3177Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.117 25.6942L176.483 28.3176L180.916 26.5988L177.117 25.6942Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.134 32.479L188.425 30.7602L192.495 28.4081L192.134 32.479Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.791 28.4986L192.495 28.4081L191.5 26.4179L187.791 28.4986Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.757 32.9314L194.395 34.1074L192.134 32.479L194.757 32.9314Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.571 31.3935L194.757 32.9313L192.495 28.4081L195.571 31.3935Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.134 40.078L193.491 39.9875L192.224 38.4496L192.134 40.078Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.429 41.4349L190.415 40.4398L189.148 38.721L187.429 41.4349Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.224 38.4496L190.415 40.4399L192.134 40.078L192.224 38.4496Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.148 38.721L192.134 40.078L192.224 38.4496L189.148 38.721Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.429 41.4349L186.615 43.8775L182.906 43.3347L187.429 41.4349Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.354 34.5597L188.153 34.1074L189.239 37.1831L184.354 34.5597Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.138 34.2883L188.153 34.1074L188.424 30.7602L191.138 34.2883Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.268 37.9973L184.354 34.5597L188.153 34.1074L183.268 37.9973Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.429 41.4349L182.725 40.1685L183.268 37.9973L187.429 41.4349Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.239 37.1831L189.148 38.721L183.268 37.9973L189.239 37.1831Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.102 32.7504L184.354 34.5597L184.263 30.5793L180.102 32.7504Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.916 26.5988L180.102 32.7504L176.031 29.8556L180.916 26.5988Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.263 30.5793L180.916 26.5988L176.031 29.8556L184.263 30.5793Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.796 29.1318L180.916 26.5988L186.163 23.0707L186.796 29.1318Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.138 20.8996L186.163 20.4473L191.138 23.6135V20.8996Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.796 29.1318L184.354 34.5597L188.424 30.7602L186.796 29.1318Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.263 45.7772L186.615 43.8775L182.906 43.3347L184.263 45.7772Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.745 35.7357L180.102 32.7504L176.031 29.8555L178.745 35.7357Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.779 38.902L174.674 41.8873L176.936 38.4496L171.779 38.902Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.745 35.7357L176.936 38.4496L180.916 38.902L178.745 35.7357Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.268 37.9973L180.916 38.902L182.725 40.1685L183.268 37.9973Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.713 36.0071L169.608 36.8213L165.537 38.902L166.713 36.0071Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.779 38.902L169.608 36.8213L172.412 36.7308L171.779 38.902Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.583 38.0878L172.412 36.7308L174.674 41.8873L174.583 38.0878Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.583 38.0878L178.745 35.7357L176.936 38.4496L174.583 38.0878Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.845 34.8311L180.102 32.7504L176.031 29.8555L176.845 34.8311Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.674 29.4032L176.845 34.8311L176.031 29.8555L174.674 29.4032Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.583 38.0878L176.845 34.8311L178.745 35.7357L174.583 38.0878Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.412 36.7308L178.745 35.7357L174.583 38.0878L172.412 36.7308Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.728 36.8213L166.713 36.0071L169.608 36.8213H163.728Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.647 38.902L163.728 36.8213L165.537 38.902H161.647Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.677 43.0633L157.576 40.6208L159.205 41.9778L155.677 43.0633Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.647 38.902L157.576 40.6208L159.205 41.9778L161.647 38.902Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.909 42.5205L165.537 38.902L163.728 36.8213L163.909 42.5205Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.205 41.9778L165.537 38.902H161.647L159.205 41.9778Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.836 50.8432L141.293 56.271L144.278 50.8432H141.836Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.192 47.7674L145.816 47.1342L141.835 50.8432L143.192 47.7674Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.278 50.8432L143.192 47.7674L145.816 47.1342L144.278 50.8432Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.068 45.0535L145.816 47.1342L151.696 46.4105L150.068 45.0535Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.676 43.0633L150.068 45.0535L155.224 44.8726L155.676 43.0633Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.158 49.5767L151.696 46.4105L150.068 45.0535L150.158 49.5767Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.224 44.8726L151.696 46.4105L153.777 47.7674L155.224 44.8726Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.099 44.4203L159.205 41.9778L155.224 44.8726L162.099 44.4203Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.909 42.5205L159.205 41.9778L162.099 44.4203L163.909 42.5205Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.779 38.902L166.894 43.8775L165.537 38.902H171.779Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.965 44.4203L165.537 38.902L169.608 36.8213L170.965 44.4203Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.674 41.8873L170.965 44.4203L171.779 38.902L174.674 41.8873Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.774 46.0486L170.965 44.4203L174.674 41.8873L172.774 46.0486Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.026 44.0584L174.674 41.8873L176.936 38.4496L177.026 44.0584Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.075 47.7675L170.965 44.4203L166.894 43.8775L167.075 47.7675Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.909 42.5205L166.894 43.8775L162.099 44.4203L163.909 42.5205Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.848 49.6672L160.109 46.0486L155.224 44.8726L157.848 49.6672Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.1 44.4203L160.109 46.0486L167.075 47.7674L162.1 44.4203Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.54 54.0999L146.63 56.1806L144.549 53.6476L146.54 54.0999Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.278 50.8432L144.549 53.6476L147.173 50.3004L144.278 50.8432Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.293 56.2711L146.63 56.3615L144.549 53.6476L141.293 56.2711Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.835 50.8432L144.549 53.6476L144.278 50.8432H141.835Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.872 56.7234L150.701 61.6989L149.887 56.9043L152.872 56.7234Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.52 55.3664L152.872 56.7234L153.867 54.0095L150.52 55.3664Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.963 89.6523L154.501 89.5619L154.862 87.9335L152.963 89.6523Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.596 86.1242L154.5 89.5619L154.862 87.9335L153.596 86.1242Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.495 83.0485L155.767 84.6768L153.596 86.1242L155.495 83.0485Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.862 87.9335L155.767 84.6768L153.596 86.1242L154.862 87.9335Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.987 90.0142L152.963 89.6523L150.611 88.8381L147.987 90.0142Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.791 86.3956L150.61 88.8382L153.596 86.1242L150.791 86.3956Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.239 82.3248L153.596 86.1243L155.495 83.0485L152.239 82.3248Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.505 80.6059L152.239 82.3247L155.495 83.0485L153.505 80.6059Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.515 78.8871L153.505 80.6059L150.249 79.3394L151.515 78.8871Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.097 85.0387V87.8431L145.726 88.8382L144.097 85.0387Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.987 90.0142L145.726 88.8382L148.349 85.8528L147.987 90.0142Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.792 86.3956L148.349 85.8528L145.726 88.8382L150.792 86.3956Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.239 82.3248L150.792 86.3957L153.596 86.1243L152.239 82.3248Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.439 74.6353L149.796 77.2588L146.268 75.4495L148.439 74.6353Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.249 79.3394L149.796 77.2588L151.515 78.8871L150.249 79.3394Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.288 77.5302L143.645 81.6915L145.002 80.7869L142.288 77.5302Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.097 85.0387L143.645 81.6915L145.002 80.7869L144.097 85.0387Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.349 85.8528L144.097 85.0387L147.535 82.8675L148.349 85.8528Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.434 66.403L147.535 71.3786L147.354 66.1317L149.434 66.403Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.701 61.6989L147.263 64.3224L149.434 66.4031L150.701 61.6989Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.53 61.0657L149.434 66.4031L150.701 61.6989L148.53 61.0657Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.52 55.3664L150.701 61.6989L152.872 56.7234L150.52 55.3664Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.63 56.3615L149.887 56.9043L148.53 61.0657L146.63 56.3615Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.173 50.3004L150.158 49.5767L145.816 47.1342L147.173 50.3004Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.535 71.3786L148.439 74.6353L146.268 75.4495L147.535 71.3786Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.107 75.2686L142.288 77.5302L143.735 75.9923L142.107 75.2686Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.249 79.3394L152.239 82.3247L151.515 78.8871L150.249 79.3394Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.496 83.0485L153.505 80.6059L153.596 86.1242L155.496 83.0485Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.192 47.7674L140.84 46.9532L142.016 47.8579L143.192 47.7674Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.921 48.7626L142.016 47.8579L143.192 47.7675L142.921 48.7626Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.031 48.1293L140.84 46.9533L137.674 46.7723L139.031 48.1293Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.442 52.0193L124.104 53.8286L126.728 50.21L129.442 52.0193Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.403 52.8334L134.417 52.2002L139.031 48.1293L137.403 52.8334Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.848 56.2711L117.682 53.1953L120.396 52.743L120.848 56.2711Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.105 53.8286L120.848 56.2711L124.919 56.9948L124.105 53.8286Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.728 50.21L124.919 56.9948L124.104 53.8286L126.728 50.21Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.227 29.4937L173.679 31.3934L174.674 29.4032L173.227 29.4937Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.689 32.7504L170.694 33.2932L172.412 33.9264L171.689 32.7504Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.679 31.3935L172.412 33.9265L171.689 32.7504L173.679 31.3935Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.085 26.4179L167.165 26.5988L167.799 27.7748L165.085 26.4179Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.73 49.0339L183.087 52.562L186.887 52.2906L181.73 49.0339Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.349 52.9239L186.887 52.2906L181.73 49.0339L185.349 52.9239Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.615 55.5474L186.887 52.2906L188.334 56.9948L186.615 55.5474Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.073 61.7894L188.334 56.9948L186.615 55.5474L186.073 61.7894Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.901 56.0902L185.349 52.9239L186.615 55.5474L183.901 56.0902Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.026 44.0584L181.73 49.0339V47.3151L177.026 44.0584Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.197 52.6525L183.087 52.562L181.73 49.0339L179.197 52.6525Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.217 46.32L172.774 46.0486L177.026 44.0584L175.217 46.32Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.73 47.3151L175.217 46.32L177.026 44.0584L181.73 47.3151Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.534 65.1365L183.177 63.5987L186.072 61.7894L184.534 65.1365Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.825 70.2025L184.534 65.1366L183.177 63.5987L180.825 70.2025Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.041 67.76L180.826 70.2025L179.469 67.4886L174.041 67.76Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.29 51.7479L160.833 53.5572L165.356 51.567L160.29 51.7479Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.075 47.7675L157.848 49.6672L160.109 46.0486L167.075 47.7675Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.161 51.5669H165.356L168.07 50.3909L168.161 51.5669Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.774 46.0486L168.07 50.3909L179.197 52.6525L172.774 46.0486Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.217 46.32L168.07 50.3909L172.774 46.0486L175.217 46.32Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.075 47.7674L168.07 50.3909L170.965 44.4203L167.075 47.7674Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.498 76.8064L175.488 71.1072L179.65 72.0118L173.498 76.8064Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.488 71.1072L179.469 67.4886L174.041 67.76L175.488 71.1072Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.825 70.2025L179.649 72.0118L175.488 71.1072L180.825 70.2025Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.534 65.1366L179.469 67.4886L180.825 70.2026L184.534 65.1366Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.887 52.2906L190.505 53.8285V55.9092L186.887 52.2906Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.334 56.9948L190.505 53.8286V55.9092L188.334 56.9948Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.767 59.3469L193.31 56.633L190.505 55.9092L192.767 59.3469Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.505 53.8286L193.31 56.6329L192.767 59.3469L190.505 53.8286Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.495 63.2368L194.124 65.4984L192.767 59.3468L192.495 63.2368Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.324 62.3322L191.048 59.6182L192.767 59.3468L190.324 62.3322Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.495 63.2369L191.048 59.6183L190.324 62.3322L192.495 63.2369Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.505 55.9092L191.048 59.6183L192.767 59.3469L190.505 55.9092Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.772 87.9335L190.596 85.5814L195.119 87.3907L191.772 87.9335Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.848 89.381L191.772 87.9335L195.119 87.3907L194.848 89.381Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.833 92.5472L194.847 89.381L202.265 89.0191L197.833 92.5472Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.256 90.557L197.833 92.5472L194.847 89.381L204.256 90.557Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.371 88.2954L197.833 92.5472L194.847 89.381L199.371 88.2954Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.415 82.6866L190.596 85.5815L192.043 85.491L190.415 82.6866Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.163 77.6206L188.786 73.5497L190.415 82.6866L186.163 77.6206Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.862 75.4495L186.163 77.6206L188.786 73.5497L191.862 75.4495Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.29 84.3149L195.119 87.3907L199.371 88.2954L197.29 84.3149Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.713 87.5717L202.265 89.0191L199.371 88.2954L203.713 87.5717Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.256 90.557L202.266 89.0191L203.713 87.4812L204.256 90.557Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.789 89.8333L206.427 88.4763L204.256 90.557L206.789 89.8333Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.449 93.7232L216.287 96.799L213.845 93.3614L220.449 93.7232Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.072 91.2807L222.53 89.2905L220.992 89.8333L223.072 91.2807Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.287 92.4567V96.799L220.449 93.7232L216.287 92.4567Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.992 89.8333L220.449 93.7232L223.072 91.2807L220.992 89.8333Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.529 89.2905L220.449 93.7232L223.072 91.2807L222.529 89.2905Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.449 81.8724L222.529 82.1438L222.71 85.4005L220.449 81.8724Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.53 89.2905L222.711 85.4005L220.992 89.8332L222.53 89.2905Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.916 82.8675L222.529 82.1438L220.449 81.8724L217.916 82.8675Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.754 81.8724H220.449L217.916 82.8675L213.754 81.8724Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.246 85.4005L207.512 83.6817L208.236 87.5717L206.246 85.4005Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.427 88.4763L203.713 87.4812L206.246 85.4005L206.427 88.4763Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.664 84.6768L207.512 83.6817L213.754 81.8724L213.664 84.6768Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.449 125.205L184.263 124.21L181.64 124.391L183.449 125.205Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.625 113.173L187.068 116.792L184.535 117.787L184.625 113.173Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.982 118.963L184.625 113.173L187.068 116.792L185.982 118.963Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.892 121.043V119.053L184.535 117.787L185.892 121.043Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.263 124.21L185.892 121.043L183.901 122.491L184.263 124.21Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.625 113.173L181.006 107.383L177.75 107.112L184.625 113.173Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.936 103.222L181.006 107.383L177.75 107.112L176.936 103.222Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.535 117.787L181.368 115.706L184.625 113.173L184.535 117.787Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.006 107.383L179.288 112.992L177.75 107.112L181.006 107.383Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.975 131.537L175.398 128.914H172.141L168.975 131.537Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.283 127.828L183.449 125.205L181.64 124.391L180.283 127.828Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.398 128.914L177.388 125.114L180.283 127.828L175.398 128.914Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.911 121.948L183.901 122.491L181.64 124.391L181.911 121.948Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.535 117.787L183.901 122.491L181.911 121.948L184.535 117.787Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.187 118.058L187.067 116.792L181.368 115.706L181.187 118.058Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.911 121.948L178.021 118.239L181.187 118.058L181.911 121.948Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.388 125.114L181.187 118.058L181.821 121.858L177.388 125.114Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.42 120.772L162.461 122.129L158.752 124.572L152.42 120.772Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.175 124.391L162.461 122.129L161.647 125.657L165.175 124.391Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.09 131.899L168.975 131.537L166.713 130.452L164.09 131.899Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.197 99.9652L140.659 104.941L143.826 105.303L142.197 99.9652Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.767 113.535L157.667 114.078L156.038 115.163L155.767 113.535Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.882 109.916L147.896 109.283L151.967 112.087L150.882 109.916Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.038 115.163L151.968 112.087L155.767 113.535L156.038 115.163Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 116.882L157.667 114.078L156.038 115.163L160.109 116.882Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.96 97.8846L176.935 103.222L172.593 102.951L171.96 97.8846Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.276 93.3614L159.838 94.266L166.17 94.6279L163.276 93.3614Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.96 97.8846L166.17 94.6279L168.975 100.418L171.96 97.8846Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.287 112.992L181.368 115.706L178.021 118.239L179.287 112.992Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.522 103.946L168.975 100.418L172.593 102.951L168.522 103.946Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.809 118.51L162.461 122.129L160.109 116.882L165.809 118.51Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.217 91.4616L136.77 96.7085L142.197 99.9652L138.217 91.4616Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.659 104.941L136.77 96.7086L142.197 99.9653L140.659 104.941Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.268 75.4495L143.916 75.0876L143.735 75.9923L146.268 75.4495Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.107 75.2686L142.559 74.183L143.916 75.0876L142.107 75.2686Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.564 72.3737L142.559 74.183L142.107 75.2686L141.564 72.3737Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.906 71.7405L148.439 74.6353L147.535 71.3786L145.906 71.7405Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.479 64.8652L140.569 60.8847L142.107 63.0559L140.479 64.8652Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.293 56.2711L140.569 60.8848L144.73 59.0755L141.293 56.2711Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.263 64.3224L144.73 59.0755L148.53 61.0657L147.263 64.3224Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.887 56.9043L144.73 59.0755L146.63 56.3615L149.887 56.9043Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.637 105.936L166.442 111.545L168.523 103.946L163.637 105.936Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.104 107.836L159.114 104.036L163.637 105.936L161.104 107.836Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.197 99.9652L143.826 105.303L147.173 103.131L142.197 99.9652Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.882 109.916L155.767 113.535L156.491 107.564L150.882 109.916Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.104 107.836L156.491 107.564L159.114 104.036L161.104 107.836Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 116.882L158.752 124.572L162.461 122.129L160.109 116.882Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.104 107.836L157.667 114.078L156.491 107.564L161.104 107.836Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.109 46.0486L160.29 51.7479L165.356 51.567L160.109 46.0486Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.156 56.0902L168.161 51.567L160.833 53.5572L169.156 56.0902Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.197 52.6525L169.156 56.0901L175.217 46.32L179.197 52.6525Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.3 91.3712L158.933 94.5374L159.838 94.266L158.3 91.3712Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.28 87.2098L161.195 87.3907L158.3 91.3712L162.28 87.2098Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.999 85.4005L162.281 87.2098L163.276 93.3614L163.999 85.4005Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.64 124.21L148.982 124.662L152.42 120.772L144.64 124.21Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.298 130.542L144.64 124.21L144.73 129.095L140.298 130.542Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.95 128.642L144.73 129.095L140.298 130.542L136.95 128.642Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.982 124.662L144.73 129.095L147.716 128.914L148.982 124.662Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.752 124.572L152.42 120.772L148.982 124.662L158.752 124.572Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.657 130.542L157.938 132.623L164.09 131.899L159.657 130.542Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.647 125.657L159.657 130.542L158.752 124.572L161.647 125.657Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.891 49.5768L186.887 52.2907L185.349 52.9239L185.891 49.5768Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.896 48.1293L181.73 49.0339L185.892 49.5767L184.896 48.1293Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.263 45.7772L181.73 47.3151L184.896 48.1293L184.263 45.7772Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.158 64.1415L188.334 56.9948L186.073 61.7894L187.158 64.1415Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.534 65.1366L187.158 64.1415L183.177 63.5987L184.534 65.1366Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.087 69.4788L179.469 67.4886L183.178 63.5987L183.087 69.4788Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.872 56.7234L169.156 56.0902L174.131 67.941L152.872 56.7234Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.999 85.4006L173.498 76.8065L186.163 77.6206L163.999 85.4006Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.156 56.0902L163.999 85.4006L174.041 67.7601L169.156 56.0902Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.725 108.469L144.64 124.21L152.42 120.772L145.725 108.469Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.3 91.3712L142.288 77.5302L138.217 91.4616L158.3 91.3712Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.486 140.041L111.892 143.117L115.872 135.699L120.486 140.041Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.205 133.799L111.892 143.117L115.872 135.699L122.205 133.799Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.647 134.704L121.21 136.965L122.205 133.799L124.647 134.704Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.872 135.699L121.21 136.965L120.486 140.041L115.872 135.699Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.469 149.901L106.193 152.254L109.268 147.73L105.469 149.901Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.449 139.95L111.892 143.117L109.088 148.002L109.449 139.95Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.449 139.95L120.486 140.041L111.892 143.117L109.449 139.95Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.425 134.975L115.872 135.699L109.449 139.95L114.425 134.975Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.268 162.295L106.374 158.676L109.63 159.762L109.268 162.295Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.77 96.7086L136.95 128.642L122.205 133.799L136.77 96.7086Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.919 56.9948L142.288 77.892L82.9434 89.5619L124.919 56.9948Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.848 56.2711L142.288 77.892L77.2441 55.8188L120.848 56.2711Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.442 52.0193L141.293 56.2711L124.919 56.9948L129.442 52.0193Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.061 193.867L178.021 118.239L136.951 128.642L133.061 193.867Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.205 133.799L82.9434 89.5619L-11.6821 82.4152L122.205 133.799Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2441 55.8188L82.9433 89.5619L-19.0098 179.755L77.2441 55.8188Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.919 56.9948L143.464 39.3543L169.156 56.0902L124.919 56.9948Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.571 37.9973L143.464 39.3543L169.156 56.0901L195.571 37.9973Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.833 92.5472L177.75 107.112L163.999 85.4005L197.833 92.5472Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.193 152.254L42.5059 188.439L82.9433 89.5619L106.193 152.254Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.77 96.7086L82.9434 89.5619L124.919 56.9948L136.77 96.7086Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.287 96.799L197.833 92.5472L173.407 141.579L216.287 96.799Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.205 133.799L173.407 141.579L106.283 184.64L122.205 133.799Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.407 141.579L172.322 186.901",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.193 152.254L122.205 133.799L172.322 186.901L106.193 152.254Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.589 96.799L164.09 85.3101",
    stroke: "#00283F",
    strokeWidth: 0.3167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.246 56.1806L82.9434 89.5619",
    stroke: "#00283F",
    strokeWidth: 0.3167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2442 55.9092L-17.3813 89.7428",
    stroke: "#00283F",
    strokeWidth: 0.3167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.6821 82.4152L106.193 152.254L82.9434 89.5619L-11.6821 82.4152Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.193 152.254L133.06 193.867L42.5059 188.439L106.193 152.254Z",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.288 77.5302L163.909 85.491",
    stroke: "#00283F",
    strokeWidth: 0.3167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.373 39.3543L164.09 85.3101",
    stroke: "#00283F",
    strokeWidth: 0.3167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.217 91.4616L77.2441 55.4569",
    stroke: "#00283F",
    strokeWidth: 0.3167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1147 -17.9095L77.244 55.4569",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.464 39.3543L142.378 77.3493",
    stroke: "#00283F",
    strokeWidth: 0.3167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.95 67.8505L77.2441 55.9092",
    stroke: "#00283F",
    strokeWidth: 0.3167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.892 142.755L124.919 56.9948",
    stroke: "#00283F",
    strokeWidth: 0.3167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.09 85.491L152.42 120.772",
    stroke: "#00283F",
    strokeWidth: 0.3167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.347 138.051L136.77 96.8895",
    stroke: "#00283F",
    strokeWidth: 0.3167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.205 133.799L197.381 92.5472",
    stroke: "#00283F",
    strokeWidth: 0.3167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.407 141.579L152.42 120.772",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.42 120.772L130.347 138.051",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.347 138.051L106.193 152.254",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7649 119.958L145.906 108.469",
    stroke: "#00283F",
    strokeWidth: 0.3167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7649 119.958L42.8677 188.439",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.938 132.623L133.513 135.608",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.726 108.559L158.843 94.5374",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.217 91.4616L159.114 104.036",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.021 118.239L166.442 111.545",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.442 111.545L165.718 118.691",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.713 130.452L165.175 124.391",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.175 124.391L172.141 128.914",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.809 118.51L165.175 124.391",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.175 124.391L177.478 125.114",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.478 125.114L165.809 118.51",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.75 107.112L165.718 118.42",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.193 152.254L-19.0098 179.393",
    stroke: "#00283F",
    strokeWidth: 0.3167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.765 119.958L-11.6821 82.4152",
    stroke: "#00283F",
    strokeWidth: 0.3167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7649 119.958L-19.0098 179.393",
    stroke: "#00283F",
    strokeWidth: 0.3167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2441 55.9092L63.7649 119.958",
    stroke: "#00283F",
    strokeWidth: 0.3167,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.862 75.4495L194.124 65.4984",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.862 75.4495L191.772 87.9335",
    stroke: "#00283F",
    strokeWidth: 0.1584,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M194.395 27.2321L196.838 30.4888L192.134 28.4986L194.395 27.2321Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M193.4 26.5988L191.138 26.5084L192.134 28.4986L193.4 26.5988Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M193.4 23.704L192.857 25.6037L190.777 23.704H193.4Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M190.867 21.0805L193.4 23.704H190.777L190.867 21.0805Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M193.4 26.5988L192.857 25.6037L192.134 28.4986L193.4 26.5988Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M193.4 23.704V26.5988L192.857 25.6037L193.4 23.704Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M194.395 27.2321L193.4 26.5988L195.933 30.8506L194.395 27.2321Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M191.138 26.5084L192.857 25.6037L190.777 23.704L191.138 26.5084Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M185.801 20.6282L186.525 18.9094L190.867 21.0805L185.801 20.6282Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M185.891 23.1612L190.867 21.0805L185.801 20.6282L185.891 23.1612Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M196.838 31.5744V30.4888L195.933 30.8507L196.838 31.5744Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M196.657 33.8359L196.838 31.5743L194.847 33.4741L196.657 33.8359Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M196.204 34.1073L196.838 31.5743L194.847 33.4741L196.204 34.1073Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M195.933 30.8506L195.209 31.5744L196.657 33.836L195.933 30.8506Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M197.109 36.4594L196.205 34.1074L195.752 36.5499L197.109 36.4594Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M197.471 37.9973L196.385 39.0829L196.114 38.2687L197.471 37.9973Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M195.752 36.5499L197.471 37.9973L197.109 36.4594L195.752 36.5499Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M194.757 36.4594L195.3 38.0878L195.752 36.5499L194.757 36.4594Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M193.129 40.078L195.933 39.4447L195.3 38.0878L193.129 40.078Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M196.385 39.0829L195.933 39.4447L196.114 38.2687L196.385 39.0829Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M191.772 32.5695L190.777 34.4692L194.033 34.2883L191.772 32.5695Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M194.847 33.4741L194.124 34.1978L196.204 34.1073L194.847 33.4741Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M191.591 35.5548L188.967 37.3641L191.862 38.5401L191.591 35.5548Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M195.3 38.0878L191.862 38.5401L194.757 36.4594L195.3 38.0878Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M194.033 34.2883L191.591 35.5548L194.757 36.4594L194.033 34.2883Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M191.772 32.5695L192.134 28.4986L195.209 31.5743L191.772 32.5695Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M187.52 28.6795L183.901 30.6697L188.063 30.8506L187.52 28.6795Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M185.892 23.1612L190.777 23.704L187.52 28.6795L185.892 23.1612Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M191.139 26.5084L185.892 23.1612L190.777 23.704L191.139 26.5084Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M183.268 18.9998L186.525 18.9094L185.801 20.6282L183.268 18.9998Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M173.95 25.0609L174.403 23.3421L174.674 25.7847L173.95 25.0609Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M177.84 20.2664L181.006 19.7236L179.468 21.0805L177.84 20.2664Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M183.268 18.9998L181.006 19.7236L183.72 21.2615L183.268 18.9998Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M185.801 20.6282L183.72 21.2614L186.525 18.9094L185.801 20.6282Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M177.84 20.2663L174.403 23.3421L178.202 22.347L177.84 20.2663Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M182.544 22.8898L183.72 21.2614L185.892 23.1612L182.544 22.8898Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M179.469 21.0805L183.72 21.2615L183.268 18.9998L179.469 21.0805Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M182.544 22.8898L182.816 24.3372L178.202 22.347L182.544 22.8898Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M179.469 21.0805L182.544 22.8898L181.006 19.7236L179.469 21.0805Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M178.202 22.347L179.469 21.0805L180.554 26.7797L178.202 22.347Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M182.816 24.3372L180.554 26.7798L186.434 29.2223L182.816 24.3372Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M185.801 23.1612L182.816 24.3372L183.72 21.2614L185.801 23.1612Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M174.312 29.5841L173.407 26.8702L174.674 25.7846L174.312 29.5841Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M173.95 25.0609L173.498 26.8702L174.674 25.7846L173.95 25.0609Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M178.202 22.347L177.569 23.8849L174.403 23.3421L178.202 22.347Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M176.845 25.7846L180.554 26.7797L177.569 23.8849L176.845 25.7846Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M174.674 25.7846H176.845L177.569 23.8849L174.674 25.7846Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M176.121 28.4081L175.669 30.0364L174.312 29.5841L176.121 28.4081Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M176.845 25.7846L176.121 28.4081L180.554 26.7797L176.845 25.7846Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M191.772 32.5695L188.063 30.8506L192.134 28.4986L191.772 32.5695Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M187.52 28.6795L192.133 28.4986L191.138 26.5084L187.52 28.6795Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M194.395 33.1122L194.033 34.2883L191.772 32.5695L194.395 33.1122Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M195.209 31.5743L194.395 33.1122L192.134 28.4986L195.209 31.5743Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M191.862 40.1685L193.129 40.078L191.862 38.5401V40.1685Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M187.068 41.6159L190.143 40.6208L188.786 38.8115L187.068 41.6159Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M191.862 38.5401L190.143 40.6208L191.862 40.1685V38.5401Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M188.786 38.8115L191.862 40.1685V38.5401L188.786 38.8115Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M187.068 41.6159L186.253 43.9679L182.635 43.4252L187.068 41.6159Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M190.777 34.4692L187.791 34.2883L188.063 30.8506L190.777 34.4692Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M180.554 26.7798L179.74 32.9313L175.669 30.0365L180.554 26.7798Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M183.901 30.6697L180.554 26.7798L175.669 30.0365L183.901 30.6697Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M186.434 29.2223L180.554 26.7798L185.801 23.1612L186.434 29.2223Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M190.867 21.0805L185.801 20.6282L190.777 23.704L190.867 21.0805Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M183.992 45.9581L186.253 43.9679L182.635 43.4251L183.992 45.9581Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M178.473 35.8262L179.74 32.9314L175.669 30.0365L178.473 35.8262Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M171.508 38.9924L174.403 41.9777L176.664 38.5401L171.508 38.9924Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M166.351 36.0976L169.246 37.0022L165.266 38.9924L166.351 36.0976Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M171.508 38.9924L169.246 37.0022L172.05 36.8213L171.508 38.9924Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M174.312 38.1783L172.051 36.8213L174.403 41.9777L174.312 38.1783Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M174.312 38.1782L178.473 35.8262L176.664 38.5401L174.312 38.1782Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M176.483 34.9216L179.74 32.9314L175.669 30.0365L176.483 34.9216Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M174.312 29.5842L176.483 34.9216L175.669 30.0365L174.312 29.5842Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M174.312 38.1782L176.483 34.9215L178.473 35.8262L174.312 38.1782Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M172.051 36.8213L178.473 35.8262L174.312 38.1782L172.051 36.8213Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M163.366 37.0022L166.351 36.0976L169.246 37.0022H163.366Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M161.285 38.9924L163.366 37.0022L165.266 38.9924H161.285Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M155.315 43.1538L157.305 40.8017L158.843 42.1587L155.315 43.1538Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M161.285 38.9924L157.305 40.8017L158.843 42.1586L161.285 38.9924Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M163.547 42.7014L165.266 38.9924L163.366 37.0022L163.547 42.7014Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M158.843 42.1586L165.266 38.9924H161.285L158.843 42.1586Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M141.474 51.0242L140.931 56.3616L143.916 50.9337L141.474 51.0242Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M142.831 47.9484L145.454 47.3151L141.474 51.0242L142.831 47.9484Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M143.916 50.9337L142.831 47.9484L145.454 47.3151L143.916 50.9337Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M149.706 45.144L145.454 47.3151L151.334 46.5009L149.706 45.144Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M155.315 43.1537L149.706 45.144L154.862 45.0535L155.315 43.1537Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M149.796 49.7577L151.334 46.5009L149.706 45.144L149.796 49.7577Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M154.862 45.0535L151.334 46.501L153.415 47.9484L154.862 45.0535Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M161.828 44.5107L158.843 42.1587L154.862 45.0535L161.828 44.5107Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M163.547 42.7014L158.843 42.1587L161.828 44.5107L163.547 42.7014Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M171.508 38.9924L166.623 43.9679L165.266 38.9924H171.508Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M174.403 41.9777L170.603 44.6012L171.508 38.9924L174.403 41.9777Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M172.412 46.2295L170.603 44.6012L174.403 41.9777L172.412 46.2295Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M176.755 44.1489L174.403 41.9777L176.664 38.5401L176.755 44.1489Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M163.547 42.7014L166.623 43.9679L161.828 44.5107L163.547 42.7014Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M157.486 49.8481L159.747 46.1391L154.862 45.0535L157.486 49.8481Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M143.916 50.9337L144.278 53.7381L146.811 50.4814L143.916 50.9337Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M141.474 51.0242L144.278 53.7381L143.916 50.9337L141.474 51.0242Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M152.601 89.7428L154.139 89.6523L154.501 88.1144L152.601 89.7428Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M153.324 86.3051L154.139 89.6523L154.5 88.1144L153.324 86.3051Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M155.134 83.1389L155.405 84.7672L153.324 86.3051L155.134 83.1389Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M154.5 88.1145L155.405 84.7673L153.324 86.3052L154.5 88.1145Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M147.625 90.1047L152.601 89.7428L150.249 89.0191L147.625 90.1047Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M150.429 86.486L150.249 89.019L153.324 86.3051L150.429 86.486Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M151.877 82.4152L153.324 86.3052L155.134 83.1389L151.877 82.4152Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M153.143 80.7869L151.877 82.4152L155.134 83.1389L153.143 80.7869Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M151.153 79.068L153.143 80.7868L149.887 79.5203L151.153 79.068Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M143.735 85.1291V88.024L145.363 88.9286L143.735 85.1291Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M147.625 90.1046L145.364 88.9286L147.987 86.0338L147.625 90.1046Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M150.43 86.4861L147.987 86.0338L145.364 88.9286L150.43 86.4861Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M151.877 82.4152L150.43 86.4861L153.325 86.3052L151.877 82.4152Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M148.077 74.7258L149.525 77.3492L145.906 75.6304L148.077 74.7258Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M149.887 79.5204L149.525 77.3492L151.153 79.068L149.887 79.5204Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M142.016 77.6206L143.373 81.8724L144.73 80.8773L142.016 77.6206Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M143.735 85.1291L143.373 81.8724L144.73 80.8773L143.735 85.1291Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M147.987 86.0338L143.735 85.1291L147.173 82.958L147.987 86.0338Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M146.811 50.4814L149.796 49.7577L145.454 47.3151L146.811 50.4814Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M147.173 71.5595L148.077 74.7257L145.906 75.6304L147.173 71.5595Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M141.745 75.359L142.017 77.6206L143.464 76.0827L141.745 75.359Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M149.887 79.5203L151.877 82.4152L151.153 79.068L149.887 79.5203Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M155.134 83.1389L153.144 80.7869L153.324 86.3052L155.134 83.1389Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M142.831 47.9483L140.479 47.0437L141.745 48.0388L142.831 47.9483Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M142.65 48.853L141.745 48.0388L142.831 47.9484L142.65 48.853Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M138.669 48.3103L140.479 47.0438L137.312 46.8628L138.669 48.3103Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M129.08 52.1097L123.743 54.0095L126.457 50.3004L129.08 52.1097Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M137.041 52.9239L134.056 52.3811L138.669 48.3102L137.041 52.9239Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M120.576 56.3615L117.41 53.2858L120.034 52.8334L120.576 56.3615Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M123.743 54.0095L120.576 56.3615L124.557 57.0852L123.743 54.0095Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M126.457 50.3004L124.557 57.0853L123.743 54.0095L126.457 50.3004Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M172.865 29.6746L173.408 31.4839L174.312 29.5842L172.865 29.6746Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M171.327 32.8409L170.332 33.3837L172.141 34.1074L171.327 32.8409Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M173.407 31.4839L172.141 34.1074L171.327 32.8409L173.407 31.4839Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M164.813 26.5084L166.894 26.6893L167.437 27.9558L164.813 26.5084Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M181.368 49.1244L182.725 52.743L186.525 52.4716L181.368 49.1244Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M184.987 53.0144L186.525 52.4716L181.368 49.1244L184.987 53.0144Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M186.253 55.6378L186.525 52.4716L188.063 57.1757L186.253 55.6378Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M185.71 61.8798L188.063 57.1757L186.253 55.6378L185.71 61.8798Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M183.54 56.1806L184.987 53.0143L186.253 55.6378L183.54 56.1806Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M176.755 44.1489L181.368 49.1244V47.4056L176.755 44.1489Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M178.926 52.8335L182.725 52.743L181.368 49.1244L178.926 52.8335Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M174.855 46.5009L172.412 46.2295L176.755 44.1489L174.855 46.5009Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M181.368 47.4056L174.855 46.5009L176.755 44.1489L181.368 47.4056Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M184.173 65.227L182.906 63.7796L185.711 61.8798L184.173 65.227Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M180.464 70.3835L184.173 65.227L182.906 63.7796L180.464 70.3835Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M173.679 67.8505L180.464 70.3835L179.197 67.5791L173.679 67.8505Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M173.136 76.8969L175.126 71.2881L179.378 72.1023L173.136 76.8969Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M175.126 71.2881L179.197 67.5791L173.679 67.8505L175.126 71.2881Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M180.464 70.3835L179.378 72.1023L175.126 71.2881L180.464 70.3835Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M184.173 65.227L179.197 67.5791L180.464 70.3834L184.173 65.227Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M186.525 52.4716L190.143 53.919V55.9997L186.525 52.4716Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M188.063 57.1757L190.143 53.919V55.9997L188.063 57.1757Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M192.405 59.4373L192.948 56.8138L190.143 55.9997L192.405 59.4373Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M190.143 53.919L192.948 56.8139L192.405 59.4373L190.143 53.919Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M192.134 63.3273L193.852 65.6793L192.405 59.4373L192.134 63.3273Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M189.962 62.5131L190.686 59.7087L192.405 59.4373L189.962 62.5131Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M192.134 63.3272L190.686 59.7087L189.962 62.5131L192.134 63.3272Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M190.143 55.9997L190.686 59.7087L192.405 59.4373L190.143 55.9997Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M191.41 88.024L190.234 85.7624L194.757 87.5717L191.41 88.024Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M194.576 89.5619L191.41 88.024L194.757 87.5717L194.576 89.5619Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M197.471 92.7281L194.576 89.5618L201.994 89.1095L197.471 92.7281Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M203.894 90.7379L197.471 92.7281L194.576 89.5619L203.894 90.7379Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M199.009 88.4763L197.471 92.7281L194.576 89.5619L199.009 88.4763Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M190.053 82.8675L190.234 85.7624L191.681 85.5814L190.053 82.8675Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M185.801 77.8015L188.424 73.6402L190.053 82.8675L185.801 77.8015Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M191.591 75.5399L185.801 77.8015L188.424 73.6402L191.591 75.5399Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M196.928 84.4959L194.757 87.5717L199.009 88.4763L196.928 84.4959Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M203.442 87.6621L201.994 89.1095L199.009 88.4763L203.442 87.6621Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M203.894 90.7379L201.994 89.1096L203.442 87.5717L203.894 90.7379Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M183.087 125.295L183.901 124.391L181.368 124.572L183.087 125.295Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M184.263 113.263L186.706 116.882L184.173 117.877L184.263 113.263Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M185.711 119.144L184.263 113.263L186.706 116.882L185.711 119.144Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M185.53 121.224L185.62 119.144L184.173 117.877L185.53 121.224Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M183.901 124.391L185.53 121.224L183.54 122.581L183.901 124.391Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M184.173 117.877L181.006 115.796L184.263 113.263L184.173 117.877Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M168.613 131.628L175.036 129.004H171.779L168.613 131.628Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M179.921 127.919L183.087 125.295L181.368 124.572L179.921 127.919Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M175.036 129.004L177.117 125.295L179.921 127.919L175.036 129.004Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M181.549 122.038L183.54 122.581L181.368 124.571L181.549 122.038Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M184.173 117.877L183.54 122.581L181.549 122.039L184.173 117.877Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M180.916 118.239L186.706 116.882L181.006 115.796L180.916 118.239Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M181.549 122.039L177.659 118.42L180.916 118.239L181.549 122.039Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M177.116 125.295L180.916 118.239L181.549 121.948L177.116 125.295Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M141.926 100.056L140.298 105.122L143.464 105.393L141.926 100.056Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M171.598 98.0655L176.574 103.403L172.231 103.131L171.598 98.0655Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M162.914 93.4518L159.566 94.447L165.899 94.8088L162.914 93.4518Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M178.926 113.083L181.006 115.796L177.659 118.42L178.926 113.083Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M140.298 105.122L136.408 96.8895L141.926 100.056L140.298 105.122Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M145.906 75.6304L143.554 75.1781L143.464 76.0827L145.906 75.6304Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M141.745 75.359L142.288 74.2734L143.554 75.1781L141.745 75.359Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M141.202 72.5546L142.288 74.2734L141.745 75.359L141.202 72.5546Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M145.544 71.9213L148.077 74.7257L147.173 71.5595L145.544 71.9213Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M140.117 64.9556L140.207 61.0657L141.745 63.2368L140.117 64.9556Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M140.931 56.3615L140.207 61.0657L144.459 59.1659L140.931 56.3615Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M157.938 91.4616L158.571 94.7183L159.566 94.4469L157.938 91.4616Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M162.009 87.3003L160.833 87.5717L157.938 91.4616L162.009 87.3003Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M163.637 85.491L162.009 87.3002L162.914 93.4518L163.637 85.491Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M161.285 125.838L159.295 130.633L158.481 124.662L161.285 125.838Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M185.53 49.7576L186.525 52.4716L184.987 53.0143L185.53 49.7576Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M184.535 48.3102L181.368 49.1244L185.53 49.7577L184.535 48.3102Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M183.992 45.9582L181.368 47.4056L184.535 48.3102L183.992 45.9582Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M186.796 64.3224L188.063 57.1757L185.71 61.8799L186.796 64.3224Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M184.173 65.227L186.796 64.3224L182.906 63.7796L184.173 65.227Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M182.725 69.6597L179.197 67.5791L182.906 63.7796L182.725 69.6597Z",
    fill: "#00283F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M124.285 134.794L120.848 137.056L121.843 133.889L124.285 134.794Z",
    fill: "#00283F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    width: 558,
    height: 194,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanceCrTlogo);
export default __webpack_public_path__ + "static/media/Advance CRT logo.c9d322e9b171ab15d2daac8a9458c9ba.svg";
export { ForwardRef as ReactComponent };